export default {
    brandSeo: {
        pageTitle: '{title} w Miral AI',
        toolDescription: 'W Miral AI: {description}',
        sectionTitle: '{title} z Miral AI',
        faqTitle: '{title} w Miral AI',
        toolFreeTrialCta: 'Wypróbuj to narzędzie bezpłatnie w Miral AI',
        toolProcessCta: '{action} bezpłatnie',
        imageFaqs: [
            { q: 'Czy mogę bezpłatnie wypróbować generowanie obrazów w Miral?', a: 'Tak. Zarejestruj się w Miral AI, odbierz darmowe kredyty i wypróbuj generowanie. Każdy wynik zużywa kredyty wymagane przez wybrany model.' },
            { q: 'Dlaczego warto tworzyć obrazy z Miral AI?', a: 'Miral AI łączy czołowe modele obrazów w jednym miejscu, aby porównywać funkcje i tworzyć bez przełączania platform.' }
        ],
        toolFaqs: [
            { q: 'Czy mogę bezpłatnie wypróbować to narzędzie Miral AI?', a: 'Tak. Zaloguj się do Miral AI, aby rozpocząć bezpłatną próbę. Dostęp zależy od limitów konta i nie oznacza nieograniczonego darmowego użycia.' },
            { q: 'Dlaczego korzystać z narzędzi kreatywnych Miral AI?', a: 'Miral AI łączy generowanie obrazów z praktyczną edycją, umożliwiając tworzenie, przetwarzanie i pobieranie wyników w jednym procesie.' }
        ]
    },
    common: {
        loading: 'Ładowanie...',
        error: 'Wystąpił błąd',
        success: 'Sukces',
        confirm: 'OK',
        prev: 'Wstecz',
        next: 'Dalej',
        optional: 'Opcjonalne',
        remove: 'Usuń',
        generate: 'Generuj',
        generating: 'Generowanie...',
        required: 'Wymagane',
        generateFailedContactSupport: 'Generowanie nie powiodło się. Spróbuj ponownie lub skontaktuj się z pomocą techniczną!',
        localMediaTransferFailed:
            'Niestabilność sieci przerwała transfer usługi lub interakcję. Generowanie zatrzymane. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.',
        errorDetails: 'Szczegóły błędu',
        tryAgainOrContactSupportTail: ' Spróbuj ponownie lub skontaktuj się z pomocą techniczną!',
        errorCategoryImageSizeInvalid: 'Rozmiar obrazu nie spełnia wymagań. Prześlij prawidłowy obraz',
        errorCategoryOutputEmptyOrSensitive: 'Generowanie zostało zablokowane przez reguły bezpieczeństwa lub nie dało wyniku. Dostosuj prompt/obraz referencyjny',
        errorCategoryUpstreamBusy: 'Usługa jest obecnie zajęta',
        errorCategoryAiNetworkError: 'Błąd połączenia sieciowego. Sprawdź sieć i spróbuj ponownie',
        errorCategoryAiTimeout: 'Żądanie AI przekroczyło limit czasu. Sieć może być niestabilna, spróbuj ponownie za chwilę',
        close: 'Zamknij',
        leaveConfirmTitle: 'Przypomnienie',
        leaveConfirmMessage: 'Twoje zadanie AI jest nadal generowane. Zmiana strony nie wpłynie na postęp. Możesz sprawdzić przetwarzane lub ukończone prace w [Moje - Moje prace].\nCzy na pewno chcesz opuścić stronę?',
        leaveConfirmConfirm: 'Opuść stronę',
        leaveConfirmCancel: 'Zostań tutaj',
        genDotIdle: 'Brak zadania generowania',
        genDotActive: 'Generowanie w toku, proszę nie zamykać przeglądarki',
        genRecoveryTimeout: 'Generowanie przekroczyło limit czasu lub strona została zamknięta',
        genRecoveryInterrupted: 'Generowanie przerwane przez odświeżenie strony'
    },
    api: {
        errors: {
            requestFailed: 'Żądanie nie powiodło się',
            badRequest: 'Nieprawidłowe żądanie',
            unauthorized: 'Brak autoryzacji, zaloguj się ponownie',
            forbidden: 'Zabronione',
            notFound: 'Nie znaleziono zasobu',
            serverError: 'Wewnętrzny błąd serwera',
            timeout: 'Limit czasu żądania, spróbuj ponownie',
            networkError: 'Błąd sieci, sprawdź połączenie',
            sessionExpired: 'Sesja wygasła, zaloguj się ponownie',
            operationFailed: 'Operacja nie powiodła się!'
        }
    },
    nav: {
        home: 'Strona główna',
        models: 'Modele AI',
        pricing: 'Cennik',
        faq: 'FAQ',
        login: 'Zaloguj',
        signup: 'Ulepsz',
        register: 'Zarejestruj',
        email: 'E-mail',
        logout: 'Wyloguj',
        help: 'Pomoc',
        profile: 'Profil',
        myWorks: 'Moje prace',
        username: 'Nazwa użytkownika',
        password: 'Hasło',
        confirmPassword: 'Potwierdź hasło',
        processing: 'Przetwarzanie...',
        haveAccount: 'Masz już konto?',
        noAccount: 'Nie masz konta?',
        orContinueWith: 'Lub kontynuuj z',
        loginFailed: 'Logowanie nie powiodło się, spróbuj ponownie',
        registerFailed: 'Rejestracja nie powiodła się, spróbuj ponownie',
        fillRequired: 'Wypełnij wszystkie wymagane pola',
        passwordMismatch: 'Hasła nie są zgodne',
        passwordTooShort: 'Hasło musi mieć co najmniej 6 znaków',
        googleNotLoaded: 'Usługa logowania Google nie załadowana, odśwież stronę',
        googleInitFailed: 'Inicjalizacja logowania Google nie powiodła się',
        googleUserInfoFailed: 'Nie można uzyskać informacji o użytkowniku',
        googleCancelled: 'Logowanie Google anulowane',
        codeLoginHint: 'Wpisz swój e-mail, wyślemy kod weryfikacyjny',
        verificationCode: 'Kod weryfikacyjny',
        sendCode: 'Wyślij kod',
        resendCode: 'Wyślij ponownie',
        verifyAndLogin: 'Zweryfikuj i zaloguj',
        enterEmail: 'Wpisz swój adres e-mail',
        invalidEmail: 'Wpisz prawidłowy adres e-mail',
        sendCodeFailed: 'Nie udało się wysłać kodu weryfikacyjnego, spróbuj ponownie',
        checkSpamFolder: 'Nie możesz znaleźć e-maila? Sprawdź folder spam/śmieci',
        enterValidCode: 'Wpisz 6-cyfrowy kod weryfikacyjny',
        verifyCodeFailed: 'Nieprawidłowy lub wygasły kod weryfikacyjny',
        googleLoginFailed: 'Logowanie Google nie powiodło się, spróbuj ponownie',
        registerHint: 'Rejestrując się, akceptujesz nasze',
        and: 'i',
        freeCreditsLabel: 'Darmowe kredyty:',
        freeCreditsDesc: 'Zdobądź darmowe kredyty po prostu się logując — płatność nie jest wymagana!',
        sidebar: {
            navigation: 'Nawigacja',
            home: 'Strona główna',
            inspiration: 'Inspiracja',
            allModels: 'Wszystkie modele AI',
            videoAI: 'Wideo AI',
            videoGenerator: 'Generator wideo',
            newModels: 'Nowe modele',
            otherModels: 'Inne modele',
            videoEnhance: 'Ulepszanie wideo',
            musicAI: 'Muzyka AI',
            musicGenerator: 'Muzyka AI',
            imageAI: 'Obrazy AI',
            imageGenerator: 'Generator obrazów',
            hotModels: 'Popularne modele',
            hotTools: 'Popularne narzędzia',
            history: 'Historia',
            upgrade: 'Ulepsz'
        }
    },
    footer: {
        brand: 'Miral',
        siteTitle: 'Miral - Platforma tworzenia obrazów, wideo i muzyki AI',
        desc: 'Wszystko w jednej platformie AI do tworzenia obrazów, wideo i muzyki.',
        fluxModels: 'Modele FLUX',
        aiImages: 'Obrazy AI',
        aiVideos: 'Wideo AI',
        aiMusic: 'Muzyka AI',
        product: 'Produkt',
        videoModels: 'Modele wideo AI',
        imageModels: 'Modele obrazu AI',
        musicModels: 'Modele muzyki AI',
        apps: 'Aplikacje',
        company: 'Firma',
        about: 'O nas',
        contact: 'Kontakt',
        blog: 'Blog',
        tools: 'Narzędzia',
        resources: 'Zasoby',
        allModels: 'Wszystkie modele AI',
        pricing: 'Cennik',
        trustSafety: 'Zaufanie i bezpieczeństwo',
        terms: 'Regulamin',
        privacy: 'Polityka prywatności',
        faq: 'FAQ',
        musicGenerator: 'Generator muzyki AI',
        copyright: '© 2025 Miral. Wszelkie prawa zastrzeżone.',
        langZh: '简体中文',
        langEn: 'English'
    },
    about: {
        tag: 'About Miral',
        title: 'About Us',
        subtitle: 'Create images, videos, and music with leading AI models in one place.',
        paragraphs: ['Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.', 'We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.', 'Learn more about our data practices on Trust & Safety, or contact support when you need help.']
    },
    contact: {
        tag: 'Support',
        title: 'Contact Us',
        subtitle: 'We will get back to your questions and feedback as soon as we can.',
        emailLabel: 'Support email',
        hint: 'Email us about billing, credits, or generation issues. We usually reply on business days.',
        cta: 'Send Email'
    },
    models: {
        image: {
            'nano-banana': {name: 'Nano Banana Pro', desc: 'Filmowy realizm z naturalną skórą, teksturą i szczegółami oświetlenia'},
            'nano-banana-31': {name: 'Nano Banana 3.1', desc: 'Generowanie obrazów w wielu rozdzielczościach z trybami v2.5 i v3.1'},
            'seedream-4': {name: 'Seedream 4', desc: 'Styl artystyczny'},
            'seedream-5': {name: 'Seedream 5', desc: 'Styl artystyczny'},
            'midjourney': {name: 'Midjourney', desc: 'Styl artystyczny'},
            'gpt-image-1': {name: 'GPT-Image-1', desc: 'Wielozadaniowy'},
            'gpt-image-1-5': {name: 'GPT-Image-1-5', desc: 'Wielozadaniowy'},
            'flux-pro-1-1-ultra': {name: 'Flux Pro 1.1 Ultra', desc: 'Wysokiej jakości tekst na obraz'},
            'flux-schnell': {name: 'Flux Schnell', desc: 'Szybki tekst na obraz'},
            'flux-kontext': {name: 'Flux Kontext', desc: 'Wysokiej jakości tekst na obraz i edycja'},
            'flux-2': {name: 'FLUX.2', desc: 'Tekst na obraz nowej generacji'},
            'qwen-image-2-0-pro': {name: 'Qwen Image 2.0 Pro', desc: 'Wysokorozdzielczy tekst na obraz z drobnymi szczegółami'},
            'z-image-turbo': {name: 'Z Image Turbo', desc: 'Wysokorozdzielcze generowanie obrazów z tekstu'},
            'sd-3-5': {name: 'Stable Diffusion 3.5', desc: 'Generowanie obrazów Stable Diffusion 3.5 z tekstu'}
        },
        video: {
            'pollodance': {name: 'Pollo Dance', desc: 'Kontrola ruchu, referencje i filmowe style'},
            'seegen': {name: 'SeeGen', desc: 'Tekst i obraz na wideo, wiele rozdzielczości'},
            'seedance': {name: 'Seedance AI', desc: 'Natywna synchronizacja audio-wideo'},
            'wan-2-5': {name: 'Wan 2.5', desc: 'Styl animacji'},
            'wan-2-6': {name: 'Wan 2.6', desc: 'Ulepszona jakość'},
            'veo-3-1': {name: 'Veo 3.1', desc: 'Wieloobrazowa referencja'},
            'veo-3-1-fast': {name: 'Veo 3.1 Fast', desc: 'Szybki, obsługuje klatkę końcową'},
            'kling-2-6': {name: 'Kling 2.6', desc: 'Synchronizacja ust'},
            'kling-3': {name: 'Kling 3', desc: 'Synchronizacja ust'},
            'sora-2': {name: 'Sora 2', desc: '4 s / 8 s / 12 s'},
            'kling-2-5': {name: 'Kling 2.5', desc: 'Standardowy'},
            'wan-2-2': {name: 'Wan 2.2', desc: 'Klasyczny'},
            'vidu-q3-pro': {name: 'Vidu Q3 Pro', desc: 'Tekst i obraz na wideo, wiele rozdzielczości'},
            'veo-3-0': {name: 'Veo 3.0', desc: 'Tekst/Obraz na wideo'},
            'hailuo-2-3': {name: 'Hailuo 2.3', desc: 'Kreatywne wideo'},
            'runway': {name: 'Runway', desc: 'Warsztat pracy'},
            'wan-animate': {name: 'Wan Animate', desc: 'Animacja postaci'}
        }
    },
    tools: {
        page: {
            tag: 'Narzędzia AI',
            title: 'Profesjonalne narzędzia AI',
            subtitle: 'Usuwanie znaków wodnych, renowacja zdjęć, skalowanie HD, ulepszanie wideo i inne profesjonalne narzędzia do obróbki.',
            allTools: 'Wszystkie narzędzia'
        },
        detail: {
            useNow: 'Użyj teraz',
            clickUpload: 'Kliknij lub przeciągnij, aby przesłać ',
            support: 'Obsługuje',
            reupload: 'Prześlij ponownie',
            scale: 'Skala',
            process: 'Przetwórz',
            processing: 'Przetwarzanie...',
            before: 'Przed',
            after: 'Po',
            download: 'Pobierz wynik',
            processNew: 'Przetwórz nowy plik',
            howToUse: 'Jak używać',
            moreTools: 'Więcej narzędzi',
            notFound: 'Narzędzie nie znalezione',
            backToList: 'Powrót do narzędzi',
            loginRequired: 'Wymagane logowanie',
            loginRequiredDesc: 'Zaloguj się, aby użyć tego narzędzia',
            loginNow: 'Zaloguj się teraz',
            demo: 'Demo',
            uploadOriginalFailed: 'Nie udało się przesłać oryginalnego obrazu, spróbuj ponownie'
        },
        steps: {
            upload: {
                title: 'Prześlij plik',
                desc: 'Wybierz lub przeciągnij i upuść plik obrazu lub wideo, który chcesz przetworzyć.'
            },
            adjust: {
                title: 'Dostosuj ustawienia',
                desc: 'Skonfiguruj parametry przetwarzania, takie jak współczynnik skali i format wyjściowy.'
            },
            process: {
                title: 'Przetwarzanie jednym kliknięciem',
                desc: 'AI przetwarza automatycznie, zazwyczaj zajmuje to od kilku sekund do minut.'
            },
            download: {title: 'Pobierz wynik', desc: 'Podgląd wyniku i pobranie wysokiej jakości pliku wyjściowego.'}
        },
        fileTypes: {
            image: 'Obraz',
            video: 'Wideo'
        },
        imageEnhancer: {
            name: 'Poprawa jakości obrazu',
            desc: 'Skaluj obrazy do rozdzielczości 4K z ulepszonymi szczegółami.',
            fullDesc: 'Skaluj obrazy do rozdzielczości 4K z ulepszonymi szczegółami. Wykorzystuje zaawansowane algorytmy AI do poprawy szczegółów, sprawiając, że rozmyte obrazy stają się ostre i wyraźne.'
        },
        'doc-crop-enhance': {
            name: 'Kadrowanie i prostowanie obrazu',
            desc: 'Kadruj krawędzie i koryguj zniekształcenia dokumentów za pomocą AI.',
            fullDesc: 'Kadrowanie, prostowanie i poprawa obrazów. Usuwanie tła na krawędziach, korygowanie zniekształceń oraz poprawa w wielu trybach, w tym rozjaśnianie, wyostrzanie, czarno-białe, skala szarości i usuwanie cieni.',
            enhanceMode: 'Tryb poprawy',
            enhanceModes: {
                disabled: 'Wyłączony',
                brighten: 'Rozjaśnienie',
                sharpen: 'Poprawa i wyostrzenie',
                blackWhite: 'Czarno-białe',
                grayscale: 'Skala szarości',
                deshadow: 'Usuwanie cieni',
                bitmap: 'Bitmapa'
            },
            cropImage: 'Kadruj krawędzie',
            dewarpImage: 'Prostuj',
            notImageFile: 'Prześlij prawidłowy plik obrazu',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB',
            noImageInResponse: 'Przetwarzanie nie powiodło się, spróbuj ponownie',
            downloadName: 'doc-crop-enhanced.png',
      "featuresKicker": "ULEPSZENIE SKANOWANIA DOKUMENTÓW",
      "featuresTitle": "Zamień zdjęcia dokumentów w czyste, odpowiednio wyrównane skany",
      "featuresIntro": "Obsługuj krawędzie dokumentów, przekrzywienia, perspektywę, zakrzywione strony, cienie i wyrazistość tekstu w przypadku typowych potrzeb związanych z przechwytywaniem i ulepszaniem skanowania na urządzeniach mobilnych.",
      "features": [
        {
          "title": "Automatycznie wykrywaj i przycinaj krawędzie dokumentu",
          "desc": "Znajdź granicę między papierem a tłem, a następnie usuń biurka, cienie na krawędziach i niepowiązane obszary, aby uzyskać czystszą stronę.",
          "cta": "Przytnij dokument za darmo"
        },
        {
          "title": "Wyprostuj przekrzywione dokumenty i popraw perspektywę",
          "desc": "Napraw zniekształcenia trapezowe, przechylone strony i proporcje spowodowane przez zdjęcia umów, formularzy i dokumentów testowych wykonane pod kątem.",
          "cta": "Popraw zdjęcie dokumentu"
        },
        {
          "title": "Dewarp zakrzywione strony i zeskanowane dokumenty",
          "desc": "Popraw zniekształcenia w pobliżu opraw książek, zwiniętego papieru i złożonych stron, aby ułatwić czytanie zdjęć z podręczników i książek.",
          "cta": "Usuń zniekształcenia zakrzywionego dokumentu"
        },
        {
          "title": "Usuń cienie ze skanów dokumentów",
          "desc": "Zmniejsz cienie powodowane przez telefony, palce, grzbiety książek i nierówne oświetlenie, aby uzyskać czystsze paragony, arkusze kalkulacyjne i zeskanowane strony.",
          "cta": "Usuń cienie dokumentu"
        },
        {
          "title": "Rozjaśnij dokumenty i wyostrz tekst",
          "desc": "Popraw jasność i krawędzie drukowanego tekstu w dokumentach o niskim kontraście, aby ułatwić czytanie, drukowanie i organizację.",
          "cta": "Wyostrz zeskanowany tekst"
        },
        {
          "title": "Twórz skany czarno-białe, w skali szarości lub bitmapowe",
          "desc": "Konwertuj kolorowe zdjęcia dokumentów na obrazy czarno-białe, w skali szarości lub z ulepszoną mapą bitową w celu drukowania i archiwizowania.",
          "cta": "Popraw obraz dokumentu"
        }
      ],
      "useCasesKicker": "Typowe przypadki użycia",
      "useCasesTitle": "Które obrazy dokumentów można przyciąć i ulepszyć?",
      "useCasesIntro": "Przeznaczony do pojedynczych obrazów dokumentów zarejestrowanych telefonem lub skanerem z nierównymi ramkami, cieniami, zniekształceniami lub niewyraźnym tekstem.",
      "useCases": [
        {
          "title": "Zdjęcie telefonu do zeskanowania",
          "desc": "Usuń tło biurka i popraw kąt kamery, aby zdjęcia z telefonu wyglądały bardziej jak skany."
        },
        {
          "title": "Umowy i formularze",
          "desc": "Przytnij kontrakty, aplikacje i formularze, aby przywrócić czyste krawędzie i proporcje strony."
        },
        {
          "title": "Paragony i faktury",
          "desc": "Zredukuj cienie i wyostrz blady drukowany tekst, aby zapewnić wyraźniejsze przeglądanie i archiwizację."
        },
        {
          "title": "Zakrzywione strony książki",
          "desc": "Prawidłowa krzywizna w pobliżu opraw podręczników, książek i zeszytów ćwiczeń."
        },
        {
          "title": "Arkusze testowe i arkusze ćwiczeń",
          "desc": "Wyprostuj arkusze testowe, usuń cienie i wyostrz wydrukowany tekst w celu ponownego użycia lub wydrukowania."
        },
        {
          "title": "Archiwa czarno-białe",
          "desc": "Konwertuj zdjęcia dokumentów na spójne style skanowania czarno-białego lub w skali szarości."
        }
      ],
      "faqTitle": "Często zadawane pytania dotyczące kadrowania i poprawiania dokumentów AI",
      "faqs": [
        {
          "q": "Na czym polega przycinanie i korygowanie dokumentów AI?",
          "a": "Wykrywa obszar dokumentu, usuwa otaczające go tło i może korygować przekrzywienie, perspektywę lub zniekształcenie zakrzywionej strony w zależności od ustawień."
        },
        {
          "q": "Jak automatycznie przyciąć zeskanowane obrazy dokumentów online?",
          "a": "Włącz przycinanie krawędzi, a następnie prześlij zeskanowany obraz dokumentu. Narzędzie próbuje wykryć granicę papieru i usunąć obszar poza dokumentem."
        },
        {
          "q": "Czy mogę przetrzeć zeskanowany dokument online?",
          "a": "Tak. Użyj prostowania w przypadku skanu pod kątem i korekcji perspektywy w przypadku zdjęcia zrobionego telefonem pod kątem. Używaj usuwania zniekształceń tylko wtedy, gdy sama strona jest zakrzywiona."
        },
        {
          "q": "Jaka jest różnica między trybami usuwania cienia i wyostrzania?",
          "a": "Deshadow poprawia nierównomierne oświetlenie strony, a wyostrzanie wzmacnia krawędzie tekstu i linii. Wybierz tryb odpowiadający problemowi źródłowemu."
        },
        {
          "q": "Jakiego narzędzia mogę użyć, aby ulepszyć zeskanowane dokumenty testowe, umowy i rachunki?",
          "a": "Użyj tego narzędzia do przycinania i ulepszania dokumentów, umożliwiającego usuwanie cienia w przypadku nierównomiernego oświetlenia, wyostrzanie w przypadku jasnego tekstu oraz skanowanie dokumentów w czerni i bieli lub w skali szarości podczas przygotowywania dokumentów do druku."
        },
        {
          "q": "Czy może zamienić zdjęcie zrobione telefonem w zeskanowany dokument?",
          "a": "Kadrowanie, poprawianie i ulepszanie może dać obraz przypominający skan, ale narzędzie nie generuje plików PDF ani nie wyodrębnia tekstu OCR."
        },
        {
          "q": "Jakie formaty obrazów i rozmiary plików są obsługiwane?",
          "a": "Obsługiwane są obrazy JPG, PNG i WebP, a maksymalny rozmiar pliku wynosi 15 MB."
        },
        {
          "q": "Czy przetwarzanie zmienia oryginalną treść dokumentu?",
          "a": "Narzędzie dostosowuje kadrowanie, geometrię, jasność i klarowność. Nie edytuje tekstu ani nie wyodrębnia zawartości dokumentu."
        }
      ],
      "education": {
        "kicker": "DOKUMENTY EDUKACYJNE",
        "title": "Zamień prace testowe, zadania domowe i zdjęcia z podręczników w wyraźne skany",
        "intro": "Automatycznie wykrywaj krawędzie dokumentów edukacyjnych i koryguj przekrzywienia, perspektywę, zakrzywione strony i cienie, aby zapewnić czystsze drukowanie, archiwizację i wykorzystanie w klasie.",
        "items": [
          {
            "title": "Przytnij zdjęcia testowe z papieru",
            "desc": "Wykryj krawędzie papieru testowego i usuń tło biurka, aby utworzyć czystą stronę z odpowiednią ramką."
          },
          {
            "title": "Popraw obrazy zadań domowych",
            "desc": "Napraw przekrzywienie i perspektywę zdjęć zadań domowych, aby ułatwić ich przeglądanie, przesyłanie i drukowanie."
          },
          {
            "title": "Strony podręcznika Dewarpa",
            "desc": "Popraw zakrzywione strony w pobliżu opraw książek i zredukuj cienie, które utrudniają czytanie drukowanych treści."
          },
          {
            "title": "Wyostrz arkusze ćwiczeń w klasie",
            "desc": "Rozjaśnij i wyostrz arkusze kalkulacyjne lub materiały do nauki dzięki czystym efektom skanowania czarno-białego lub w skali szarości."
          }
        ],
        "relatedTitle": "Chcesz usunąć odręczne odpowiedzi z arkusza testowego?",
        "relatedDesc": "Narzędzie to obsługuje kadrowanie, korekcję geometryczną i ulepszanie obrazu. Użyj gumki do pisma ręcznego, aby usunąć odpowiedzi uczniów, obliczenia lub adnotacje nauczyciela.",
        "relatedCta": "Otwórz gumkę do pisma ręcznego"
      }
        },
        'watermark-remover': {
            name: 'Usuwanie znaków wodnych',
            desc: 'Usuń znaki wodne z obrazu jednym kliknięciem za pomocą AI.',
            fullDesc: 'Usuwanie znaków wodnych za pomocą AI przy zachowaniu jakości obrazu. Obsługuje przetwarzanie wsadowe, automatyczne wykrywanie znaków wodnych i precyzyjne usuwanie bez uszkadzania oryginalnego obrazu.',
            audienceLabels: ['Sprzedawcy e-commerce', 'Zespoły marketingowe', 'Projektanci i twórcy', 'Sklepy modowe i odzieżowe'],
            audienceCases: [
                { title: 'Przygotuj materiały produktowe 3 razy szybciej', desc: 'Przed utworzeniem profesjonalnych zdjęć ofertowych oczyść autoryzowane fotografie produktów, obrazy od dostawców lub wersje robocze. Usuń rozpraszające oznaczenia, aby klienci skupili się na produkcie.' },
                { title: 'Ogranicz ręczne czyszczenie o 60% i szybciej twórz kampanie', desc: 'Przed przekształceniem własnych lub licencjonowanych materiałów w reklamy, banery i grafiki marki usuń niepotrzebne znaki wodne. Czyste zasoby szybciej wykorzystasz w kampaniach, premierach i plakatach produktowych.' },
                { title: 'Szybciej zmieniaj czyste obrazy w nowe koncepcje', desc: 'Odkrywaj nowe kierunki projektowe na podstawie oczyszczonych obrazów źródłowych bez budowania wszystkiego od zera. Używaj wersji bez znaków wodnych jako odniesienia do szkiców AI, concept artu lub grafik plakatowych.' },
                { title: 'Odśwież katalog bez ponownej sesji zdjęciowej', desc: 'Przed przygotowaniem katalogu, sezonowej premiery lub wizualizacji wirtualnej przymierzalni AI oczyść autoryzowane zdjęcia odzieży, aby wyeksponować krój, tkaninę i detale produktu.' }
            ],
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'watermark-removed.png',
      "aiRepair": "Usuwanie znaku wodnego",
      "uploadLabel": "Prześlij obraz",
      "uploadHint": "Obsługuje obrazy JPG, PNG lub WebP o rozmiarze do 15 MB.",
      "featuresKicker": "Szybki i dokładny",
      "featuresTitle": "Usuń różne znaki wodne ze zdjęć online",
      "featuresIntro": "Prześlij obraz w formacie JPG, PNG lub WebP i pozwól sztucznej inteligencji wykryć obszary znaku wodnego i zrekonstruować tło bez ręcznego szczotkowania.",
      "features": [
        {
          "title": "Wyczyść znaki wodne w pełnym obrazie",
          "desc": "Usuń powtarzający się półprzezroczysty tekst lub znaki wodne ze wzorami, które pokrywają cały obraz, aby uzyskać czystszy efekt.",
          "cta": "Wypróbuj bezpłatnie narzędzie do usuwania znaku wodnego AI"
        },
        {
          "title": "Usuń znaczniki czasu i daty",
          "desc": "Usuń daty, znaczniki czasu i ślady aparatu z rogów zdjęć, rekonstruując jednocześnie tło za nimi.",
          "cta": "Usuń znaki wodne obrazu online"
        },
        {
          "title": "Usuń logo marki",
          "desc": "Usuń logo marki, plakietki narożne i znaki promocyjne ze zdjęć, które możesz edytować.",
          "cta": "Usuń teraz zdjęcia znaków wodnych"
        },
        {
          "title": "Wyczyść tekst i znaki robocze",
          "desc": "Usuń nakładki tekstowe z podglądów, wersji roboczych projektów i zdjęć, aby stworzyć czystszą treść wizualną.",
          "cta": "Wypróbuj teraz narzędzie do usuwania znaku wodnego"
        }
      ],
      "useCasesKicker": "Przypadki użycia",
      "useCasesTitle": "Co może wyczyścić narzędzie do usuwania znaków wodnych obrazu AI?",
      "useCases": [
        {
          "title": "Usuwanie znaku wodnego ze zdjęć produktów",
          "desc": "Usuń tekst, logo i znaki promocyjne ze zdjęć produktów przed przekazaniem własnych zasobów."
        },
        {
          "title": "Usuwanie znaku wodnego ze zdjęć społecznościowych",
          "desc": "Usuń oznaczenia platformy lub sygnatury czasowe ze swoich zdjęć, aby uzyskać czystszą wersję publikacyjną."
        },
        {
          "title": "Wyczyść wiele znaków wodnych",
          "desc": "Gdy jeden obraz zawiera kilka znaków wodnych, sztuczna inteligencja może wykryć i wyczyścić wiele zakrytych obszarów."
        }
      ],
      "howToKicker": "Trzy proste kroki",
      "howToTitle": "Jak usunąć znaki wodne ze zdjęć online za darmo",
      "howToIntro": "Nie jest wymagana instalacja oprogramowania. Prześlij obraz, uruchom narzędzie do usuwania znaków wodnych AI i pobierz oczyszczony wynik.",
      "howToCta": "Usuń teraz znaki wodne online",
      "steps": {
        "upload": {
          "title": "Prześlij obraz ze znakiem wodnym",
          "desc": "Wybierz obraz w formacie JPG, PNG lub WebP o rozmiarze mniejszym niż 15 MB. Upewnij się, że masz prawo do edycji i korzystania z niego."
        },
        "remove": {
          "title": "Usuń znak wodny za pomocą AI",
          "desc": "Rozpocznij przetwarzanie, a sztuczna inteligencja wykryje logo, tekst, znaczniki czasu lub znaki wodne pełnego obrazu i zrekonstruuje tło."
        },
        "download": {
          "title": "Wyświetl podgląd i pobierz",
          "desc": "Porównaj wyniki przed i po, a następnie pobierz oczyszczony obraz lub prześlij inny."
        }
      },
      "faqTitle": "Często zadawane pytania dotyczące usuwania znaku wodnego AI",
      "faqs": [
        {
          "q": "Co to jest narzędzie do usuwania znaków wodnych AI?",
          "a": "Narzędzie do usuwania znaków wodnych AI wykrywa obszary znaków wodnych i rekonstruuje zakryte tła przy użyciu pobliskich kolorów, tekstur i zawartości obrazu."
        },
        {
          "q": "Jak bezpłatnie usunąć znaki wodne ze zdjęć online?",
          "a": "Zarejestruj się, prześlij obraz do narzędzia do usuwania znaków wodnych Miral AI i rozpocznij przetwarzanie, aby wyświetlić podgląd oczyszczonego wyniku."
        },
        {
          "q": "Jakie formaty obrazów są obsługiwane?",
          "a": "Narzędzie obsługuje obecnie obrazy JPG, PNG i WebP o rozmiarze poniżej 15 MB. Ta strona nie usuwa znaków wodnych z filmów."
        },
        {
          "q": "Czy może usunąć pełnoobrazowe znaki wodne, logo i znaczniki czasu?",
          "a": "Tak. Sztuczna inteligencja może przetwarzać powtarzające się pełnowymiarowe znaki wodne, logo marki, datowniki, tekst i znaki robocze. Wyniki zależą od nieprzezroczystości, pokrytego obszaru i złożoności tła."
        },
        {
          "q": "Jakiego narzędzia mogę użyć, aby usunąć wiele logo lub znaczników czasu z jednego zdjęcia?",
          "a": "Narzędzie do usuwania znaków wodnych Miral AI może przetwarzać wiele obszarów znaków wodnych, w tym logo i znaczniki czasu. Sprawdź podgląd, gdy duże znaki zakrywają ludzi lub złożone tekstury."
        },
        {
          "q": "Czy usuwanie znaku wodnego z obrazu jest legalne?",
          "a": "Przetwarzaj wyłącznie obrazy, których jesteś właścicielem, masz uprawnienia do edycji lub których możesz legalnie używać. Usunięcie autorskich znaków wodnych bez zgody może naruszyć prawa właściciela."
        },
        {
          "q": "Jak naprawić rozmyte obszary po usunięciu znaku wodnego?",
          "a": "Zacznij od najwyższej jakości dostępnego obrazu źródłowego i sprawdź podgląd przed pobraniem. Sztuczna inteligencja stara się zachować oryginalną kompozycję, rozdzielczość i szczegóły, ale zawartość ukryta za dużymi znakami wodnymi musi zostać zrekonstruowana, więc lokalne wyniki mogą różnić się od oryginału."
        }
      ]
        },
        'full-watermark-remover': {
            name: 'Pełne usuwanie znaków wodnych',
            desc: 'Usuń znaki wodne z całego obrazu i przywróć czysty obraz za pomocą AI.',
            fullDesc: 'Usuwanie gęstych lub pełnoobrazowych znaków wodnych za pomocą AI przy zachowaniu oryginalnej treści i jakości wizualnej obrazu.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'full-watermark-removed.png'
        },
        'background-remover': {
            name: 'Usuwanie tła',
            desc: 'Usuń tło obrazu jednym kliknięciem za pomocą AI.',
            heroTitle: 'Darmowe usuwanie tła AI i przezroczyste PNG',
            fullDesc: 'Prześlij JPG, PNG lub WebP, a AI wykryje portret, produkt i krawędzie obiektu. Zachowaj włosy oraz drobne detale i pobierz przezroczysty PNG bez Photoshopa.',
            uploadLabel: 'Prześlij obraz do usunięcia tła',
            uploadHint: 'Kliknij lub przeciągnij obraz tutaj',
            uploadSpec: 'Obsługuje JPG, PNG i WebP do 15 MB. Wynik jest pobierany jako przezroczysty PNG.',
            processButton: 'Usuń tło obrazu',
            previewAlt: 'Podgląd przed usunięciem tła przez AI',
            demoBeforeAlt: 'Portret przed usunięciem tła',
            demoAfterAlt: 'Portret po usunięciu tła przez AI',
            processingAlt: 'AI usuwa tło obrazu',
            processingLabel: 'Wycinanie w toku',
            resultLabel: 'Przezroczyste tło gotowe',
            resultBeforeAlt: 'Oryginalny obraz przed usunięciem tła',
            resultAfterAlt: 'Przezroczysty PNG po usunięciu tła AI',
            productBeforeAlt: 'Zdjęcie produktu przed usunięciem tła',
            productAfterAlt: 'Wycięty produkt na przezroczystym tle',
            featuresKicker: 'Precyzyjne wykrywanie obiektu',
            featuresTitle: 'Usuwanie tła AI z portretów i zdjęć produktów',
            featuresIntro: 'Od złożonych krawędzi portretu po zdjęcia ecommerce — AI oddziela obiekt od tła bez pędzli, ścieżek i ręcznych masek.',
            features: [
                { title: 'Usuń tło portretu i zachowaj włosy', desc: 'Wykrywaj osoby, ubrania i cienkie włosy w zdjęciach profilowych, biznesowych, plakatach i grafikach społecznościowych.', cta: 'Usuń tło portretu za darmo' },
                { title: 'Wycinaj zdjęcia produktów jednym kliknięciem', desc: 'Usuń stół, ścianę i scenę, aby użyć produktu na białym tle, w sklepie i reklamie.', cta: 'Usuń tło produktu online' },
                { title: 'Pobierz przezroczysty PNG', desc: 'Zachowaj przezroczystość do użycia na nowym tle, banerze, prezentacji, miniaturze lub w projekcie.', cta: 'Ustaw przezroczyste tło' }
            ],
            featureAlts: { portraitBefore: 'Portret przed wycięciem', portraitAfter: 'Wycięty portret z zachowanymi włosami', productBefore: 'Produkt przed usunięciem tła', productAfter: 'Produkt na przezroczystym tle', ecommerceBefore: 'Zdjęcie ecommerce przed wycięciem', ecommerceAfter: 'Przezroczysty PNG dla ecommerce' },
            useCasesKicker: 'Popularne zastosowania',
            useCasesTitle: 'Jakie obrazy nadają się do wycinania AI?',
            useCasesIntro: 'Użyj narzędzia, gdy potrzebujesz szybko odizolować obiekt lub stworzyć przezroczysty materiał do pracy kreatywnej i komercyjnej.',
            useCases: [
                { title: 'Zdjęcia produktów ecommerce', desc: 'Przygotuj przezroczyste produkty do katalogów, sklepów i kampanii.' },
                { title: 'Portrety i zdjęcia profilowe', desc: 'Usuń otoczenie, zachowując włosy, ubrania i kontury.' },
                { title: 'Grafiki społecznościowe', desc: 'Umieszczaj osoby i produkty na okładkach, postach i miniaturach.' },
                { title: 'Zdjęcia biznesowe i dokumentowe', desc: 'Oddziel osobę, a potem dodaj wymagany kolor tła.' },
                { title: 'Logo i elementy graficzne', desc: 'Usuń niechciane tło przed ponownym użyciem projektu.' },
                { title: 'Reklama i projektowanie', desc: 'Twórz elastyczne przezroczyste PNG bez ręcznego wycinania.' }
            ],
            howToKicker: 'Trzy proste kroki',
            howToTitle: 'Jak usunąć tło obrazu online za darmo',
            howToIntro: 'Prześlij obraz, uruchom automatyczne wycinanie AI i pobierz przezroczysty PNG.',
            steps: [
                { title: 'Prześlij JPG, PNG lub WebP', desc: 'Wybierz wyraźny portret, produkt lub projekt do 15 MB.' },
                { title: 'Usuń tło za pomocą AI', desc: 'AI oddziela obiekt, zachowując ważne krawędzie.' },
                { title: 'Sprawdź i pobierz PNG', desc: 'Porównaj wynik i zapisz przezroczysty obraz.' }
            ],
            faqTitle: 'FAQ usuwania tła AI',
            faqs: [
                { q: 'Jak usunąć tło obrazu online za darmo?', a: 'Prześlij JPG, PNG lub WebP i rozpocznij proces. AI wykrywa obiekt i tworzy przezroczysty PNG.' },
                { q: 'Czy AI zachowa włosy i cienkie krawędzie?', a: 'Narzędzie stara się zachować włosy, ubrania i małe detale. Wyraźny kontrast zwykle poprawia wynik.' },
                { q: 'Czy mogę usunąć tło zdjęcia produktu?', a: 'Tak. Wyraźne produkty nadają się do przezroczystych materiałów ecommerce i reklamowych.' },
                { q: 'Jaki format otrzymam po przetworzeniu?', a: 'Wynik jest pobierany jako PNG z przezroczystością.' },
                { q: 'Jakie formaty i rozmiary są obsługiwane?', a: 'Obsługiwane są JPG, PNG i WebP do 15 MB.' },
                { q: 'Czy muszę instalować Photoshop?', a: 'Nie. AI usuwa tło bezpośrednio w przeglądarce.' }
            ],
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'background-removed.png'
        },
        'image-eraser': {
            name: 'Usuwanie obiektów',
            desc: 'Usuń dowolny obiekt, osobę lub znak wodny z obrazów za pomocą AI.',
            fullDesc: 'Usuwanie obiektów z obrazów za pomocą AI. Zaznacz pędzlem dowolny niechciany obiekt, osobę, znak wodny lub tekst na zdjęciu, a sztuczna inteligencja płynnie go usunie i wypełni obszar naturalną treścią. Idealne do czyszczenia zdjęć i usuwania rozpraszających elementów.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'image-erased.png'
        },
        'object-remover': {
            name: 'Usuwanie obiektów',
            desc: 'Usuń niechciane obiekty ze swoich zdjęć za pomocą AI.',
            fullDesc: 'Narzędzie do usuwania obiektów z zdjęć za pomocą AI. Zaznacz pędzlem dowolny niechciany obiekt na zdjęciu, a sztuczna inteligencja płynnie go usunie i wypełni obszar naturalną treścią. Idealne do czyszczenia zdjęć i usuwania rozpraszających elementów.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'object-removed.png',
      "uploadLabel": "Prześlij obraz",
      "uploadHint": "Kliknij lub przeciągnij, aby przesłać obraz",
      "uploadSpec": "Obsługuje obrazy JPG, PNG lub WebP.",
      "maskHint": "Pomaluj każdą część obiektu, który chcesz usunąć przez sztuczną inteligencję.",
      "processButton": "Usuń obiekt",
      "demoBeforeAlt": "Zdjęcie przed usunięciem niechcianego obiektu",
      "demoAfterAlt": "Zdjęcie po usunięciu niechcianego obiektu",
      "processingAlt": "AI przetwarza zaznaczone zdjęcie",
      "resultBeforeAlt": "Oryginalne zdjęcie przed usunięciem obiektu",
      "resultAfterAlt": "Wyczyść zdjęcie po usunięciu obiektu",
      "featureImageLabels": {
        "object": "przykład usuwania niepożądanych obiektów",
        "person": "przykład usunięcia osoby",
        "distraction": "przykład usuwania zakłóceń w tle"
      },
      "featuresKicker": "Precyzyjne czyszczenie zdjęć",
      "featuresTitle": "Usuń niechciane obiekty ze zdjęć online",
      "featuresIntro": "Zaznacz dokładnie obszar, który chcesz wyczyścić, i użyj funkcji usuwania obiektów AI do codziennych oderwań od zdjęć, bez konieczności ręcznego odtwarzania tła.",
      "features": [
        {
          "title": "Usuń niechciane przedmioty",
          "desc": "Do zaznaczania bałaganu, znaków, rekwizytów i innych obiektów używaj regulowanego pędzla. AI usuwa wybrany obszar i wypełnia go szczegółami otaczającego obrazu.",
          "cta": "Usuń obiekty za darmo"
        },
        {
          "title": "Usuń ludzi z tła zdjęć",
          "desc": "Usuń fotobombowców, turystów i przechodniów ze zdjęć podróżniczych i portretów, gdy odwracają uwagę od głównego tematu.",
          "cta": "Czyste tła do zdjęć za darmo"
        },
        {
          "title": "Usuń małe zakłócenia w tle",
          "desc": "Usuń przewody, kosze, bałagan uliczny, ślady lub izolowane elementy rozpraszające wzrok, aby stworzyć czystszą kompozycję.",
          "cta": "Usuń zakłócenia fotograficzne za darmo"
        }
      ],
      "useCasesKicker": "Popularne przypadki użycia",
      "useCasesTitle": "Co można usunąć za pomocą narzędzia do usuwania obiektów AI?",
      "useCasesIntro": "Zaprojektowany do ukierunkowanych edycji, w których można wyraźnie przesunąć niechciany obszar, pozostawiając resztę zdjęcia bez zmian.",
      "useCases": [
        {
          "title": "Oczyszczanie zdjęć z podróży",
          "desc": "Usuń przechodniów, znaki, kosze i bałagan uliczny ze zdjęć z wakacji."
        },
        {
          "title": "Oczyszczanie zdjęć produktów",
          "desc": "Usuń rekwizyty, etykiety, kable i rozpraszające przedmioty wokół produktu."
        },
        {
          "title": "Oczyszczanie tła portretu",
          "desc": "Usuń osoby w tle i małe obiekty, które odwracają uwagę od obiektu."
        },
        {
          "title": "Zdjęcia nieruchomości",
          "desc": "Usuń tymczasowe bałagany i izolowane obiekty z obrazów pomieszczeń lub nieruchomości."
        },
        {
          "title": "Obrazy w mediach społecznościowych",
          "desc": "Wypoleruj zdjęcia przed publikacją, usuwając widoczne zakłócenia z kadru."
        },
        {
          "title": "Kreatywna edycja zdjęć",
          "desc": "Wyczyść wybrane obszary przed ponownym użyciem obrazu w układzie lub projekcie wizualnym."
        }
      ],
      "howToKicker": "Trzy proste kroki",
      "howToTitle": "Jak usunąć obiekt ze zdjęcia online",
      "howToIntro": "Prześlij zdjęcie, przesuń kursor nad niechciany obiekt i pobierz wynik oczyszczony przez sztuczną inteligencję.",
      "steps": [
        {
          "title": "Prześlij swoje zdjęcie",
          "desc": "Wybierz obraz zawierający osobę, przedmiot lub rozproszenie, które chcesz usunąć."
        },
        {
          "title": "Pędzel nad obiektem",
          "desc": "Wyreguluj pędzel i zakryj cały niechciany obszar. Użyj cofania lub gumki, aby udoskonalić maskę."
        },
        {
          "title": "Usuń i pobierz",
          "desc": "Rozpocznij przetwarzanie AI, porównaj obrazy przed i po, a następnie pobierz oczyszczone zdjęcie."
        }
      ],
      "faqTitle": "Często zadawane pytania dotyczące usuwania obiektów AI",
      "faqs": [
        {
          "q": "Jak usunąć niechciane obiekty ze zdjęć online?",
          "a": "Prześlij zdjęcie, pomaluj cały niechciany obiekt i rozpocznij przetwarzanie. Sztuczna inteligencja rekonstruuje wybrany obszar, wykorzystując pobliskie kolory, tekstury i szczegóły sceny."
        },
        {
          "q": "Jakiego narzędzia mogę użyć, aby usunąć osobę z tła zdjęcia?",
          "a": "Użyj pędzla, aby zakryć osobę i uwzględnić szczegóły, takie jak cienie lub noszone przedmioty. Wyniki są zwykle lepsze, gdy widoczne jest otaczające tło."
        },
        {
          "q": "Czy sztuczna inteligencja może usunąć znaki, przewody, kosze i bałagan uliczny?",
          "a": "Tak. Wyraźnie zaznacz niechciany obszar i unikaj zasłaniania pobliskich obiektów, które chcesz zachować. Małe, izolowane elementy rozpraszające są zazwyczaj łatwiejsze do zrekonstruowania."
        },
        {
          "q": "Jak mogę uzyskać bardziej naturalny efekt usuwania obiektów?",
          "a": "Użyj wyraźnego obrazu źródłowego wysokiej jakości i przesuń pędzel nieco poza krawędzie obiektu. Przetwarzaj trudne obszary osobno, gdy kilka obiektów nakłada się na siebie."
        },
        {
          "q": "Czy usuwanie obiektów zmienia całe zdjęcie?",
          "a": "Żądanie usunięcia opiera się na szczotkowanej masce. Narzędzie skupia się na wybranym obszarze, choć AI musi zrekonstruować piksele wokół jego krawędzi."
        },
        {
          "q": "Jakie formaty obrazów mogę przesyłać?",
          "a": "Kontrola przesyłania akceptuje popularne formaty obrazów, w tym JPG, PNG i WebP."
        }
      ]
        },
        'ai-person-remover': {
            name: 'Usuwanie osób AI',
            desc: 'Usuń osoby ze swoich zdjęć za pomocą AI.',
            fullDesc: 'Narzędzie do usuwania osób ze zdjęć za pomocą AI. Zaznacz pędzlem dowolną osobę na zdjęciu, a sztuczna inteligencja płynnie ją usunie i wypełni obszar naturalną treścią. Idealne do usuwania przechodniów, turystów i obcych osób ze swoich zdjęć.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'person-removed.png'
        },
        'background-blur': {
            name: 'Rozmycie tła',
            desc: 'Rozmyj tło obrazu za pomocą AI jednym kliknięciem, aby uwypuklić obiekt',
            fullDesc: 'AI automatycznie wykrywa obiekt na pierwszym planie (osobę/obiekt), utrzymuje go w ostrości i nakłada rozmycie gaussowskie na tło dla efektu typu Tryb Portretowy. Idealne do portretów i zbliżeń produktowych.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'background-blur.png'
        },
        'white-background': {
            name: 'Białe tło',
            desc: 'Zastąp tło obrazu na białe za pomocą AI.',
            fullDesc: 'Zastępowanie tła na białe za pomocą AI jednym kliknięciem. Precyzyjnie wykrywa kontur obiektu, zachowuje drobne szczegóły takie jak włosy, generuje obraz z czystym białym tłem. Idealne do zdjęć produktowych i dowodów tożsamości.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'white-background.png'
        },
        'blue-background': {
            name: 'Niebieskie tło',
            desc: 'Zastąp tło obrazu na niebieskie za pomocą AI.',
            fullDesc: 'Zastępowanie tła na niebieskie za pomocą AI jednym kliknięciem. Precyzyjnie wykrywa kontur obiektu, zachowuje drobne szczegóły takie jak włosy, generuje obraz z czystym niebieskim tłem. Idealne do zdjęć paszportowych i dowodów tożsamości.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            noImageInResponse: 'Nie zwrócono obrazu wynikowego. Spróbuj ponownie później.',
            downloadName: 'blue-background.png'
        },
        'face-swap': {
            name: 'Zamiana twarzy na zdjęciach',
            desc: 'Zamieniaj twarze na zdjęciach za pomocą AI jednym kliknięciem.',
            fullDesc: 'Zamiana twarzy za pomocą AI. Prześlij zdjęcie docelowe i zdjęcie twarzy źródłowej, aby płynnie wkomponować twarz w obraz docelowy. Obsługuje sceny wieloosobowe z realistycznymi efektami.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            targetImage: 'Zdjęcie docelowe',
            sourceImage: 'Twarz źródłowa',
            downloadName: 'face-swap-result.png',
            step1Title: 'Prześlij zdjęcia',
            step1Desc: 'Prześlij zdjęcie docelowe i zdjęcie twarzy źródłowej',
            step2Title: 'AI Zamiana twarzy',
            step2Desc: 'Kliknij przetwórz, AI automatycznie zamienia twarz',
            step3Title: 'Pobierz',
            step3Desc: 'Podgląd i pobranie wyniku',
      "effectImageLabel": "Wynik",
      "processButton": "Zamień twarz",
      "targetPreviewAlt": "Docelowy podgląd zdjęcia w celu zamiany twarzy AI",
      "sourcePreviewAlt": "Podgląd twarzy źródłowej do zamiany twarzy AI",
      "processingAlt": "Podgląd przetwarzania zamiany twarzy AI",
      "resultBeforeAlt": "Wybierz zdjęcie przed zamianą twarzy",
      "resultAfterAlt": "Zdjęcie po zamianie twarzy AI",
      "featuresKicker": "Naturalna wymiana twarzy",
      "featuresTitle": "Zamień twarze między zdjęciami za pomocą sztucznej inteligencji",
      "featuresIntro": "Użyj zdjęcia docelowego dla pozy i kompozycji, a następnie podaj wyraźną twarz źródłową, aby uzyskać wyraźną zamianę twarzy.",
      "features": [
        {
          "title": "Stwórz naturalnie wyglądającą zamianę twarzy",
          "desc": "Sztuczna inteligencja łączy tożsamość źródłową ze zdjęciem docelowym, śledząc jego pozę, kadrowanie, oświetlenie i ogólny styl wizualny.",
          "cta": "Utwórz bezpłatną zamianę twarzy na zdjęcie"
        },
        {
          "title": "Zachowaj docelową kompozycję zdjęcia",
          "desc": "Użyj portretu, selfie, obrazu postaci lub kreatywnej sceny jako celu, zachowując jednocześnie tło i kompozycję.",
          "cta": "Wypróbuj funkcję Photo Face Swap za darmo"
        },
        {
          "title": "Użyj jasnej twarzy źródłowej",
          "desc": "Prześlij skierowane do przodu, dobrze oświetlone zdjęcie źródłowe z widocznymi szczegółami twarzy, aby pomóc modelowi w stworzeniu bardziej spójnego zamiennika.",
          "cta": "Przesyłaj i wymieniaj za darmo"
        }
      ],
      "useCasesKicker": "Kreatywne pomysły na zdjęcia",
      "useCasesTitle": "Popularne zastosowania internetowej zamiany zdjęć twarzy",
      "useCasesIntro": "Twórz zabawne i kreatywne edycje zdjęć, korzystając z jednego obrazu docelowego i jednego źródłowego obrazu twarzy.",
      "useCases": [
        {
          "title": "Zamiana twarzy w selfie i zdjęciu profilowym",
          "desc": "Zamień twarz na selfie lub portrecie, zachowując docelową pozę, tło i kadrowanie. Przeglądaj koncepcje zdjęć profilowych i pomysły na portrety osobiste z wyraźną twarzą źródłową.",
          "cta": "Utwórz bezpłatną zamianę twarzy portretowej",
          "imageAlt": "Przykład zamiany twarzy AI dla selfie i zdjęć profilowych"
        },
        {
          "title": "Memy i obrazy zawierające reakcje społeczne",
          "desc": "Zamień znajome zdjęcia w spersonalizowane memy, zabawne obrazy reakcji i treści społecznościowe, które można udostępniać. Wyraźny wyraz celu pomaga w łatwym rozpoznaniu końcowego obrazu.",
          "cta": "Zrób zamianę twarzy mema za darmo",
          "imageAlt": "Przypadek użycia kreatywnego memu i obrazu reakcji społecznej"
        },
        {
          "title": "Cosplay, postacie i kreatywne historie",
          "desc": "Wypróbuj twarz w kostiumie, portret fantastyczny, ilustrowaną postać lub scenę tematyczną. Korzystaj z funkcji zamiany twarzy, aby odkrywać koncepcje postaci i tworzyć wizualne historie z obrazów, które możesz edytować.",
          "cta": "Wypróbuj zamianę twarzy postaci za darmo",
          "imageAlt": "Przypadek użycia cosplayu i zamiany twarzy postaci"
        }
      ],
      "howToKicker": "Trzy proste kroki",
      "howToTitle": "Jak zamieniać twarze na zdjęciach online za pomocą sztucznej inteligencji",
      "howToIntro": "Wybierz zdjęcie docelowe, dodaj wyraźną twarz źródłową i pozwól sztucznej inteligencji wygenerować wynik zamiany twarzy.",
      "faqTitle": "Często zadawane pytania dotyczące zamiany twarzy na zdjęciach",
      "faqs": [
        {
          "q": "Jak zamienić twarz między dwoma zdjęciami online?",
          "a": "Prześlij zdjęcie, którego pozę i kompozycję chcesz zachować jako cel, a następnie prześlij tożsamość, której chcesz użyć jako twarzy źródłowej, i rozpocznij przetwarzanie."
        },
        {
          "q": "Jaka jest różnica między zdjęciem docelowym a twarzą źródłową?",
          "a": "Zdjęcie docelowe określa pozę, tło i kompozycję. Twarz źródłowa zapewnia tożsamość twarzy używaną do zastąpienia."
        },
        {
          "q": "Jak wybrać dobry obraz źródłowy do zamiany twarzy?",
          "a": "Użyj wyraźnego, dobrze oświetlonego obrazu z niezakłóconą twarzą. Kąt źródła i ekspresja podobne do celu mogą dać bardziej spójny wynik."
        },
        {
          "q": "Czy mogę używać funkcji zamiany twarzy AI do robienia selfie, memów lub zdjęć cosplayowych?",
          "a": "Tak. Są to typowe zastosowania twórcze, gdy jesteś właścicielem przesłanych obrazów lub masz pozwolenie na edycję."
        },
        {
          "q": "Dlaczego zamiana twarzy czasami wygląda mniej realistycznie?",
          "a": "Duże różnice w kącie twarzy, oświetleniu, wyrazie, rozdzielczości lub dużej okluzji mogą utrudniać mieszanie. Wypróbuj wyraźniejsze i bardziej kompatybilne zdjęcia źródłowe."
        },
        {
          "q": "Jakie formaty obrazów i rozmiary plików są obsługiwane?",
          "a": "Obsługiwane są obrazy JPG, PNG i WebP, a maksymalny rozmiar pliku wynosi 15 MB na obraz."
        },
        {
          "q": "Czy mogę zamienić twarz w filmie na tej stronie?",
          "a": "Nie. Ta strona przetwarza nieruchome obrazy i zwraca wynik w postaci obrazu."
        }
      ]
        },
        'image-enhancer': {
            name: 'Poprawa jakości obrazu',
            desc: 'Popraw przejrzystość obrazu jednym kliknięciem za pomocą AI.',
            fullDesc: 'Skaluj obrazy do rozdzielczości 4K z ulepszonymi szczegółami. Wykorzystuje zaawansowane algorytmy AI do poprawy szczegółów, sprawiając, że rozmyte obrazy stają się ostre i wyraźne.',
            fileTooLarge: 'Obraz jest zbyt duży. Użyj pliku poniżej 15 MB (JPG, PNG lub WebP).',
            notImageFile: 'Prześlij plik obrazu.',
            downloadName: 'image-enhanced.png',
            targetResolution: 'Rozdzielczość docelowa',
            outputFormat: 'Format wyjściowy',
            resolutions: {
                '2k': '2K',
                '4k': '4K',
                '8k': '8K'
            },
            formats: {
                JPEG: 'JPEG',
                PNG: 'PNG',
                WEBP: 'WEBP'
            },
            processFailed: 'Przetwarzanie nie powiodło się. Spróbuj innego obrazu lub formatu wyjściowego.'
        },
        'video-enhancer': {
            name: 'Poprawa jakości wideo',
            desc: 'Popraw jakość wideo za pomocą skalowania AI.',
            fullDesc: 'Popraw jakość wideo do HD/4K dzięki interpolacji klatek i wyostrzaniu AI.',
            notVideoFile: 'Prześlij plik wideo (np. MP4, MOV, AVI).',
            fileTooLarge: 'Wideo jest zbyt duże. Użyj pliku poniżej 100 MB.'
        },
        'cartoon-video-style-converter': {
            name: 'Konwerter stylu kreskówkowego',
            desc: 'Konwertuj filmy do stylu kreskówkowego',
            fullDesc: 'Prześlij film, a AI przekonwertuje go do stylu kreskówkowego, zachowując główny ruch, kadr i rytm sceny.',
            notVideoFile: 'Prześlij prawidłowy plik wideo.',
            fileTooLarge: 'Wideo jest zbyt duże. Wybierz film poniżej 100 MB.',
            downloadName: 'cartoon-style-video.mp4'
        },
        'anime-video-style-converter': {
            name: 'Konwerter stylu anime',
            desc: 'Konwertuj filmy do stylu anime',
            fullDesc: 'Prześlij film, a AI przekonwertuje go do stylu anime, zachowując ruch obiektu i tempo ujęcia.',
            notVideoFile: 'Prześlij prawidłowy plik wideo.',
            fileTooLarge: 'Wideo jest zbyt duże. Wybierz film poniżej 100 MB.',
            downloadName: 'anime-style-video.mp4'
        },
        'oil-painting-video-style-converter': {
            name: 'Konwerter stylu malarstwa olejnego',
            desc: 'Konwertuj filmy do stylu malarstwa olejnego',
            fullDesc: 'Prześlij film, a AI przekonwertuje go do stylu malarstwa olejnego z bogatymi kolorami i malarską teksturą.',
            notVideoFile: 'Prześlij prawidłowy plik wideo.',
            fileTooLarge: 'Wideo jest zbyt duże. Wybierz film poniżej 100 MB.',
            downloadName: 'oil-painting-style-video.mp4'
        },
        'cyberpunk-video-style-converter': {
            name: 'Konwerter stylu cyberpunk',
            desc: 'Konwertuj filmy do stylu cyberpunk',
            fullDesc: 'Prześlij film, a AI przekonwertuje go do futurystycznego stylu cyberpunk o wysokim kontraście i neonowym wyglądzie.',
            notVideoFile: 'Prześlij prawidłowy plik wideo.',
            fileTooLarge: 'Wideo jest zbyt duże. Wybierz film poniżej 100 MB.',
            downloadName: 'cyberpunk-style-video.mp4'
        },
        'photo-restore': {
            name: 'Renowacja zdjęć',
            desc: 'Przywróć stare, rozmyte lub uszkodzone zdjęcia za pomocą technologii AI.',
            fullDesc: 'Przywracanie starych, rozmytych lub uszkodzonych zdjęć za pomocą technologii AI. Obsługuje odszumianie, wyostrzanie i wypełnianie brakujących elementów, aby ożywić cenne wspomnienia.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'photo-restored.png'
        },
        'blurry-photo-repair': {
            name: 'Naprawa rozmytych obrazów',
            desc: 'Napraw rozmyte obrazy i odzyskaj wyraźniejsze szczegóły za pomocą AI.',
            fullDesc: 'Naprawa rozmytych obrazów za pomocą AI. Popraw ostrość, odzyskaj szczegóły twarzy i tekstur, sprawiając, że miękkie zdjęcia stają się wyraźniejsze do udostępniania lub archiwizacji.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'blurry-image-fixed.png'
        },
        'cartoon-digital-human': {
            name: 'Generator postaci kreskówkowych AI',
            desc: 'Zmień portret w kreskówkowy cyfrowy awatar w stylu anime.',
            fullDesc: 'Generuj kreskówkową postać cyfrową w stylu anime z portretu. Zachowaj rozpoznawalne cechy osoby, tworząc dopracowany awatar z wyraźnymi liniami i żywymi kolorami.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'cartoon-digital-human.png'
        },
        'manga-digital-human': {
            name: 'Generator postaci manga AI',
            desc: 'Zmień portret w cyfrowy awatar w stylu mangi.',
            fullDesc: 'Generuj cyfrową postać w stylu mangi z portretu. Zachowaj rozpoznawalne cechy osoby, tworząc czysty komiksowy wygląd z ekspresywnymi liniami i dopracowanym cieniowaniem.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'manga-digital-human.png'
        },
        'oil-painting-digital-human': {
            name: 'Generator portretów olejnych AI'
        },
        'ai-change-clothes': {
            name: 'Zmiana ubrań AI'
        },
        'id-photo-generator': {
            name: 'Generator zdjęć dowodowych',
            desc: 'Wygeneruj czyste zdjęcie dowodowe z portretu za pomocą AI.',
            fullDesc: 'Generuj czyste, profesjonalne zdjęcie dowodowe z portretu. AI dostosowuje osobę do schludnego wyglądu zdjęcia dokumentowego, odpowiedniego do profilu i użytku w formie dowodu tożsamości.',
            notImageFile: 'Prześlij prawidłowy plik obrazu.',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB.',
            downloadName: 'id-photo.png'
        },
        'handwritten-erase': {
            name: 'Usuwanie odręcznych notatek',
            desc: 'Usuń odręczny tekst z dokumentów za pomocą AI.',
            fullDesc: 'Automatycznie wykryj i usuń odręczny tekst z dokumentów, zachowując wydrukowaną treść. Idealne do egzaminów, notatek, umów i nie tylko. Obsługuje kadrowanie, prostowanie i obracanie.',
            docDirection: 'Obrót',
            docDirections: {
                none: 'Bez obrotu',
                rotate90: '90° zgodnie z ruchem wskazówek zegara',
                rotate180: '180° zgodnie z ruchem wskazówek zegara',
                rotate270: '270° zgodnie z ruchem wskazówek zegara',
                auto: 'Automatyczne wykrywanie'
            },
            crop: 'Kadruj krawędzie',
            dewarp: 'Prostuj',
            notImageFile: 'Prześlij prawidłowy plik obrazu',
            fileTooLarge: 'Obraz zbyt duży, wybierz obraz poniżej 15 MB',
            noImageInResponse: 'Przetwarzanie nie powiodło się, spróbuj ponownie',
            downloadName: 'handwriting-erased.png',
      "featuresKicker": "Usuwanie pisma ręcznego dokumentu",
      "featuresTitle": "Usuń pismo odręczne i przywróć czyste dokumenty",
      "featuresIntro": "Czyste odręczne odpowiedzi, poprawki do umów, notatki z recenzji i oznaczenia zeskanowanych dokumentów, zachowując jednocześnie drukowany tekst i oryginalny układ.",
      "features": [
        {
          "title": "Usuń odpowiedzi uczniów z prac testowych",
          "desc": "Automatycznie wykrywaj odręczne odpowiedzi, obliczenia i adnotacje na wypełnionych arkuszach testowych.",
          "cta": "Czysty papier testowy Odpowiedzi za darmo"
        },
        {
          "title": "Usuń charakter pisma odręcznego z umów",
          "desc": "Wyczyść odręczne dodatki, kółka, zmienione kwoty, strzałki i notatki z przeglądu, zachowując jednocześnie wydrukowane klauzule, tabele i układ.",
          "cta": "Czyste pismo odręczne w umowie online"
        },
        {
          "title": "Przygotowywanie i ponowne drukowanie testów do nauczania",
          "desc": "Przejrzyste odpowiedzi uczniów i adnotacje nauczyciela dotyczące lekcji, przygotowania testów i archiwizacji dokumentów.",
          "cta": "Wypróbuj środek do czyszczenia papieru dla nauczycieli"
        },
        {
          "title": "Wyczyść odręczne znaki ze zeskanowanych dokumentów",
          "desc": "Usuń znaczniki, strzałki, kółka, notatki na marginesach i znaczniki recenzji ze zeskanowanych formularzy, raportów z inspekcji i dokumentów biurowych.",
          "cta": "Wyczyść znaczniki zeskanowanego dokumentu"
        }
      ],
      "useCasesKicker": "Dla uczniów i nauczycieli",
      "useCasesTitle": "Edukacyjne przypadki użycia usuwania pisma ręcznego AI",
      "useCases": [
        {
          "title": "Usunięcie odpowiedzi testowej",
          "desc": "Usuń odpowiedzi i obliczenia uczniów z prac testowych."
        },
        {
          "title": "Przegląd błędów",
          "desc": "Przywróć wypełnione dokumenty na kolejną rundę ćwiczeń."
        },
        {
          "title": "Czyszczenie zeszytu ćwiczeń",
          "desc": "Usuń odręczne treści z prac domowych i arkuszy ćwiczeń."
        },
        {
          "title": "Nauczanie i przygotowanie do testów",
          "desc": "Twórz czyste dokumenty na lekcje, przedrukuj i archiwizuj."
        },
        {
          "title": "Korekta zeskanowanego papieru",
          "desc": "Obracaj, przycinaj i usuwaj zniekształcenia przekrzywionych lub zakrzywionych obrazów dokumentów."
        },
        {
          "title": "Sprzątanie kontraktów i notatek",
          "desc": "Usuń charakter pisma ręcznego i adnotacje z dokumentów ogólnych."
        }
      ],
      "howToKicker": "Trzy proste kroki",
      "howToTitle": "Jak usunąć odręczne odpowiedzi z prac testowych online",
      "howToIntro": "Prześlij arkusz testowy lub dokument, ustaw opcje obracania, kadrowania i usuwania zniekształceń, a następnie pobierz wyczyszczony wynik.",
      "steps": {
        "upload": {
          "title": "Prześlij arkusz testowy lub dokument",
          "desc": "Prześlij arkusz testowy w formacie JPG, PNG lub WebP, arkusz zadania domowego lub zeskanowany dokument o rozmiarze mniejszym niż 15 MB."
        },
        "process": {
          "title": "Skonfiguruj i usuń pismo ręczne",
          "desc": "Wybierz kierunek dokumentu i w razie potrzeby włącz przycinanie lub usuwanie zniekształceń, a następnie rozpocznij przetwarzanie."
        },
        "download": {
          "title": "Przejrzyj i pobierz",
          "desc": "Porównaj obrazy przed i po, pobierz czysty dokument lub przetwórz inny obraz."
        }
      },
      "faqTitle": "Często zadawane pytania dotyczące usuwania odpowiedzi na papier testowy AI",
      "faqs": [
        {
          "q": "Jakiego narzędzia mogę użyć do usunięcia odręcznych odpowiedzi z arkuszy testowych?",
          "a": "Narzędzie do usuwania pisma ręcznego Miral AI wykrywa odręczne odpowiedzi, obliczenia i adnotacje, zachowując jednocześnie wydrukowane pytania i oryginalny układ, jeśli to możliwe."
        },
        {
          "q": "Czy sztuczna inteligencja może usunąć pismo odręczne, zachowując drukowany tekst?",
          "a": "Może przywrócić czysty papier, zachowując drukowany tekst, gdy pismo odręczne nie nakłada się mocno na drukowaną treść."
        },
        {
          "q": "Czy nauczyciele mogą wyczyścić i ponownie wydrukować arkusze testowe?",
          "a": "Tak. Nadaje się do przygotowywania lekcji, wyjaśniania zajęć, tworzenia testów i archiwizowania dokumentów."
        },
        {
          "q": "Czy studenci mogą zresetować odpowiedzi na prace w celu powtórki?",
          "a": "Tak. Oczyszczone arkusze testowe i arkusze ćwiczeń można ponownie wykorzystać do sprawdzenia błędów i dalszej praktyki."
        },
        {
          "q": "Jak usunąć odręczne notatki, ślady długopisu i adnotacje wykonane czerwonym tuszem?",
          "a": "Prześlij obraz dokumentu i uruchom narzędzie do usuwania pisma ręcznego. Może przetwarzać różne kolory pisma ręcznego i narzędzia do pisania, chociaż wyniki zależą od przejrzystości i nakładania się na drukowany tekst."
        },
        {
          "q": "Jak naprawić przekrzywiony lub zakrzywiony skan przed usunięciem pisma ręcznego?",
          "a": "Najpierw wyprostuj lub obróć przechylony skan. Przycinaj nadmiar tła i usuwaj zniekształcenia tylko w przypadku naprawdę zakrzywionych stron przed obróbką pisma ręcznego."
        },
        {
          "q": "Jakie formaty obrazów są obsługiwane?",
          "a": "Obsługiwane są obrazy JPG, PNG i WebP o rozmiarze mniejszym niż 15 MB. Ta strona nie obsługuje plików PDF."
        }
      ]
        },
        category: {
            image: 'Narzędzia obrazów',
            video: 'Narzędzia wideo',
            document: 'Narzędzia dokumentów'
        },
        categoryModal: {
            title: 'Wybierz kategorię narzędzi'
        },
        convert: {
            success: 'Konwersja zakończona!',
            zipHint: 'Wynik jest spakowany jako plik ZIP zawierający wiele obrazów',
            fileTooLarge: 'Plik zbyt duży, wybierz plik poniżej 50 MB',
            multiImageHint: 'Obsługuje przesyłanie wielu obrazów i łączenie w jeden PDF',
            addMore: 'Dodaj więcej'
        },
        'pdf-to-word': {
            name: 'PDF na Word',
            desc: 'Konwertuj pliki PDF na edytowalne dokumenty Word',
            fullDesc: 'Inteligentnie konwertuj pliki PDF na edytowalne dokumenty Word, dokładnie zachowując układ, tabele, obrazy i nie tylko. Obsługuje mieszany tekst chiński i angielski.'
        },
        'image-to-word': {
            name: 'Obraz na Word',
            desc: 'Konwertuj tekst na obrazach na dokumenty Word',
            fullDesc: 'Inteligentnie rozpoznaj tekst, tabele i inną treść na obrazach i konwertuj je na dokumenty Word, zachowując oryginalny format układu. Obsługuje ekstrakcję pieczęci i rozpoznawanie tekstu odręcznego.'
        },
        'pdf-to-excel': {
            name: 'PDF na Excel',
            desc: 'Konwertuj tabele PDF na edytowalne pliki Excel',
            fullDesc: 'Inteligentnie rozpoznaj treść tabel w plikach PDF i konwertuj je na edytowalne pliki Excel, dokładnie zachowując strukturę tabel i dane.'
        },
        'pdf-to-ppt': {
            name: 'PDF na PPT',
            desc: 'Konwertuj pliki PDF na edytowalne prezentacje PPT',
            fullDesc: 'Inteligentnie konwertuj pliki PDF na edytowalne prezentacje PPT, zachowując oryginalny układ, obrazy i treść tekstową.'
        },
        'pdf-to-image': {
            name: 'PDF na obraz',
            desc: 'Konwertuj każdą stronę PDF na wysokiej jakości obrazy',
            fullDesc: 'Konwertuj każdą stronę pliku PDF na wysokiej jakości obrazy. Obsługuje wsadową konwersję wielostronicowych plików PDF, z wynikami spakowanymi jako pobranie ZIP.'
        },
        'word-to-pdf': {
            name: 'Word na PDF',
            desc: 'Konwertuj dokumenty Word na pliki PDF',
            fullDesc: 'Szybko konwertuj dokumenty Word na pliki PDF, zachowując oryginalny układ, czcionki i obrazy, aby zapewnić spójność formatu.'
        },
        'excel-to-pdf': {
            name: 'Excel na PDF',
            desc: 'Konwertuj arkusze Excel na pliki PDF',
            fullDesc: 'Konwertuj arkusze Excel na pliki PDF, zachowując strukturę tabel i układ danych do łatwego udostępniania i drukowania.'
        },
        'image-to-pdf': {
            name: 'Obraz na PDF',
            desc: 'Scal wiele obrazów w jeden plik PDF',
            fullDesc: 'Scal wiele obrazów w jeden plik PDF. Obsługuje popularne formaty obrazów takie jak JPG, PNG i BMP do ujednoliconego zarządzania i udostępniania.'
        },
        'word-to-image': {
            name: 'Word na obraz',
            desc: 'Konwertuj każdą stronę dokumentu Word na obraz',
            fullDesc: 'Konwertuj każdą stronę dokumentu Word na wysokiej jakości obrazy. Obsługuje wsadową konwersję wielostronicowych dokumentów, z wynikami spakowanymi jako pobranie ZIP.'
        }
    },
    plans: {
        basic: {
            name: 'Podstawowy',
            features: [
                'Wszystkie kredyty dostarczane od razu',
                'Generuj do 2 600 obrazów AI',
                'Generuj 520 wideo AI',
                'Generuj do 480 utworów muzycznych AI',
                'Bez znaków wodnych',
                'Licencja komercyjna'
            ]
        },
        pro: {
            name: 'Pro',
            features: [
                'Wszystkie kredyty dostarczane od razu',
                'Generuj do 10 600 obrazów AI',
                'Generuj do 2 120 wideo AI',
                'Generuj do 1 920 utworów muzycznych AI',
                'Wszystkie modele premium',
                'Kolejka priorytetowa',
                'Wsparcie priorytetowe',
                'Tryb prywatności i zgodność z DPA'
            ]
        },
        ultimate: {
            name: 'Ultimate',
            features: [
                'Wszystkie kredyty dostarczane od razu',
                'Generuj do 36 600 obrazów AI',
                'Generuj do 7 320 wideo AI',
                'Generuj do 6 720 utworów muzycznych AI',
                'Wszystkie modele premium',
                'Dedykowane wsparcie',
                'Tryb prywatności i zgodność z DPA'
            ]
        }
    },
    faq: {
        categories: {
            all: 'Wszystkie',
            general: 'Ogólne',
            pricing: 'Cennik',
            models: 'Modele',
            features: 'Funkcje'
        },
        items: [
            {
                q: 'Czym jest Miral?',
                a: 'Miral to wszechstronna platforma tworzenia AI integrująca ponad 29 najwyższej klasy modeli AI, obsługująca generowanie obrazów, tworzenie wideo, produkcję muzyki i profesjonalne narzędzia edycyjne. Nie trzeba przełączać się między platformami - jedno konto daje dostęp do wszystkich głównych modeli, w tym FLUX, Midjourney, Sora, Veo, Kling i innych.'
            },
            {
                q: 'Które modele AI są obsługiwane?',
                a: 'Obsługujemy ponad 29 najwyższej klasy modeli AI, w tym modele obrazów (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana itp.), modele wideo (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5 itp.) oraz modele generowania muzyki AI. Wszystkie modele są stale aktualizowane.'
            },
            {
                q: 'Jak działa system kredytów?',
                a: 'Używamy ujednoliconego systemu kredytów. Generowanie obrazów zaczyna się od 2 kredytów, generowanie wideo od 10 kredytów, a muzyki po 10 kredytów na utwór. Modele premium mogą zużywać więcej kredytów. Subskrybenci korzystają z niższych stawek kredytowych i mogą również kupować pakiety kredytów osobno.'
            },
            {
                q: 'Czy mogę generować obrazy, wideo i muzykę?',
                a: 'Tak! Miral obsługuje tekst na obraz, edycję obrazów, transfer stylu, tekst na wideo, obraz na wideo, tworzenie muzyki AI i nie tylko - spełniając wszystkie potrzeby kreatywne, od projektów osobistych po prace komercyjne.'
            },
            {
                q: 'Jak szybkie jest generowanie?',
                a: 'Większość generowania obrazów kończy się w ciągu 30 sekund, generowanie wideo zajmuje około 1-6 minut. Nieustannie optymalizujemy naszą infrastrukturę, aby zapewnić szybkie i stabilne generowanie.'
            },
            {
                q: 'Czy mogę używać Miral do celów komercyjnych?',
                a: 'Tak. Wszystkie płatne plany zawierają licencje komercyjne, pozwalając na używanie wygenerowanej treści do projektów komercyjnych, materiałów marketingowych, mediów społecznościowych i nie tylko.'
            },
            {
                q: 'Czy dostępny jest dostęp do API?',
                a: 'Tak, plan Ultimate obejmuje dostęp do API. Dzięki naszemu kompleksowemu API możesz zintegrować generowanie obrazów, wideo i muzyki AI bezpośrednio z aplikacjami.'
            },
            {
                q: 'Czy mogę generować muzykę za pomocą AI?',
                a: 'Oczywiście! Nasz generator muzyki AI obsługuje różne style muzyczne. Wystarczy opisać, co chcesz wygenerować oryginalną muzykę, idealną do ścieżek dźwiękowych wideo, muzyki tła do podcastów i nie tylko.'
            },
            {
                q: 'Jak radzicie sobie z prywatnością i bezpieczeństwem danych?',
                a: 'Ściśle przestrzegamy standardów zgodności z RODO. Wszystkie dane są szyfrowane i nie są używane do trenowania modeli AI. Użytkownicy mogą usunąć swoje konta i wszystkie dane w dowolnym momencie.'
            },
            {
                q: 'Czy inni mogą zobaczyć moje prace?',
                a: 'Domyślnie Twoje prace są widoczne tylko dla Ciebie. Użytkownicy Pro i Ultimate mogą włączyć tryb prywatności, aby zapewnić pełną prywatność.'
            },
            {
                q: 'Jak mogę usunąć moje konto i dane?',
                a: 'Możesz poprosić o usunięcie konta w ustawieniach konta w dowolnym momencie. Usuniemy wszystkie Twoje dane i wygenerowaną treść w ciągu 30 dni.'
            },
            {
                q: 'Czy mogę uzyskać wsparcie, jeśli napotkam problemy?',
                a: 'Oczywiście! Możesz skontaktować się z naszym zespołem wsparcia pod adresem miral_support@miralvis.com. Użytkownicy Pro otrzymują wsparcie priorytetowe, a użytkownicy Ultimate - wsparcie dedykowane.'
            }
        ]
    },
    testimonials: {
        items: [
            {
                name: 'Alex Chen',
                role: 'Dyrektor marketingu cyfrowego',
                tag: 'Oszczędź 90% czasu',
                content: 'Miral stał się naszym centrum treści wizualnych. Generuj zdjęcia produktów za pomocą Midjourney, twórz wideo promocyjne za pomocą Veo, a następnie edytuj wszystko w Miral - wszystko bez przełączania platform.'
            },
            {
                name: 'Sarah Rodriguez',
                role: 'Właściciel sklepu e-commerce',
                tag: '40% wyższa konwersja',
                content: 'Dostęp do ponad 29 modeli w jednym miejscu jest niesamowity. Używam Seedream do zdjęć produktowych, Seedance do reklam wideo i narzędzi do skalowania dla katalogów. Konwersja wzrosła o 40%!'
            },
            {
                name: 'David Kim',
                role: 'Twórca treści',
                tag: '500K+ obserwujących',
                content: 'Tworzę obrazy za pomocą FLUX i Nano Banana, a następnie zamieniam je w viralowe wideo za pomocą Kling i Sora. System kredytów jest sprawiedliwy - płacisz za to, co zużywasz. Moi obserwatorzy uwielbiają różnorodne treści!'
            },
            {
                name: 'Emma Thompson',
                role: 'Projektant graficzny',
                tag: 'Klasa profesjonalna',
                content: 'Jako projektantka byłam sceptyczna wobec platform AI. Ale bogata biblioteka modeli Miral i precyzyjne narzędzia edycyjne są naprawdę imponujące - od szkiców koncepcyjnych po gotowe produkty, wszystko jest proste.'
            },
            {
                name: 'James Wilson',
                role: 'Producent wideo',
                tag: '10x szybszy przepływ pracy',
                content: 'Modele wideo tutaj są niesamowite - Veo jest filmowy, Seedance jest szybki, a animacja postaci Wan jest naturalna. Wszystkie modele współdzielą jeden system kredytów - oszczędza czas i pieniądze.'
            },
            {
                name: 'Lisa Park',
                role: 'Właściciel agencji kreatywnej',
                tag: 'Najlepszy wybór zespołu',
                content: 'Nasz cały zespół przeszedł na Miral. Integracja API jest płynna, a różnorodność modeli oznacza, że zawsze znajdujemy odpowiednie narzędzie. To najlepsza dostępna platforma AI.'
            }
        ]
    },
    langModal: {
        title: 'Wybierz język'
    },
    home: {
        searchModel: 'Szukaj modelu...',
        newModels: 'Nowe modele',
        otherModels: 'Inne modele',
        selectModel: 'Wybierz model',
        promptPlaceholderImage: 'Opisz obraz, który chcesz stworzyć...',
        promptPlaceholderVideo: 'Opisz wideo, które chcesz stworzyć...',
        generate: 'Generuj',
        chatDisabledGenerateHint: 'Wpisz prompt',
        compactChatPlaceholder: 'Wpisz prompt, aby tworzyć zachwycające obrazy i filmy AI oraz oryginalną muzykę',
        hero: {
            title: 'Miral – Kompleksowy kreator AI obrazów, wideo i muzyki',
            subtitle: 'Dzięki wszechstronnym modelom AI Miral łączy edycję obrazów, generowanie wideo i tworzenie muzyki AI. Edytuj zdjęcia, twórz filmowe portrety wideo i własną muzykę w tle do projektów prywatnych i komercyjnych.',
            createVideo: 'Stwórz wideo',
            createImage: 'Stwórz obraz'
        },
        stats: {
            models: 'Najlepsze modele AI',
            works: 'Wygenerowanych prac',
            tools: 'Profesjonalne narzędzia',
            platforms: 'Platformy partnerskie'
        },
        generatorNew: {
            promptPlaceholder: 'Opisz wideo, które chcesz wygenerować...',
            promptPlaceholderImage: 'Opisz obraz, który chcesz wygenerować...',
            generating: 'Generowanie...',
            noHistory: 'Wyniki pojawią się po generowaniu',
            generationFailed: 'Generowanie nie powiodło się',
            historyTitle: 'Historia',
            myAssets: 'Moje zasoby'
        },
        quickTools: {
            title: 'Szybkie narzędzia AI'
        },
        exploreMore: {
            title: 'Odkryj więcej funkcji AI'
        },
        musicPresets: [
            { label: 'Wesoły hymn pop', value: 'Upbeat Pop Anthem' },
            { label: 'Chill Lo-fi Beat', value: 'Chill Lo-fi Beat' },
            { label: 'Filmowa epicka ścieżka', value: 'Cinematic Epic Score' },
            { label: 'Akustyczna piosenka folkowa', value: 'Acoustic Folk Song' },
            { label: 'Elektroniczny utwór taneczny', value: 'Electronic Dance Track' },
            { label: 'Klimat jazzowy', value: 'Jazz Lounge Vibe' },
            { label: 'Rockowa ballada', value: 'Rock Power Ballad' },
            { label: 'Ambientowa medytacja', value: 'Ambient Meditation' }
        ],
        musicPresetsPlaceholder: 'Wybierz preset muzyczny',
        platform: {
            tag: 'Platforma',
            title: 'Narzędzia AI, które upraszczają tworzenie',
            subtitle: 'Wszystko w jednym: generowanie obrazów, tworzenie wideo, produkcja muzyki i profesjonalne narzędzia napędzane przez wiodące modele AI.',
            tabs: {
                image: 'Obrazy AI',
                video: 'Wideo AI',
                music: 'Muzyka AI',
                tools: 'Narzędzia AI'
            },
            image: {
                title: 'Generuj i edytuj oszałamiające obrazy najlepszymi globalnymi modelami AI',
                desc: 'Tekst na obraz, precyzyjna edycja, transfer stylu i skalowanie HD. Napędzane przez FLUX, Midjourney, Seedream, GPT-Image-1 i Nano Banana.',
                explore: 'Przeglądaj modele obrazów →'
            },
            video: {
                title: 'Twórz filmowe wideo za pomocą AI',
                desc: 'Od tekstu na wideo do animacji obrazów, napędzane przez modele Veo, Sora, Kling, Seedance i Wan. Generuj wideo z zsynchronizowanym dźwiękiem i profesjonalną pracą kamery.',
                explore: 'Przeglądaj modele wideo →'
            },
            music: {
                title: 'Oryginalne tworzenie muzyki napędzane przez AI',
                desc: 'Generuj oryginalną muzykę z opisów, obsługując różne style i czasy trwania. Idealne do ścieżek dźwiękowych wideo, muzyki tła do podcastów i nie tylko.',
                explore: 'Przeglądaj muzykę AI →'
            },
            tools: {
                title: 'Profesjonalne narzędzia AI',
                desc: 'Usuwanie znaków wodnych, restauracja zdjęć, skalowanie HD, ulepszanie wideo i inne profesjonalne narzędzia do wszystkich potrzeb przetwarzania końcowego.',
                explore: 'Zobacz wszystkie narzędzia →'
            }
        },
        models: {
            tag: 'Modele',
            title: 'Jednokrotna integracja najlepszych globalnych modeli AI',
            subtitle: 'Jedna platforma integrująca wszystkie główne modele AI. Koniec z przełączaniem się między wieloma kontami i subskrypcjami.',
            imageModels: 'Modele obrazów',
            videoModels: 'Modele wideo',
            musicModels: 'Muzyka AI',
            musicDesc: 'Generuj oryginalną muzykę z opisów',
            filterAll: 'Wszystkie',
            credits: 'Kredyty',
            viewAll: 'Zobacz wszystkie →'
        },
        features: {
            tag: 'Kluczowe funkcje',
            title: 'Twórz oszałamiające obrazy, wideo i muzykę',
            subtitle: 'Od tekstu na obraz, tekstu na wideo po tworzenie muzyki AI, plus precyzyjna edycja i skalowanie HD - tworzenie wszystkiego w jednym.',
            items: {
                textToImage: {
                    tag: 'Tekst na obraz',
                    title: 'Tekst na obraz',
                    desc: 'Wpisz opis, zobacz magię. Niezależnie od tego, czy to hiperrealistyczne portrety czy fantazyjne krajobrazy, użyj Midjourney, Seedream, Nano Banana i innych modeli do generowania wizualnych arcydzieł za pomocą prostych promptów.',
                    cta: 'Generowanie obrazów',
                    imageAlt: 'Generuj wizualne arcydzieła za pomocą prostych promptów używając Midjourney, Seedream, Nano Banana i innych modeli'
                },
                imageEdit: {
                    tag: 'Edycja obrazów i transfer stylu',
                    title: 'Edycja obrazów i transfer stylu',
                    desc: 'Użyj AI do precyzyjnego przekształcania obrazów. Niezależnie od zmiany stylów, modyfikowania obiektów, zastępowania tła czy edycji tekstu - wszystko z wysoką spójnością.',
                    cta: 'Edycja obrazów',
                    beforeAlt: 'Przed edycją obrazu i transferem stylu',
                    afterAlt: 'Po edycji obrazu i transferze stylu'
                },
                textToVideo: {
                    tag: 'Tekst na wideo',
                    title: 'Tekst na wideo',
                    desc: 'Wystarczy wpisać prompty, aby wygenerować filmowe wideo z zsynchronizowanym dźwiękiem, profesjonalną pracą kamery i realistycznym ruchem. Wybieraj spośród modeli Veo, Sora, Kling, Seedance i Wan.',
                    cta: 'Generowanie wideo'
                },
                imageToVideo: {
                    tag: 'Obraz na wideo',
                    title: 'Obraz na wideo',
                    desc: 'Zamień statyczne obrazy w filmowe wideo. Niezależnie od zdjęć produktowych, ilustracji czy obrazów wygenerowanych przez AI - ożywij je naturalnym ruchem i lektorem.',
                    cta: 'Animacja obrazów'
                },
                upscale: {
                    tag: 'Skalowanie HD',
                    title: 'Skalowanie HD',
                    desc: 'Użyj AI do poprawy jakości obrazów i wideo. Obsługuj bezstratne skalowanie HD i poprawiaj rozdzielczość wideo do profesjonalnego poziomu 4K.',
                    cta: 'Skaluj teraz',
                    imageAlt: 'Użyj AI do poprawy jakości obrazów i wideo'
                },
                templates: {
                    tag: 'Ponad 40 szablonów obrazów',
                    title: 'Ponad 40 szablonów obrazów',
                    desc: 'Ogromna kolekcja szablonów dla inspiracji: modele 3D, styl Ghibli, zabawki projektanta, generator memów, okładki magazynów i nie tylko - prześlij zdjęcie, natychmiastowe wyniki.',
                    cta: 'Przeglądaj szablony',
                    imageAlt: 'Przykład szablonu obrazu'
                }
            }
        },
        gallery: {
            tag: 'Galeria',
            title: 'Odkryj nieskończone możliwości',
            subtitle: 'Zobacz, co twórcy budują z Miral - od hiperrealistycznych obrazów po filmowe wideo, inspiracja w zasięgu ręki.',
            images: {
                alt1: 'Przykład wygenerowanego obrazu Midjourney',
                alt2: 'Przykład wygenerowanego obrazu Seedream',
                alt3: 'Przykład wygenerowanego obrazu GPT-Image-1',
                alt4: 'Przykład wygenerowanego obrazu Flux',
                alt5: 'Przykład wygenerowanego obrazu Flux Pro',
                alt6: 'Przykład wygenerowanego obrazu Midjourney',
                alt7: 'Przykład wygenerowanego obrazu Seedream',
                alt8: 'Przykład wygenerowanego obrazu GPT-Image-1'
            }
        },
        whyChoose: {
            tag: 'Dlaczego Miral',
            title: 'Wszystko w jednym do tworzenia, wszystko czego potrzebujesz',
            subtitle: 'Platforma typu wszystko w jednym, łącząca najlepsze na świecie modele AI do tworzenia obrazów, wideo i muzyki.',
            items: {
                allModels: {
                    title: 'Wszystkie modele zintegrowane, jeden wystarczy',
                    desc: 'Jednokrotny dostęp do ponad 29 najlepszych modeli AI od OpenAI, Google, Alibaba, ByteDance i innych. Nie trzeba przełączać się między narzędziami ani zarządzać wieloma subskrypcjami.'
                },
                fast: {
                    title: 'Błyskawicznie szybki',
                    desc: 'Większość generowania obrazów kończy się w ciągu 30 sekund, generowanie wideo zajmuje około 1-6 minut. Zoptymalizowana infrastruktura zapewnia brak długiego czekania.'
                },
                credits: {
                    title: 'Prosty system kredytów',
                    desc: 'Płać za to, co zużywasz, przejrzyste ceny. Zacznij od darmowych kredytów - nie potrzebujesz subskrypcji, aby zacząć tworzyć.'
                },
                api: {
                    title: 'API dla deweloperów',
                    desc: 'Zintegruj generowanie obrazów, wideo i muzyki AI bezpośrednio z aplikacjami za pomocą naszego kompleksowego API. Zbuduj swój produkt na najlepszych modelach AI.'
                }
            }
        },
        testimonials: {
            tag: 'Opinie użytkowników',
            title: 'Zaufali nam twórcy z całego świata',
            subtitle: 'Dołącz do tysięcy profesjonalistów i twórców używających Miral do generowania obrazów, tworzenia wideo i napędzania swoich kreatywnych przepływów pracy.'
        },
        faq: {
            tag: 'Wsparcie',
            title: 'Często zadawane pytania',
            subtitle: 'Kompleksowy przewodnik po platformie, obsługiwanych modelach, planach cenowych i funkcjach.'
        },
        cta: {
            title: 'Rozpocznij swoją podróż z tworzeniem AI już teraz',
            subtitle: 'Dołącz do tysięcy twórców, projektantów i firm używających Miral do realizacji swojej kreatywności z najlepszymi na świecie modelami AI.',
            createImage: 'Stwórz obraz →',
            createVideo: 'Stwórz wideo →',
            note: 'Nowi użytkownicy otrzymują darmowe kredyty po rejestracji. Karta kredytowa nie jest wymagana.'
        },
        apps: {
            title: "Aplikacje",
            quickTitle: "Szybkie aplikacje AI",
        more: "Więcej",
        keywords: {
            viralVideo: "Viralowe wideo",
            tiktokAds: "Reklamy TikTok",
            productShowcase: "Prezentacja produktu",
            aiAvatar: "Awatar AI",
            homeModernKitchen: "Nowoczesna kuchnia"
        },
            social: 'Media społecznościowe',
            posters: 'Plakaty',
            interior: 'Dom',
            entertainment: 'Rozrywka',
            lifestyle: 'Styl życia',
            comic: 'Komiks',
            items: {
                viralVideo: 'Viraliowe wideo',
                celebrityVideo: 'Wideo celebrytów',
                productShowcase: 'Prezentacja produktu',
                tiktokAds: 'Reklamy TikTok',
                aiMeme: 'AI Memy',
                aiAvatar: 'AI Awatar',
                logoAnimation: 'Animacja logo',
                socialShorts: 'Krótkie formy społecznościowe',
                brandStory: 'Historia marki',
                tutorialClip: 'Klip poradnikowy',
                musicVideo: 'AI Teledysk',
                animeScene: 'Scena anime',
                movieTrailer: 'Zwiastun filmowy',
                gameCinematic: 'Kinematografia gry',
                visualPoetry: 'Wizualna poezja',
                natureDoc: 'Film dokumentalny o naturze',
                cyberpunkCity: 'Cyberpunkowe miasto',
                underwaterWorld: 'Podwodny świat',
                timelapseArt: 'Sztuka timelapse',
                dailyVlog: 'Codzienny vlog',
                cookingShow: 'Program kulinarny',
                fitnessCoach: 'Trener fitness',
                travelDiary: 'Dziennik podróży',
                fashionShow: 'Pokaz mody',
                petParadise: 'Raj zwierzaków',
                weddingMoment: 'Chwila ślubna',
                yogaFlow: 'Joga flow',
                homeDecor: 'Wystrój wnętrz',
                sunsetRun: 'Bieg o zachodzie słońca',
                instagramReels: 'Instagram Reels',
                youtubeIntro: 'Intro YouTube',
                linkedinPromo: 'Promo LinkedIn',
                aiThumbnail: 'AI Miniatura',
                podcastClip: 'Klip podcastowy',
                horrorShort: 'Krótki horror',
                danceVideo: 'Wideo taneczne',
                aiComic: 'AI Komiks',
                magicShow: 'Pokaz magii',
                fantasyWorld: 'Świat fantasy',
                diyCraft: 'Zrób to sam',
                morningRoutine: 'Poranna rutyna',
                babyGrowth: 'Wzrost dziecka',
                streetFood: 'Jedzenie uliczne',
                bookTrailer: 'Zwiastun książki',
                socialLuxuryBag: 'Premiera Luksusowej Torby',
                socialFashionVote: 'Głosowanie na Modę',
                socialSneakerDrop: 'Miejskie Buty Premium',
                socialTropicalCocktail: 'Weekendowy Koktajl',
                socialCityBillboard: 'Reklama na Bilbordzie Miejskim',
                socialStreetwearDrop: 'Premiera Streetwear',
                socialBoxingGloves: 'Reklama Rękawic Bokserskich',
                homeEclecticLiving: 'Eklektyczny Salon',
                homeFarmhouseKitchen: 'Kuchnia Wiejska',
                homeModernKitchen: 'Nowoczesna Minimalistyczna Kuchnia',
                homeVictorianStairs: 'Wiktoriańskie Schody',
                homeScandiLiving: 'Skandynawski Salon',
                homeMediterraneanPatio: 'Śródziemnomorski Patio',
                homeBohoSunroom: 'Boho Ogród Zimowy',
                homeEclecticBedroom: 'Eklektyczna Sypialnia',
                comicPortrait: 'Komiks Superbohatera',
                animeCharacter: 'Anime Mecha',
                mangaScene: 'Manga Deszczowa Noc',
                comicOilPainting: 'Komiks Codzienny',
                comicCover: 'Komiks Bohatera Energii',
                animePortrait: 'Komiks Skok po Dachach',
                comicCouple: 'Komiks Młodego Bohatera',
                mangaWarrior: 'Komiks Czarnoksiężnika'
            }
        }
    },
    musicTags: {
        pop: 'Pop',
        electronic: 'Elektroniczna',
        classical: 'Klasyczna',
        jazz: 'Jazz'
    },
    music: {
        breadcrumb: {
            home: 'Strona główna',
            aiMusic: 'Muzyka AI'
        },
        model: {
            label: 'Model',
            aiMusicName: 'Muzyka AI',
            desc: 'Generuj oryginalną muzykę z opisów, obsługując różne style i czasy trwania.',
            tagMusic: 'Generowanie muzyki',
            tagLyrics: 'Tworzenie tekstów'
        },
        mode: {
            describe: 'Opisz',
            lyrics: 'Napisz tekst'
        },
        form: {
            musicDesc: 'Opis muzyki',
            musicDescPlaceholder: 'Opisz styl muzyki, emocje i scenę, jakiej chcesz...\n\nPrzykład: Wesoła muzyka elektroniczna z futurystycznymi melodiami syntezatora, odpowiednia do filmów promocyjnych produktów technologicznych',
            optimize: 'Optymalizuj',
            songTitle: 'Tytuł utworu',
            songTitlePlaceholder: 'Wpisz tytuł utworu...',
            lyricsDescLabel: 'Opis tekstów',
            lyricsDescPlaceholder: 'Napisz tutaj opis swoich tekstów...\n\nPrzykład:\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...',
            styleTags: 'Tagi stylu',
            styleTagsPlaceholder: 'Kliknij tagi poniżej, aby dodać (wielokrotny wybór)'
        },
        tags: {
            sections: [
                {label: 'Zwrotka', value: '[Verse]\n'},
                {label: 'Refren', value: '[Chorus]\n'},
                {label: 'Most', value: '[Bridge]\n'},
                {label: 'Intro', value: '[Intro]\n'},
                {label: 'Outro', value: '[Outro]\n'}
            ],
            styles: [
                {label: 'Pop', value: 'Pop'},
                {label: 'Rock', value: 'Rock'},
                {label: 'Jazz', value: 'Jazz'},
                {label: 'Klasyczna', value: 'Classical'},
                {label: 'Elektroniczna', value: 'Electronic'},
                {label: 'R&B', value: 'R&B'},
                {label: 'Hip-Hop', value: 'Hip-Hop'},
                {label: 'Country', value: 'Country'},
                {label: 'Folk', value: 'Folk'},
                {label: 'Ambient', value: 'Ambient'},
                {label: 'Filmowa', value: 'Cinematic'},
                {label: 'Lo-fi', value: 'Lo-fi'},
                {label: 'Metal', value: 'Metal'},
                {label: 'Reggae', value: 'Reggae'},
                {label: 'Blues', value: 'Blues'},
                {label: 'Soul', value: 'Soul'},
                {label: 'Funk', value: 'Funk'},
                {label: 'Indie', value: 'Indie'}
            ]
        },
        options: {
            duration: 'Czas trwania',
            instrumental: 'Instrumentalny',
            instrumentalDescOn: 'Generuj tylko akompaniament, bez wokalu',
            instrumentalDescOff: 'Uwzględnij wokal'
        },
        errors: {
            titleRequired: 'Tytuł utworu jest wymagany',
            lyricsDescRequired: 'Opis tekstu jest wymagany'
        },
        footer: {
            creditsRequired: 'Wymagane kredyty:',
            creditsLeft: 'Pozostało:',
            generate: 'Generuj muzykę'
        },
        preview: {
            generating: 'Generowanie muzyki...',
            generatedTitle: 'Wygenerowana muzyka',
            emptyTitle: 'Generator muzyki AI',
            emptySubtitle: 'Twórz oryginalną muzykę z AI. Opisz styl lub wpisz teksty, i wygeneruj własną piosenkę w kilka sekund.',
            emptyTags: ['Pop', 'Jazz', 'Filmowa', 'Lo-fi', 'Rock'],
            track: 'Utwór',
            play: 'Odtwórz',
            pause: 'Wstrzymaj',
            mute: 'Wycisz',
            unmute: 'Włącz dźwięk',
            download: 'Pobierz',
            showLyrics: 'Pokaż tekst',
            hideLyrics: 'Ukryj tekst',
            generateFailed: 'Generowanie nie powiodło się',
            requestFailed: 'Żądanie nie powiodło się, spróbuj ponownie',
            downloadMp3: 'Pobierz MP3',
            downloadWav: 'Pobierz WAV',
            regenerate: 'Regeneruj',
            noHistory: 'Brak historii'
        },
        intro: {
            title: 'Generator muzyki AI',
            desc: 'Wykorzystując zaawansowaną technologię AI, wystarczy wpisać opis lub teksty, aby wygenerować wysokiej jakości oryginalną muzykę. Obsługuje wiele stylów muzycznych, odpowiednia do ścieżek dźwiękowych wideo, reklam, podcastów i nie tylko.',
            tagMusic: 'Generowanie muzyki',
            tagLyrics: 'Tworzenie tekstów',
            tagStyles: 'Wiele stylów',
            tagCommercial: 'Licencja komercyjna'
        },
        features: {
            badge: 'Kluczowe funkcje',
            title: 'Co może dla Ciebie zrobić generator muzyki AI?',
            items: {
                styles: {
                    icon: '🎵',
                    title: 'Wiele stylów',
                    desc: 'Obsługuje Pop, Rock, Elektroniczną, Jazz, Klasyczną, Hip-Hop i dziesiątki innych stylów muzycznych, aby sprostać różnym potrzebom kreatywnym.'
                },
                lyrics: {
                    icon: '📝',
                    title: 'Tworzenie tekstów',
                    desc: 'Wpisz teksty, aby wygenerować kompletne piosenki ze znacznikami sekcji (Zwrotka, Refren itp.), AI automatycznie aranżuje i produkuje muzykę.'
                },
                vocals: {
                    icon: '🎤',
                    title: 'Synteza wokalu',
                    desc: 'Obsługuje męskie i żeńskie wokale o różnych barwach, AI śpiewa Twoje teksty z naturalnymi i płynnymi wynikami.'
                },
                instrumental: {
                    icon: '🎹',
                    title: 'Tryb instrumentalny',
                    desc: 'Generuj wysokiej jakości akompaniament instrumentalny, odpowiedni do ścieżek dźwiękowych wideo, muzyki tła do podcastów i nie tylko.'
                },
                fast: {
                    icon: '⚡',
                    title: 'Szybkie generowanie',
                    desc: 'Zaawansowane modele AI zapewniają szybką produkcję muzyki, większość muzyki może być wygenerowana w ciągu 30 sekund.'
                },
                commercial: {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Cała wygenerowana muzyka może być używana do celów komercyjnych, w tym wideo, reklam, podcastów i nie tylko.'
                }
            }
        },
        faq: {
            title: 'Często zadawane pytania',
            items: {
                howItWorks: {
                    q: 'Jak działa generator muzyki AI?',
                    a: 'Nasz generator muzyki AI wykorzystuje zaawansowane modele głębokiego uczenia do tworzenia oryginalnej muzyki na podstawie Twoich opisów tekstowych lub tekstów piosenek. Wystarczy wpisać styl muzyki, emocje i opis sceny, a AI automatycznie skomponuje kompletny utwór muzyczny.'
                },
                commercial: {
                    q: 'Czy wygenerowana muzyka może być używana do celów komercyjnych?',
                    a: 'Tak, cała muzyka wygenerowana za pomocą naszej platformy może być używana do celów komercyjnych, w tym wideo YouTube, reklam, podcastów, gier i nie tylko.'
                },
                styles: {
                    q: 'Jakie style muzyczne są obsługiwane?',
                    a: 'Obsługujemy Pop, Rock, Elektroniczną, Jazz, Klasyczną, Hip-Hop, R&B, Country, Metal, Folk i dziesiątki innych stylów muzycznych. Możesz również łączyć wiele stylów, aby stworzyć unikalną muzykę.'
                },
                credits: {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'W zależności od wybranego modelu, każde generowanie kosztuje 8-10 kredytów. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                download: {
                    q: 'Czy mogę pobrać wygenerowaną muzykę?',
                    a: 'Tak, wygenerowana muzyka obsługuje pobieranie w formatach MP3 i WAV. Możesz wybrać odpowiedni format w zależności od potrzeb.'
                }
            }
        },
        demoTracks: {
            summerBreeze: {title: 'Letnia bryza', style: 'Pop / Wesoła', duration: '2:00'},
            spaceJourney: {title: 'Kosmiczna podróż', style: 'Elektroniczna / Futurystyczna', duration: '1:30'},
            rainWalk: {title: 'Spacer w deszczu', style: 'Jazz / Zrelaksowana', duration: '2:30'},
            mountainDawn: {title: 'Świt w górach', style: 'Klasyczna / Spokojna', duration: '3:00'}
        }
    },
    pricing: {
        title: 'Nielimitowana inspiracja, wybierz plan, który najlepiej do Ciebie pasuje',
        subtitle: 'Odblokuj wszystkie modele AI, wsadowo generuj obrazy, wideo i muzykę.',
        promo: 'Oferta ograniczona czasowo - zaoszczędź 30% na planach rocznych',
        monthly: 'Miesięcznie',
        yearly: 'Rocznie',
        yearlyNote: 'Plan roczny - kredyty dostarczane od razu, jednorazowa płatność bardziej opłacalna',
        popular: 'Najpopularniejszy',
        currentPlan: 'Obecny plan',
        currentPlanBtn: 'Obecny plan',
        upgrade: 'Ulepsz',
        unavailable: 'Niedostępny',
        upgradeSuccess: 'Ulepszenie zakończone sukcesem!',
        upgradeFailed: 'Ulepszenie nie powiodło się',
        upgradeModal: {
            title: 'Potwierdź ulepszenie',
            item1: 'Pobieremy różnicę cenową z Twojej karty.',
            item2: 'Po udanej płatności dodatkowe saldo zostanie dodane automatycznie.',
            item3: 'Nowy plan wchodzi w życie po udanej płatności.',
            tip: 'Wskazówka: Upewnij się, że Twoja metoda płatności jest ważna. Saldo aktualizuje się w ciągu kilku sekund po płatności.',
            cancel: 'Anuluj',
            confirm: 'Potwierdź ulepszenie'
        },
        subscribe: 'Subskrybuj teraz',
        processing: 'Przetwarzanie...',
        creditsPer: 'kredytów /',
        extraCredits: 'dodatkowe kredyty',
        creditsRate: '100 kredytów = $',
        perMonth: 'miesiąc',
        perYear: 'rok',
        yearlyBilling: 'Rozliczane rocznie',
        saveVsMonthly: 'Oszczędność względem miesięcznego:',
        planDesc: {
            basic: 'Idealny na start',
            pro: 'Najlepszy dla twórców i profesjonalistów',
            ultimate: 'Dla zespołów i zaawansowanych użytkowników'
        },
        creditsPack: {
            title: 'Kup pakiet kredytów',
            subtitle: 'Jednorazowy zakup, bez subskrypcji',
            buy: 'Kup kredyty',
            oneTime: 'Jednorazowy zakup',
            permanent: 'Kredyty nigdy nie wygasają',
            tip: 'Wskazówka: Subskrypcje są bardziej opłacalne',
            tipItems: ['Niższe stawki kredytowe (oszczędź 40-60%)', '15% zniżki na wszystkie pakiety kredytów']
        },
        security: {
            noTraining: 'Nie używane do trenowania AI',
            encrypted: 'Szyfrowane przechowywanie',
            gdpr: 'Zgodny z RODO',
            delete: 'Samodzielne usuwanie konta'
        },
        dataSafety: 'Dowiedz się o naszym zobowiązaniu do bezpieczeństwa danych →',
        allPlansInclude: 'Wszystkie plany obejmują',
        includes: {
            models: 'Modele AI premium',
            fast: 'Szybkie generowanie',
            privacy: '100% prywatności',
            commercial: 'Użytek komercyjny'
        },
        creditsInfo: {
            title: 'Przewodnik po kredytach',
            subtitle: 'Zobacz zużycie kredytów dla wszystkich modeli',
            model: 'Model',
            type: 'Typ',
            cost: 'Koszt kredytów',
            speed: 'Prędkość',
            image: 'Obraz',
            video: 'Wideo'
        },
        questions: 'Pytania?',
        contact: 'Potrzebujesz pomocy?',
        contactUs: 'Skontaktuj się z nami',
        faq: {
            items: [
                {
                    q: 'Co mogę stworzyć za pomocą kredytów?',
                    a: 'Kredytów można użyć do generowania obrazów, wideo i muzyki AI. Generowanie obrazów zaczyna się od 2 kredytów, generowanie wideo od 10 kredytów, a muzyki po 10 kredytów na utwór. Modele premium mogą zużywać więcej kredytów.'
                },
                {
                    q: 'Czy mogę anulować w dowolnym momencie?',
                    a: 'Tak, możesz anulować subskrypcję w dowolnym momencie. Możesz kontynuować korzystanie z usługi do końca bieżącego okresu rozliczeniowego.'
                },
                {
                    q: 'Co jeśli skończą mi się kredyty?',
                    a: 'Możesz kupić jednorazowe pakiety kredytów w dowolnym momencie (bez subskrypcji). Subskrybenci otrzymują 15% zniżki na pakiety kredytów. Możesz również ulepszyć plan, aby uzyskać lepsze stawki na miesięczne limity.'
                },
                {
                    q: 'Czy istnieje polityka zwrotów?',
                    a: 'Tak. Przy pierwszym zakupie jednorazowych pakietów lub pierwszej subskrypcji możesz poprosić o zwrot środków w ciągu 7 dni kalendarzowych, jeśli zużycie kredytów jest poniżej 3%.'
                }
            ]
        }
    },
    modelDetail: {
        breadcrumb: {
            home: 'Strona główna',
            models: 'Modele'
        },
        model: 'Model',
        modelVersion: 'Wersja modelu',
        standard: 'Standardowy',
        pro: 'Pro',
        standardDesc: 'Standardowa jakość, szybkie generowanie',
        proDesc: 'Wysoka jakość, obsługa wysokiej rozdzielczości',
        credits: 'kredytów',
        imagePrompt: 'Prompt obrazu',
        imagePromptPlaceholder: 'Opisz obraz, który chcesz wygenerować...',
        videoPrompt: 'Prompt wideo',
        videoPromptPlaceholder: 'Opisz wideo, które chcesz wygenerować...',
        referenceImage: 'Obraz referencyjny',
        aspectRatio: 'Proporcje obrazu',
        thinkingLevel: 'Poziom myślenia',
        thinkingMinimal: 'Niskie opóźnienie',
        thinkingHigh: 'Wysoka wierność',
        referenceImageFormats: 'PNG, JPG, JPEG, WEBP',
        uploadImageHint: 'PNG, JPG, JPEG, WEBP',
        nanoBanana2EmptyPreview: 'Podgląd oficjalnego wyjścia obrazu Nano Banana 2',
        characters: 'znaków',
        imageSize: 'Rozmiar obrazu',
        auto: 'Automatyczny',
        resolution: 'Rozdzielczość',
        duration: 'Czas trwania',
        seconds: 'sekund',
        creditsRequired: 'Wymagane kredyty:',
        creditsRemaining: 'Pozostało:',
        remaining: 'Pozostało:',
        generate: 'Generuj',
        getMoreCredits: 'Uzyskaj więcej kredytów',
        generating: 'Generowanie...',
        demoPrompt: 'Prompt demonstracyjny',
        modelLabel: 'Model:',
        version: 'Wersja:',
        size: 'Rozmiar:',
        download: 'Pobierz',
        regenerate: 'Regeneruj',
        noHistory: 'Brak historii generowania',
        features: {
            badge: 'Kluczowe funkcje',
            title: 'Co potrafi ten model?',
            items: {
                realistic: {
                    icon: '📷',
                    title: 'Filmowy realizm',
                    desc: 'Twórz wysokowierniste realistyczne obrazy z naturalnymi odcieniami skóry, bogatymi teksturami materiałów i wiarygodnym oświetleniem filmowym.'
                },
                artistic: {
                    icon: '🎨',
                    title: 'Styl artystyczny',
                    desc: 'Twórz artystyczne obrazy w różnych stylach malarskich.'
                },
                portrait: {
                    icon: '👤',
                    title: 'Portret',
                    desc: 'Profesjonalna fotografia portretowa z naturalnymi odcieniami skóry.'
                },
                landscape: {icon: '🏔️', title: 'Krajobraz', desc: 'Oszałamiająca fotografia krajobrazowa i przyrodnicza.'},
                product: {icon: '📦', title: 'Produkt', desc: 'Wysokiej jakości fotografia produktowa dla e-commerce.'},
                fast: {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 10-30 sekund.'},
                highRes: {icon: '🖼️', title: 'Wysoka rozdzielczość', desc: 'Obsługa wyjścia do rozdzielczości 4K.'},
                cinematic: {
                    icon: '🎬',
                    title: 'Filmowy',
                    desc: 'Twórz filmowe wideo z profesjonalną pracą kamery.'
                },
                audioSync: {icon: '🔊', title: 'Synchronizacja audio', desc: 'Natywna synchronizacja audio-wideo dla filmów.'},
                lipSync: {icon: '👄', title: 'Synchronizacja ust', desc: 'Precyzyjna synchronizacja ust dla wideo z postaciami.'},
                animation: {icon: '🎭', title: 'Animacja', desc: 'Płynna animacja i ruch postaci.'},
                longVideo: {icon: '⏱️', title: 'Długie wideo', desc: 'Obsługa dłuższych czasów trwania wideo.'},
                privacy: {
                    icon: '🔒',
                    title: 'Prywatność i bezpieczeństwo',
                    desc: 'Wszystkie dane są szyfrowane w tranzycie i nie są używane do trenowania AI. Twoje kreacje należą do Ciebie.'
                }
            }
        },
        whyChoose: {
            items: [
                'Inteligentne tworzenie napędzane przez {name}',
                'Szybko i efektywnie wykonuj złożone zadania kreatywne',
                'Wygenerowana treść może być używana komercyjnie',
                'Ciągłe aktualizacje i poprawa możliwości',
                'Ujednolicony system kredytów, płać za to, co zużywasz'
            ]
        },
        faq: {
            title: 'Często zadawane pytania',
            imageType: 'obrazy',
            videoType: 'wideo',
            imageFormats: 'Obsługiwane formaty wyjściowe PNG, JPEG i WebP; wybierz odpowiedni do Twojego przepływu pracy.',
            videoFormats: 'Wideo jest dostarczane jako MP4 z opcjami 480p i 720p oraz wieloma proporcjami obrazu.',
            items: [
                {
                    q: 'Jak działa {name}?',
                    a: 'Prześlij referencję lub wpisz prompt tekstowy - {name} generuje wysokiej jakości {type} na podstawie Twojego wejścia. Proces jest prosty i nie wymaga specjalistycznych umiejętności.'
                },
                {
                    q: 'Czy mogę używać wygenerowanych {type} komercyjnie?',
                    a: 'Tak. Treść z {name} może być używana komercyjnie, w tym w marketingu, mediach społecznościowych i zastosowaniach produktowych.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Każde generowanie za pomocą {name} zużywa {credits} kredytów. Subskrybenci otrzymują lepsze stawki kredytowe.'
                },
                {
                    q: 'Jak szybkie jest generowanie?',
                    a: 'Typowa prędkość dla {name} to {speed}. stale optymalizujemy, aby zapewnić niezawodne, szybkie wyniki.'
                },
                {q: 'Jakie formaty wyjściowe są obsługiwane?', a: ''}
            ]
        },
        qwenImage20Pro: {
            negativePromptLabel: 'Negatywny prompt (opcjonalnie)',
            negativePromptPlaceholder: 'Opisz, co nie powinno się pojawić (np. niska przejrzystość, zniekształcone dłonie itp.)',
            customWidth: 'Szerokość',
            customHeight: 'Wysokość',
            sizeHint: 'Zakres: 512x512 do 2048x2048',
            sizeErrorRequired: 'Wpisz szerokość i wysokość',
            sizeErrorInteger: 'Szerokość i wysokość muszą być liczbami całkowitymi',
            sizeErrorRange: 'Rozdzielczość musi być między 512x512 a 2048x2048',
            promptEnhanceTitle: 'Ulepszenie promptu',
            promptEnhanceDesc: 'Ulepsz szczegóły promptu dla bogatszych wyników',
            watermarkTitle: 'Znak wodny',
            watermarkDesc: 'Dodaj znak wodny do wygenerowanych obrazów',
            demoPromptText: 'Pośród zaśnieżonych gór mały chłopiec w sprzęcie narciarskim i goglach szczęśliwie zjeżdża na nartach; kryształy śniegu dryfują wzdłuż jego śladu, a za nim ciągną się bezkresne ośnieżone grzbiety.',
            faqSizeSupportQ: 'Jakie rozmiary są obsługiwane?',
            faqSizeSupportA: 'Wpisz szerokość i wysokość w zakresie 512~2048 (np. 2048*2048).',
            faqMaxCountQ: 'Ile obrazów można wygenerować maksymalnie?',
            faqMaxCountA: 'Do 4 obrazów (n=1..4).',
            faqLinkUsageQ: 'Jak korzystać z linków do obrazów po generowaniu?',
            faqLinkUsageA: 'Najpierw pobiera tymczasowy URL zwrócony przez DashScope, przesyła go na nasz serwer i zwraca długotrwały dostępny URL.'
        },
        zImageTurbo: {
            promptExtendTitle: 'Ulepszenie promptu',
            promptExtendDesc: 'Ulepsz szczegóły promptu dla bogatszych wyników',
            customWidth: 'Szerokość',
            customHeight: 'Wysokość',
            sizeHint: 'Zakres: 512x512 do 2048x2048',
            sizeErrorRequired: 'Wpisz szerokość i wysokość',
            sizeErrorInteger: 'Szerokość i wysokość muszą być liczbami całkowitymi',
            sizeErrorRange: 'Rozdzielczość musi być między 512x512 a 2048x2048',
            seedLabel: 'Ziarno',
            seedErrorRequired: 'Wpisz ziarno',
            seedErrorInteger: 'Ziarno musi być liczbą całkowitą',
            seedErrorRange: 'Ziarno musi być między 0 a 2147483647',
            tagQuality: 'Wysoka jakość',
            tagOfficial: 'Bezpośredni oficjalny',
            tagHighRes: 'Wysoka rozdzielczość',
            tagSeed: 'Kontrola ziarna',
            tagPromptExtend: 'Ulepszenie promptu',
            feature1Title: 'Wysokiej jakości wyjście',
            feature1Desc: 'Generuj obrazy w wysokiej rozdzielczości i przesyłaj je jako długotrwałe dostępne URL.',
            feature2Title: 'Niestandardowa rozdzielczość',
            feature2Desc: 'Wpisz szerokość i wysokość w zakresie 512-2048.',
            feature3Title: 'Kontrolowane generowanie',
            feature3Desc: 'Obsługuje ziarno i ulepszenie promptu dla powtarzalności i dostrajania.',
            demoPromptText: 'Na drobnym złotym piasku wyraźny ślad stóp prowadzi głębiej w kadr; krawędzie pokazują wilgotny, ziarnisty piasek, powierzchnia błyszczy w świetle słonecznym, przyciągając wzrok do odległej latarni morskiej.',
            faqSizeSupportQ: 'Jakie rozmiary są obsługiwane?',
            faqSizeSupportA: 'Wpisz szerokość i wysokość w zakresie 512-2048 (np. 1024*1536).',
            faqSeedQ: 'Do czego służy ziarno?',
            faqSeedA: 'Przy tym samym prompcie i parametrach ziarno pomaga odtworzyć podobne wyniki.',
            faqPromptExtendQ: 'Co to jest ulepszenie promptu?',
            faqPromptExtendA: 'Po włączeniu ulepsza szczegóły promptu dla bogatszych wyników.'
        }
    },
    modelIntro: {
        common: {
            videoMode: 'Tryb wideo',
            textToVideo: 'Tekst na wideo',
            imageToVideo: 'Obraz na wideo',
            referenceImage: 'Obraz referencyjny',
            referenceAudio: 'Audio referencyjne',
            negativePrompt: 'Negatywny prompt',
            duration: 'Czas trwania',
            resolution: 'Rozdzielczość',
            aspectRatio: 'Proporcje obrazu',
            seed: 'Ziarno',
            generateAudio: 'Generuj audio',
            watermark: 'Dodaj znak wodny',
            endFrame: 'Klatka końcowa',
            promptEnhance: 'Ulepsz prompt',
            promptExtend: 'Rozszerzenie promptu',
            imageSize: 'Rozmiar obrazu',
            imageCount: 'Liczba obrazów',
            style: 'Styl',
            sizeMode: 'Tryb rozmiaru',
            width: 'Szerokość',
            height: 'Wysokość',
            optional: 'Opcjonalne',
            uploading: 'Przesyłanie...',
            clickToUpload: 'Kliknij, aby przesłać',
            quality: 'Jakość',
            qualityAuto: 'Automatyczna',
            qualityLow: 'Niska',
            qualityMedium: 'Średnia',
            qualityHigh: 'Wysoka',
            multipleOf64Hint: 'Szerokość i wysokość muszą być wielokrotnością 64.'
        },
        seegen: {
            aspectAdaptive: 'Automatyczny',
            genMode: 'Tryb generowania',
            modeStand: 'Standardowy',
            modeSpeed: 'Szybki'
        },
        pollodance: {
            variantLabel: 'Wariant modelu',
            card20: '2.0',
            card20Fast: '2.0 SZYBKI',
            card20Ref: '2.0 REF',
            card20FastRef: '2.0 SZYBKI REF',
            opt20Desc: 'Zaawansowana kontrola ruchu, filmowy transfer stylu i generowanie klasy przemysłowej.',
            opt20FastDesc: 'Szybkie generowanie z niskim opóźnieniem.',
            opt20RefDesc: 'Silna kontrola referencyjna: transfer stylu i śledzenie obiektu.',
            opt20FastRefDesc: 'Szybkie generowanie plus precyzyjna kontrola referencyjna.',
            refImages: 'Obrazy referencyjne',
            refVideo: 'Wideo referencyjne',
            refAudio: 'Audio referencyjne',
            webSearch: 'Wyszukiwanie w sieci'
        },
        nanoBanana: {
            version: 'Wersja modelu',
            title: 'Generator obrazów AI Nano Banana Pro',
            desc: 'Nano Banana to wysokowydajny model generowania obrazów AI, który obsługuje generowanie obrazów w realistycznym stylu, doskonale radząc sobie z portretami i scenami naturalnymi. Dostępny w wersjach Standard i Pro, aby sprostać różnym potrzebom.',
            v25Type: 'Niskie opóźnienie',
            v25TypeBadge: 'Szybki',
            v25TypeDesc: 'Stała rozdzielczość 1024px, szybka prędkość generowania',
            v31Type: 'Wysoka wierność',
            v31TypeBadge: 'Jakość',
            v31TypeDesc: 'Obsługuje wiele rozdzielczości 1K / 2K / 4K',
            demoPrompt: 'Filmowy portret kobiety w świetle złotej godziny, z naturalną teksturą skóry i miękkim tłem bokeh',
            multiSize: 'Wiele rozmiarów',
            multiSizeDesc: 'Obsługuje automatyczny, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 i inne rozmiary obrazów.',
            featuresDesc: 'Nano Banana zapewnia możliwości generowania obrazów wysokiej jakości z wieloma opcjami rozmiaru i rozdzielczości.',
            flexiblePricing: 'Elastyczne ceny',
            flexiblePricingDesc: 'Standard 5 kredytów, Pro 20 kredytów, wybierz według potrzeb.',
            commercial: 'Licencja komercyjna',
            commercialDesc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.',
            enterPrompt: 'Wpisz prompt',
            generateFailed: 'Generowanie nie powiodło się',
            requestFailed: 'Żądanie nie powiodło się, spróbuj ponownie',
            faq: [
                {
                    q: 'Jaka jest różnica między wersjami Standard i Pro?',
                    a: 'Wersja Standard nadaje się do szybkiego generowania obrazów standardowej jakości, zużywając 5 kredytów. Wersja Pro obsługuje wyższe rozdzielczości (1K/2K/4K) z lepszą jakością obrazu, zużywając 20 kredytów.'
                },
                {
                    q: 'Jak działa Nano Banana?',
                    a: 'Wystarczy wpisać opis tekstowy, a model Nano Banana wygeneruje wysokiej jakości obrazy w realistycznym stylu na podstawie Twojego promptu.'
                },
                {
                    q: 'Jakie rozmiary obrazów są obsługiwane?',
                    a: 'Obsługuje automatyczny, 1:1 (kwadrat), 4:3, 3:4, 16:9 (krajobraz), 9:16 (portret), 3:2, 2:3 i inne rozmiary.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Nano Banana może być używana do celów komercyjnych.'
                }
            ]
        },
        nanoBanana2: {
            genType: 'Wersja generowania'
        },
        seedream: {
            title: 'Generator obrazów AI Seedream 4',
            desc: 'Seedream 4 to zaawansowany model generowania obrazów AI specjalizujący się w artystycznych i kreatywnych obrazach. Idealny do ilustracji, concept artu i stylizowanych grafik.',
            webSearch: 'Wyszukiwanie w sieci',
            webSearchDesc: 'Włącz wyszukiwanie w sieci dla dokładniejszych informacji referencyjnych',
            watermark: 'Dodaj znak wodny',
            watermarkDesc: 'Dodaj znak wodny do wygenerowanych obrazów',
            sizeModeResolution: 'Wg rozdzielczości',
            sizeModeCustom: 'Niestandardowy rozmiar',
            customWidth: 'Szerokość',
            customHeight: 'Wysokość',
            sizeHint: 'Obszar 1024x1024-4096x4096, proporcje 1/16-16',
            sizeErrorArea: 'Obszar musi być między 1024x1024 a 4096x4096',
            sizeErrorRatio: 'Proporcje muszą być między 1/16 a 16',
            demoPromptExample: 'Popołudniowe światło boczne oświetla namiot kempingowy, z wyraźnie widoczną chropowatą teksturą płótna namiotu. Wewnątrz leży owczarek niemiecki; jego właściciel kuca, by podać mu łapę.',
            features: [
                {
                    icon: '🎨',
                    title: 'Styl artystyczny',
                    desc: 'Generuj oszałamiające artystyczne obrazy w różnych stylach malarskich i ilustracyjnych.'
                },
                {icon: '🖼️', title: 'Wysoka rozdzielczość', desc: 'Obsługa do rozdzielczości 4K dla szczegółowych grafik.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 15 sekund.'},
                {icon: '🎭', title: 'Transfer stylu', desc: 'Zastosuj różne style artystyczne do swoich kreacji.'},
                {icon: '📐', title: 'Wiele rozmiarów', desc: 'Obsługa różnych proporcji dla różnych potrzeb.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Do czego najlepiej nadaje się Seedream 4?',
                    a: 'Seedream 4 doskonale radzi sobie z generowaniem artystycznych i kreatywnych obrazów, w tym ilustracji, concept artu i stylizowanych grafik.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Seedream 4 kosztuje 8 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie style są obsługiwane?',
                    a: 'Seedream 4 obsługuje różne style artystyczne, w tym malarstwo olejne, akwarelę, sztukę cyfrową, anime i nie tylko.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Seedream 4 może być używana do celów komercyjnych.'
                }
            ]
        },
        seedream5: {
            title: 'Generator obrazów AI Seedream 5',
            desc: 'Seedream 5 to zaawansowany model generowania obrazów AI specjalizujący się w artystycznych i kreatywnych obrazach. Idealny do ilustracji, concept artu i stylizowanych grafik.',
            webSearch: 'Wyszukiwanie w sieci',
            webSearchDesc: 'Włącz wyszukiwanie w sieci dla dokładniejszych informacji referencyjnych',
            watermark: 'Dodaj znak wodny',
            watermarkDesc: 'Dodaj znak wodny do wygenerowanych obrazów',
            sizeModeResolution: 'Wg rozdzielczości',
            sizeModeCustom: 'Niestandardowy rozmiar',
            customWidth: 'Szerokość',
            customHeight: 'Wysokość',
            sizeHint: 'Obszar 2560x1440-3072x3072, proporcje 1/16-16',
            sizeErrorArea: 'Obszar musi być między 2560x1440 a 3072x3072',
            sizeErrorRatio: 'Proporcje muszą być między 1/16 a 16',
            demoPromptExample: 'Popołudniowe światło boczne oświetla namiot kempingowy, z wyraźnie widoczną chropowatą teksturą płótna namiotu. Wewnątrz leży owczarek niemiecki; jego właściciel kuca, by podać mu łapę.',
            features: [
                {
                    icon: '🎨',
                    title: 'Styl artystyczny',
                    desc: 'Generuj oszałamiające artystyczne obrazy w różnych stylach malarskich i ilustracyjnych.'
                },
                {icon: '🖼️', title: 'Wysoka rozdzielczość', desc: 'Obsługa wyjścia 2K i 3K z bogatymi szczegółami.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 15 sekund.'},
                {icon: '🎭', title: 'Transfer stylu', desc: 'Zastosuj różne style artystyczne do swoich kreacji.'},
                {icon: '📐', title: 'Elastyczne rozmiary', desc: 'Obsługuje predefiniowane rozdzielczości i niestandardowe rozmiary.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Do czego najlepiej nadaje się Seedream 5?',
                    a: 'Seedream 5 doskonale radzi sobie z generowaniem artystycznych i kreatywnych obrazów, w tym ilustracji, concept artu i stylizowanych grafik.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Seedream 5 kosztuje 10 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie rozdzielczości są obsługiwane?',
                    a: 'Obsługuje presety 2K i 3K oraz niestandardowe rozmiary w dozwolonym zakresie obszaru i proporcji.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Seedream 5 może być używana do celów komercyjnych.'
                }
            ]
        },
        midjourney: {
            title: 'Generator obrazów AI Midjourney',
            desc: 'Midjourney to wiodący model generowania obrazów AI znany z wyjątkowej jakości artystycznej i możliwości kreatywnych. Idealny do profesjonalnych grafik i projektów kreatywnych.',
            referenceBoxTitle: 'Dodaj obrazy referencyjne do konwersji obraz na obraz',
            referenceBoxSubtitle: 'Obsługuje PNG, JPEG, WEBP (maks. 100KB). Do 5 obrazów. Mniej obrazów, bardziej precyzyjne wyniki.',
            demoPrompt: 'Tajemnicza pływająca wyspa na niebie, starożytne ruiny pokryte świeczącymi kryształami, wodospady kaskadujące w chmury poniżej, eteryczne oświetlenie, styl fantasy art',
            referenceImages: 'Obrazy referencyjne',
            referenceImagesCount: 'Do 5',
            refImageMaxSize: 'Każdy obraz nie może przekraczać 100KB',
            style: 'Styl',
            styleRealistic: 'Realistyczny',
            styleAnime: 'Anime',
            generationSpeed: 'Prędkość generowania',
            fastDesc: 'Generowanie standardową prędkością',
            turboDesc: 'Szybkie generowanie, priorytetowe przetwarzanie',
            creative: 'Kreatywny',
            highQuality: 'Wysoka jakość',
            fastTurbo: 'Szybki/Turbo',
            creativeGeneration: 'Kreatywne generowanie',
            speed: 'Prędkość',
            features: [
                {
                    icon: '🎨',
                    title: 'Wybitna jakość artystyczna',
                    desc: 'Przemysłowo wiodąca jakość artystyczna i kreatywne wyniki.'
                },
                {
                    icon: '🖼️',
                    title: 'Wysoka rozdzielczość',
                    desc: 'Generuj wysokiej jakości obrazy odpowiednie do profesjonalnego użytku.'
                },
                {icon: '🎭', title: 'Unikalne style', desc: 'Charakterystyczne style artystyczne, które wyróżnią Twoją pracę.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 20 sekund.'},
                {icon: '📐', title: 'Wiele rozmiarów', desc: 'Obsługa różnych proporcji i rozdzielczości.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między Fast i Turbo?',
                    a: 'Tryb Fast kosztuje 10 kredytów ze standardową prędkością. Tryb Turbo kosztuje 20 kredytów z szybszym generowaniem i priorytetowym przetwarzaniem.'
                },
                {
                    q: 'Jak działa Midjourney?',
                    a: 'Wystarczy wpisać opis tekstowy, a Midjourney wygeneruje artystyczne obrazy na podstawie Twojego promptu.'
                },
                {
                    q: 'Jakie rozmiary obrazów są obsługiwane?',
                    a: 'Obsługuje 1:1 (kwadrat), 4:3, 3:4, 16:9 (krajobraz), 9:16 (portret), 3:2, 2:3 i inne rozmiary.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Midjourney może być używana do celów komercyjnych.'
                }
            ]
        },
        gptImage: {
            title: 'Generator obrazów AI GPT-Image-1',
            desc: 'GPT-Image-1 to wszechstronny model generowania obrazów od OpenAI, zdolny do tworzenia szerokiej gamy obrazów z opisów tekstowych. Świetny do ogólnego generowania obrazów.',
            demoPromptExample: 'Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.',
            imageCount: 'Liczba obrazów',
            promptEnhance: 'Ulepszenie promptu',
            promptEnhanceDesc: 'Automatycznie optymalizuj prompty dla lepszych wyników generowania',
            count: 'Liczba',
            multiPurpose: 'Wielozadaniowy',
            batchGeneration: 'Generowanie wsadowe',
            size1024Square: '1024×1024 (kwadrat)',
            size1536Landscape: '1536×1024 (krajobraz)',
            size1024Portrait: '1024×1536 (portret)',
            threeSizes: 'Trzy stałe rozmiary',
            tagQuality: 'Wysoka jakość',
            tagCommercialShort: 'Użytek komercyjny',
            features: [
                {icon: '🎨', title: 'Wszechstronne generowanie', desc: 'Twórz szeroką gamę obrazów do dowolnych celów.'},
                {icon: '🖼️', title: 'Wysoka jakość', desc: 'Generuj wysokiej jakości obrazy z dokładnymi szczegółami.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 15 sekund.'},
                {
                    icon: '📝',
                    title: 'Rozumienie tekstu',
                    desc: 'Doskonałe rozumienie złożonych opisów tekstowych.'
                },
                {
                    icon: '📐',
                    title: 'Trzy stałe rozmiary',
                    desc: '1024×1024 (kwadrat), 1536×1024 (krajobraz), 1024×1536 (portret).'
                },
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa GPT-Image-1?',
                    a: 'Wystarczy wpisać opis tekstowy, a GPT-Image-1 wygeneruje wysokiej jakości obrazy na podstawie Twojego promptu.'
                },
                {
                    q: 'Jakie rozmiary obrazów są obsługiwane?',
                    a: 'Obsługuje trzy stałe rozmiary: 1024×1024 (kwadrat), 1536×1024 (krajobraz) i 1024×1536 (portret).'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą GPT-Image-1 może być używana do celów komercyjnych.'
                }
            ]
        },
        gptImage15: {
            title: 'Generator obrazów AI GPT-Image-1.5',
            desc: 'GPT-Image-1.5 to wszechstronny model generowania obrazów od OpenAI, zdolny do tworzenia szerokiej gamy obrazów z opisów tekstowych. Świetny do ogólnego generowania obrazów.',
            demoPromptExample: 'Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.',
            imageCount: 'Liczba obrazów',
            promptEnhance: 'Ulepszenie promptu',
            promptEnhanceDesc: 'Automatycznie optymalizuj prompty dla lepszych wyników generowania',
            count: 'Liczba',
            multiPurpose: 'Wielozadaniowy',
            batchGeneration: 'Generowanie wsadowe',
            size1024Square: '1024×1024 (kwadrat)',
            size1536Landscape: '1536×1024 (krajobraz)',
            size1024Portrait: '1024×1536 (portret)',
            threeSizes: 'Trzy stałe rozmiary',
            tagQuality: 'Wysoka jakość',
            tagCommercialShort: 'Użytek komercyjny',
            features: [
                {icon: '🎨', title: 'Wszechstronne generowanie', desc: 'Twórz szeroką gamę obrazów do dowolnych celów.'},
                {icon: '🖼️', title: 'Wysoka jakość', desc: 'Generuj wysokiej jakości obrazy z dokładnymi szczegółami.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów generowana w ciągu 15 sekund.'},
                {
                    icon: '📝',
                    title: 'Rozumienie tekstu',
                    desc: 'Doskonałe rozumienie złożonych opisów tekstowych.'
                },
                {
                    icon: '📐',
                    title: 'Trzy stałe rozmiary',
                    desc: '1024×1024 (kwadrat), 1536×1024 (krajobraz), 1024×1536 (portret).'
                },
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane obrazy mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa GPT-Image-1.5?',
                    a: 'Wystarczy wpisać opis tekstowy, a GPT-Image-1.5 wygeneruje wysokiej jakości obrazy na podstawie Twojego promptu.'
                },
                {
                    q: 'Jakie rozmiary obrazów są obsługiwane?',
                    a: 'Obsługuje trzy stałe rozmiary: 1024×1024 (kwadrat), 1536×1024 (krajobraz) i 1024×1536 (portret).'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą GPT-Image-1.5 może być używana do celów komercyjnych.'
                }
            ]
        },
        fluxKontext: {
            title: 'Generator obrazów AI Flux Kontext',
            desc: 'Flux Kontext to zaawansowany model generowania obrazów wysokiej jakości z tekstu, oferujący precyzyjną edycję i wiele stylów wyjściowych.',
            imageCount: 'Liczba obrazów',
            count: 'Liczba',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'Wysoka jakość',
            fastGen: 'Szybkie generowanie',
            multiSize: 'Wiele rozmiarów',
            outputStyle: 'Styl wyjściowy',
            outputStyleDesc: {
                auto: 'Domyślny — model automatycznie określa styl, bez wymuszania wyglądu',
                photographic: 'Fotograficzny — realistyczne zdjęcia, naturalne światło i cienie',
                digital_art: 'Sztuka cyfrowa — wygląd CG/ilustracji, żywe i bogate kolory',
                anime: 'Anime — japoński styl anime/kreskówki, czyste linie'
            },
            outputStyleLabel: {
                auto: 'Domyślny',
                photographic: 'Fotograficzny',
                digital_art: 'Sztuka cyfrowa',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Wysokiej jakości wyniki', desc: 'Generuj szczegółowe, wysokowierne obrazy.'},
                {icon: '🎨', title: 'Tekst na obraz', desc: 'Dokładnie generuj obrazy z opisów tekstowych.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów gotowa w około 15 sekund.'},
                {icon: '📐', title: 'Wiele rozmiarów', desc: 'Obsługa proporcji 1:1, 3:2, 2:3.'},
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowane obrazy mogą być używane do celów komercyjnych.'}
            ],
            faq: [
                {
                    q: 'Jak działa Flux Kontext?',
                    a: 'Wpisz opis tekstowy; Flux Kontext generuje wysokiej jakości obrazy i obsługuje pojedyncze lub wiele obrazów na żądanie.'
                },
                {q: 'Jakie rozmiary obrazów są obsługiwane?', a: 'Obsługuje 1:1 (kwadrat), 3:2 (krajobraz), 2:3 (portret).'},
                {
                    q: 'Czy mogę generować wiele obrazów jednocześnie?',
                    a: 'Tak, możesz generować 1-3 obrazy, każdy rozliczany osobno.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, treść wygenerowana za pomocą Flux Kontext może być używana do celów komercyjnych.'
                }
            ]
        },
        fluxPro11Ultra: {
            title: 'Generator obrazów AI Flux Pro 1.1 Ultra',
            desc: 'Flux Pro 1.1 Ultra do wysokiej jakości generowania obrazów z tekstu z wieloma proporcjami i generowaniem wsadowym.',
            imageCount: 'Liczba obrazów',
            count: 'Liczba',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'Wysoka jakość',
            fastGen: 'Szybkie generowanie',
            multiSize: 'Wiele rozmiarów',
            outputStyle: 'Styl wyjściowy',
            outputStyleDesc: {
                auto: 'Domyślny — model automatycznie określa styl, bez wymuszania wyglądu',
                photographic: 'Fotograficzny — realistyczne zdjęcia, naturalne światło i cienie',
                digital_art: 'Sztuka cyfrowa — wygląd CG/ilustracji, żywe i bogate kolory',
                anime: 'Anime — japoński styl anime/kreskówki, czyste linie'
            },
            outputStyleLabel: {
                auto: 'Domyślny',
                photographic: 'Fotograficzny',
                digital_art: 'Sztuka cyfrowa',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Wysokiej jakości wyniki', desc: 'Generuj szczegółowe, wysokowierne obrazy.'},
                {icon: '🎨', title: 'Tekst na obraz', desc: 'Dokładnie generuj obrazy z opisów tekstowych.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów gotowa w około 15 sekund.'},
                {
                    icon: '📐',
                    title: 'Wiele rozmiarów',
                    desc: 'Obsługa proporcji 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowane obrazy mogą być używane do celów komercyjnych.'}
            ],
            faq: [
                {
                    q: 'Jak działa Flux Pro 1.1 Ultra?',
                    a: 'Wpisz opis tekstowy, aby wygenerować wysokiej jakości obrazy; obsługuje 1-4 obrazy na żądanie.'
                },
                {q: 'Jakie rozmiary obrazów są obsługiwane?', a: 'Obsługuje 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Czy mogę generować wiele obrazów jednocześnie?',
                    a: 'Tak, możesz generować 1-4 obrazy, każdy rozliczany osobno.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, treść może być używana do celów komercyjnych.'
                }
            ]
        },
        fluxSchnell: {
            title: 'Generator obrazów AI Flux Schnell',
            desc: 'Flux Schnell do szybkiego generowania obrazów z tekstu z wieloma proporcjami i generowaniem wsadowym.',
            imageCount: 'Liczba obrazów',
            count: 'Liczba',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            demoPrompt2: 'A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.',
            demoPrompt3: 'A young mother adjusting her baby\'s beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.',
            highQuality: 'Wysoka jakość',
            fastGen: 'Szybkie generowanie',
            multiSize: 'Wiele rozmiarów',
            outputStyle: 'Styl wyjściowy',
            outputStyleDesc: {
                auto: 'Domyślny — model automatycznie określa styl, bez wymuszania wyglądu',
                photographic: 'Fotograficzny — realistyczne zdjęcia, naturalne światło i cienie',
                digital_art: 'Sztuka cyfrowa — wygląd CG/ilustracji, żywe i bogate kolory',
                anime: 'Anime — japoński styl anime/kreskówki, czyste linie'
            },
            outputStyleLabel: {
                auto: 'Domyślny',
                photographic: 'Fotograficzny',
                digital_art: 'Sztuka cyfrowa',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Wysokiej jakości wyniki', desc: 'Generuj szczegółowe, wysokowierne obrazy.'},
                {icon: '🎨', title: 'Tekst na obraz', desc: 'Dokładnie generuj obrazy z opisów tekstowych.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość obrazów gotowa w około 15 sekund.'},
                {
                    icon: '📐',
                    title: 'Wiele rozmiarów',
                    desc: 'Obsługa proporcji 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowane obrazy mogą być używane do celów komercyjnych.'}
            ],
            faq: [
                {
                    q: 'Jak działa Flux Schnell?',
                    a: 'Wpisz opis tekstowy, aby szybko wygenerować wysokiej jakości obrazy; obsługuje 1-4 obrazy na żądanie.'
                },
                {q: 'Jakie rozmiary obrazów są obsługiwane?', a: 'Obsługuje 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Czy mogę generować wiele obrazów jednocześnie?',
                    a: 'Tak, możesz generować 1-4 obrazy, każdy rozliczany osobno.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, treść może być używana do celów komercyjnych.'
                }
            ]
        },
        flux2: {
            title: 'Generator obrazów AI FLUX.2',
            desc: 'FLUX.2 wnosi wydajność klasy enterprise i profesjonalną precyzję do generowania obrazów z tekstu z fotorealistycznymi szczegółami, dokładnymi dłońmi, twarzami i teksturami.',
            variant: 'Wariant modelu',
            variantLabel: 'Wariant modelu',
            variantDesc: {
                'klein-04': 'Czas rzeczywisty',
                'klein-09': 'Zrównoważony',
                'max': 'Najwyższa jakość',
                'pro': 'Produkcyjny',
                'flex': 'Konfigurowalny'
            },
            promptUpsampling: 'Wzbogacanie promptu',
            promptUpsamplingHint: 'Wzbogać szczegóły promptu dla bogatszych wyników (niedostępne dla modeli Klein).',
            steps: 'Kroki',
            stepsHint: 'Więcej kroków daje więcej szczegółów, ale trwa dłużej. Tylko wariant Flex.',
            guidance: 'Prowadzenie',
            guidanceHint: 'Kontroluje, jak ściśle wynik podąża za promptem. Tylko wariant Flex.',
            tagPhotorealism: 'Fotorealizm',
            tagMultilingual: 'Wielojęzyczny',
            tagVariants: '5 wariantów',
            demoPrompt1: 'A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.',
            features: [
                {icon: '✨', title: 'Fotorealistyczne szczegóły', desc: 'Dokładne dłonie, twarze, tkaniny, logotypy i małe obiekty do rozdzielczości 4MP.'},
                {icon: '🎨', title: 'Typografia i projekt', desc: 'Renderuje wyraźną, czytelną typografię i stosuje się do złożonych instrukcji układu.'},
                {icon: '🌍', title: 'Wielojęzyczny', desc: 'Obsługa promptów w języku ojczystym ze najnowocześniejszym podążaniem za instrukcjami.'},
                {icon: '🎯', title: '5 wariantów modelu', desc: 'Klein 4B/9B dla szybkości, Max dla jakości, Pro dla skali, Flex dla niestandardowej kontroli.'},
                {icon: '⚙️', title: 'Elastyczna kontrola', desc: 'Konfigurowalne kroki, prowadzenie, rozmiar i tolerancja bezpieczeństwa dla przepływów produkcyjnych.'}
            ],
            faq: [
                {
                    q: 'Jakie są warianty modelu FLUX.2?',
                    a: 'FLUX.2 oferuje 5 wariantów: Klein 4B i 9B (szybkie, duże wolumeny), Max (najwyższa jakość z wyszukiwaniem ugruntowania), Pro (produkcja na dużą skalę) i Flex (konfigurowalne kroki i prowadzenie).'
                },
                {
                    q: 'Jakie rozmiary obrazów są obsługiwane?',
                    a: 'FLUX.2 używa wymiarów w pikselach (szerokość x wysokość), które muszą być wielokrotnością 16. Presety obejmują 1:1 (1024x1024), 4:3, 3:4, 16:9, 9:16, 21:9 i 9:21.'
                },
                {
                    q: 'Co to jest wzbogacanie promptu?',
                    a: 'Po włączeniu model wewnętrznie wzbogaca Twój prompt dla bogatszych szczegółów. Dostępne dla wariantów Max, Pro i Flex (nie Klein).'
                },
                {
                    q: 'Co to są kroki i prowadzenie w trybie Flex?',
                    a: 'Kroki (1-50) kontrolują jakość wnioskowania - więcej oznacza więcej szczegółów, ale wolniej. Prowadzenie (1.5-10) kontroluje zgodność z promptem - wyższe oznacza bliżej Twojego opisu.'
                },
                {
                    q: 'Czy wygenerowane obrazy mogą być używane komercyjnie?',
                    a: 'Tak, treść może być używana do celów komercyjnych.'
                }
            ]
        },
        seedance: {
            title: 'Generator wideo AI Seedance',
            desc: 'Seedance to model wideo AI nowej generacji obsługujący natywną synchronizację audio-wideo, filmowy ruch i ekspresję emocjonalną. Obejmuje tryby tekst na wideo, obraz na wideo i rozszerzenie wideo.',
            textToVideo: 'Tekst na wideo',
            imageToVideo: 'Obraz na wideo',
            videoExtend: 'Rozszerzenie wideo',
            uploadImage: 'Kliknij, aby przesłać obraz referencyjny',
            uploadHint: 'PNG, JPG, JPEG (maks. 20MB)',
            endFrame: 'Obraz klatki końcowej',
            endFrameHint: '(Opcjonalnie) Prześlij klatkę końcową, aby kontrolować zakończenie wideo',
            uploadEndFrame: 'Kliknij, aby przesłać obraz klatki końcowej',
            uploadVideo: 'Kliknij, aby przesłać wideo referencyjne',
            uploadVideoHint: 'MP4, MOV, WebM (maks. 100MB)',
            videoPrompt: 'Prompt wideo',
            promptPlaceholder: 'Opisz wideo, które chcesz wygenerować...',
            videoPromptPlaceholder: 'Opisz wideo, które chcesz wygenerować...',
            negativePrompt: 'Negatywny prompt',
            negativePromptPlaceholder: 'Opisz, czego nie chcesz w wideo (opcjonalnie)',
            duration: 'Czas trwania',
            videoDuration: 'Czas trwania wideo',
            resolution: 'Rozdzielczość',
            aspectRatio: 'Proporcje obrazu',
            promptEnhance: 'Ulepszenie promptu',
            promptEnhanceDesc: 'Automatycznie optymalizuj prompty dla lepszych wyników generowania',
            generateAudio: 'Generuj audio',
            audioOn: 'Natywne audio (głos + efekty dźwiękowe)',
            audioOff: 'Tylko wideo, bez audio',
            seedValue: 'Wartość ziarna',
            seedHint: 'Wartość ziarna to unikalny identyfikator ogólnego stylu. Użycie tego samego ziarna utrzymuje spójny styl, podczas gdy dostosowywanie innych parametrów pomaga udoskonalić szczegóły wizualne.',
            seedPlaceholder: '-1 (losowo)',
            characters: 'znaków',
            creditsRequired: 'Wymagane kredyty:',
            creditsRemaining: 'Pozostało:',
            generate: 'Generuj',
            generating: 'Generowanie...',
            demoPrompt: 'Prompt demonstracyjny',
            demoPromptExample: 'A soft and cute white kitten dances joyfully on tiptoes, its fluffy body swaying gently with tiny pink paws lifted. On a soft carpet under warm yellow lighting, healing cartoon style, exquisite details, soft and gentle colors.',
            modelLabel: 'Model:',
            durationLabel: 'Czas trwania:',
            techSpecsTitle: 'Specyfikacje techniczne',
            techSpecsDesc: 'Seedance obsługuje natywną synchronizację audio-wideo, filmowy ruch i ekspresję emocjonalną. Obejmuje tryby tekst na wideo, obraz na wideo i rozszerzenie wideo.',
            t2vTitle: 'Tekst na wideo (T2V)',
            t2vDesc: 'Przekształcaj prompty w filmowe sceny wideo',
            i2vTitle: 'Obraz na wideo (I2V)',
            i2vDesc: 'Animuj pojedynczy obraz za pomocą AI',
            input: 'Wejście:',
            textPrompt: 'Prompt tekstowy',
            imagePrompt: 'Obraz + prompt',
            audio: 'Audio:',
            nativeAudio: 'Natywne generowanie audio',
            bestFor: 'Najlepsze do:',
            t2vBestFor: 'Idealny do tworzenia treści filmowych, reklam i wideo w mediach społecznościowych.',
            i2vBestFor: 'Najlepszy do animacji portretów, prezentacji produktów i treści kreatywnych.',
            featuresDesc: 'Niezależnie od tego, czy jesteś projektantem, marketerem, twórcą treści czy zwykłym użytkownikiem, Seedance pomaga szybko tworzyć wysokiej jakości treści AI.',
            features: [
                {
                    icon: '🎬',
                    title: 'Natywne generowanie audio-wideo',
                    desc: 'Jednoczesne generowanie wideo i audio, dostarczając jakość filmową. Naturalna synchronizacja ust i dubbing dialogów.'
                },
                {
                    icon: '😊',
                    title: 'Ekspresja napędzana emocjami',
                    desc: 'Nowa wydajność świadoma emocji dla bardziej realistycznych wyrazów twarzy. Subtelne wyrazy obejmują wahanie, smutek, napięcie lub powstrzymywanie emocji.'
                },
                {
                    icon: '🎥',
                    title: 'Kontrola kamery na poziomie reżysera',
                    desc: 'Obsługa ruchów kamery: najazd, wyjazd, panoramowanie, orbita i śledzenie. Naprowadzanie pierwszą i ostatnią klatką dla płynnych przejść.'
                },
                {
                    icon: '📱',
                    title: 'Wejście multimodalne',
                    desc: 'Obsługuje tekst na wideo, obraz na wideo i inne elastyczne przepływy kreatywne.'
                },
                {
                    icon: '⚡',
                    title: 'Szybkie generowanie',
                    desc: 'Zoptymalizowany silnik wnioskowania zapewnia szybką produkcję, większość wideo gotowa w ciągu kilku minut.'
                },
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych, odpowiednie do reklam, mediów społecznościowych i nie tylko.'
                }
            ],
            enterPrompt: 'Wpisz prompt',
            imageRequired: 'Tryb obraz na wideo wymaga obrazu referencyjnego',
            videoRequired: 'Tryb rozszerzenia wideo wymaga wideo referencyjnego',
            generateFailed: 'Generowanie nie powiodło się',
            requestFailed: 'Żądanie nie powiodło się, spróbuj ponownie',
            faq: [
                {
                    q: 'Jak działa Seedance?',
                    a: 'Możesz przesłać obraz referencyjny lub wpisać opis tekstowy, a model Seedance wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji, z zsynchronizowanym audio. Proces jest prosty i intuicyjny, nie wymaga profesjonalnych umiejętności.'
                },
                {
                    q: 'Czy wygenerowane wideo może być używane komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Seedance może być używana do celów komercyjnych, w tym materiały marketingowe, media społecznościowe, prezentacje produktów i nie tylko.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Seedance kosztuje 18 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jak szybkie jest generowanie?',
                    a: 'Średnia prędkość generowania Seedance to około 1,5 minuty. Nieustannie optymalizujemy naszą infrastrukturę, aby zapewnić szybkie i stabilne generowanie.'
                },
                {
                    q: 'Jakie formaty wyjściowe są obsługiwane?',
                    a: 'Wideo jest dostarczane w formacie MP4, obsługując rozdzielczości 480p, 720p i 1080p, z czasem trwania 5 lub 10 sekund i wieloma proporcjami obrazu.'
                }
            ]
        },
        veo: {
            title: 'Generator wideo AI Veo 3.1',
            desc: 'Google Veo 3.1 to najnowocześniejszy model wideo AI obsługujący natywne generowanie audio, ultrawysoką rozdzielczość i tworzenie długich wideo. Idealny do profesjonalnej produkcji wideo.',
            fastType: 'Typ szybki',
            fastTypeBadge: 'Szybka prędkość, niższy koszt',
            fastTypeDesc: '(Obsługuje obrazy referencyjne 16:9)',
            qualityType: 'Typ jakościowy',
            qualityTypeBadge: 'Bogatsze szczegóły',
            qualityTypeDesc: 'Płynniejszy ruch. Klatka końcowa w trybie obrazu jest opcjonalna, aby kontrolować ostatnią klatkę.',
            imageMode: 'Tryb generowania',
            startEndFrames: 'Klatki początkowa/końcowa',
            referenceImage: 'Obraz referencyjny',
            startFrame: 'Klatka początkowa',
            startFrameHint: 'Ustaw pierwszą klatkę. Wideo animuje się od tej klatki.',
            uploadStartFrame: 'Kliknij, aby przesłać klatkę początkową',
            endFrame: 'Klatka końcowa',
            endFrameHint: 'Ustaw ostatnią klatkę. Wideo kończy się na tej klatce.',
            uploadEndFrame: 'Kliknij, aby przesłać klatkę końcową',
            negativePrompt: 'Negatywny prompt',
            negativePromptPlaceholder: 'Opisz, czego nie chcesz w wideo...',
            features: [
                {
                    icon: '🎬',
                    title: 'Natywne generowanie audio',
                    desc: 'Jednoczesne generowanie wideo i audio, w tym dialogi i efekty dźwiękowe.'
                },
                {
                    icon: '📺',
                    title: 'Rozdzielczość Ultra HD',
                    desc: 'Obsługa wyjścia do rozdzielczości 4K dla profesjonalnej produkcji wideo.'
                },
                {
                    icon: '⏱️',
                    title: 'Obsługa długiego wideo',
                    desc: 'Generuj wideo do 2 minut, odpowiednie do różnych potrzeb kreatywnych.'
                },
                {icon: '🎥', title: 'Filmowy ruch', desc: 'Profesjonalne ruchy kamery i płynne przejścia.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Zoptymalizowany silnik wnioskowania dla szybkiej produkcji.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między typem szybkim a jakościowym?',
                    a: 'Typ szybki jest szybszy i bardziej opłacalny, odpowiedni do szybkiej iteracji. Typ jakościowy zapewnia bogatsze szczegóły i płynniejszy ruch, idealny do końcowego wyniku.'
                },
                {
                    q: 'Jak działa Veo 3.1?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Veo 3.1 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji, opcjonalnie z zsynchronizowanym audio.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Veo 3.1 kosztuje 30 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie rozdzielczości i czasy trwania są obsługiwane?',
                    a: 'Obsługuje rozdzielczości 720p i 1080p, z czasami trwania 5s, 10s i do 2 minut dla dłuższych wideo.'
                }
            ]
        },
        veo31: {
            genType: 'Typ generowania',
            genTypeFast: 'Szybki',
            genTypeQuality: 'Jakościowy',
            endFrame: 'Klatka końcowa'
        },
        veo30: {
            title: 'Generator wideo AI Veo 3.0',
            desc: 'Google Veo 3.0 to zaawansowany model wideo AI obsługujący tekst na wideo i obraz na wideo, z czasem trwania 4s/6s/8s i wyjściem 720p/1080p.',
            fastType: 'Typ szybki',
            fastTypeBadge: 'Szybszy, niższy koszt',
            fastTypeDesc: '(Obsługuje obraz referencyjny 16:9)',
            qualityType: 'Typ jakościowy',
            qualityTypeBadge: 'Bogatsze szczegóły',
            qualityTypeDesc: 'Płynniejszy ruch. Klatka końcowa w trybie obrazu jest opcjonalna do kontrolowania ostatniej klatki.',
            imageMode: 'Tryb obrazu',
            startEndFrames: 'Klatka początkowa/końcowa',
            referenceImage: 'Obraz referencyjny',
            referenceImageHint: 'Prześlij obraz referencyjny; wideo zostanie wygenerowane na jego podstawie.',
            uploadReferenceImage: 'Kliknij, aby przesłać obraz referencyjny',
            startFrame: 'Klatka początkowa',
            startFrameHint: 'Ustaw pierwszą klatkę. Wideo animuje się od tej klatki.',
            uploadStartFrame: 'Kliknij, aby przesłać klatkę początkową',
            endFrame: 'Klatka końcowa',
            endFrameHint: 'Ustaw ostatnią klatkę. Wideo kończy się na tej klatce.',
            uploadEndFrame: 'Kliknij, aby przesłać klatkę końcową',
            negativePrompt: 'Negatywny prompt',
            negativePromptPlaceholder: 'Opisz, czego nie chcesz w wideo...',
            seedRangeError: 'Ziarno musi być liczbą całkowitą między 0 a 2147483647.',
            duration: 'Czas trwania',
            resolution: 'Rozdzielczość',
            demoPrompt: 'A teenage girl sketching in a notebook at a café window, rain tapping on the glass...',
            features: [
                {
                    icon: '🎬',
                    title: 'Natywne generowanie audio',
                    desc: 'Jednoczesne generowanie wideo i audio, w tym dialogi i efekty dźwiękowe.'
                },
                {
                    icon: '📺',
                    title: 'Rozdzielczość HD',
                    desc: 'Obsługa wyjścia 720p i 1080p dla profesjonalnej produkcji wideo.'
                },
                {icon: '⏱️', title: 'Wiele czasów trwania', desc: 'Obsługa generowania wideo 4s, 6s i 8s.'},
                {icon: '🎥', title: 'Filmowy ruch', desc: 'Profesjonalne ruchy kamery i płynne przejścia.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Zoptymalizowany silnik wnioskowania dla szybkiej produkcji.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między typem szybkim a jakościowym?',
                    a: 'Typ szybki jest szybszy i bardziej opłacalny, odpowiedni do szybkiej iteracji. Typ jakościowy zapewnia bogatsze szczegóły i płynniejszy ruch, idealny do końcowego wyniku.'
                },
                {
                    q: 'Jak działa Veo 3.0?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Veo 3.0 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji, opcjonalnie z zsynchronizowanym audio.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Veo 3.0 kosztuje 25 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie rozdzielczości i czasy trwania są obsługiwane?',
                    a: 'Obsługuje rozdzielczości 720p i 1080p, z czasami trwania 4s, 6s lub 8s.'
                }
            ]
        },
        veo31fast: {
            title: 'Generator wideo AI Veo 3.1 Fast',
            desc: 'Google Veo 3.1 Fast do szybszego generowania, obsługujący tekst na wideo i obraz na wideo z opcjonalną klatką końcową, czasem trwania 4s/6s/8s i wyjściem 720p/1080p/4K.',
            referenceImage: 'Obraz referencyjny',
            referenceImageHint: 'Prześlij obraz referencyjny; wideo zostanie wygenerowane na jego podstawie.',
            uploadReferenceImage: 'Kliknij, aby przesłać obraz referencyjny',
            endFrame: 'Klatka końcowa',
            endFrameHint: 'Opcjonalna. Ustaw obraz dla ostatniej klatki wideo, aby kontrolować zakończenie.',
            uploadEndFrame: 'Kliknij, aby przesłać klatkę końcową',
            duration: 'Czas trwania',
            resolution: 'Rozdzielczość',
            seedRangeError: 'Ziarno musi być liczbą całkowitą między 0 a 2147483647.',
            demoPrompt: 'A teenage girl sketching in a notebook at a café window, rain tapping on the glass...',
            features: [
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Zoptymalizowane pod kątem szybszego wyjścia.'},
                {icon: '📺', title: 'Rozdzielczość 4K', desc: 'Obsługa wyjścia 720p, 1080p i 4K.'},
                {icon: '⏱️', title: 'Wiele czasów trwania', desc: 'Obsługa wideo 4s, 6s i 8s.'},
                {
                    icon: '🖼️',
                    title: 'Opcjonalna klatka końcowa',
                    desc: 'Tryb obraz na wideo może przesłać klatkę końcową do kontrolowania zakończenia.'
                },
                {icon: '🎥', title: 'Filmowy ruch', desc: 'Profesjonalne ruchy kamery i płynne przejścia.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między Veo 3.1 Fast a Veo 3.1?',
                    a: 'Veo 3.1 Fast jest zoptymalizowany pod kątem szybkości i niższego zużycia kredytów, z obsługą 4K i opcjonalną klatką końcową.'
                },
                {
                    q: 'Co to jest klatka końcowa?',
                    a: 'W trybie obraz na wideo możesz przesłać obraz klatki końcowej, aby wideo kończyło się na tej klatce, co daje Ci kontrolę nad zakończeniem.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Veo 3.1 Fast kosztuje 20 kredytów za generowanie.'
                },
                {
                    q: 'Jakie rozdzielczości i czasy trwania są obsługiwane?',
                    a: 'Obsługuje rozdzielczości 720p, 1080p i 4K, z czasami trwania 4s, 6s lub 8s.'
                }
            ]
        },
        kling: {
            title: 'Generator wideo AI Kling 2.6',
            desc: 'Kling 2.6 to wydajny model wideo AI obsługujący tekst na wideo i obraz na wideo, z doskonałą jakością ruchu i szybkim generowaniem.',
            features: [
                {
                    icon: '🎬',
                    title: 'Wysokiej jakości ruch',
                    desc: 'Płynny i naturalny ruch z profesjonalną jakością wyjścia.'
                },
                {icon: '📱', title: 'Wiele proporcji obrazu', desc: 'Obsługa 1:1, 16:9, 9:16 i innych proporcji.'},
                {
                    icon: '🔊',
                    title: 'Generowanie audio',
                    desc: 'Opcjonalne natywne generowanie audio dla kompletnego doświadczenia wideo.'
                },
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość wideo generowana w ciągu 2 minut.'},
                {icon: '🖼️', title: 'Obraz na wideo', desc: 'Animuj statyczne obrazy za pomocą ruchu napędzanego AI.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa Kling 2.6?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Kling 2.6 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Kling 2.6 kosztuje 28 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie rozdzielczości i czasy trwania są obsługiwane?',
                    a: 'Obsługuje rozdzielczości 720p i 1080p, z czasami trwania 5s i 10s.'
                },
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Kling 2.6 może być używana do celów komercyjnych.'
                }
            ]
        },
        kling3: {
            title: 'Generator wideo AI Kling 3.0',
            desc: 'Kling 3.0 to wydajny model wideo AI obsługujący tekst na wideo i obraz na wideo, z doskonałą jakością ruchu i szybkim generowaniem.',
            features: [
                {
                    icon: '🎬',
                    title: 'Wysokiej jakości ruch',
                    desc: 'Płynny i naturalny ruch z profesjonalną jakością wyjścia.'
                },
                {icon: '📱', title: 'Wiele proporcji obrazu', desc: 'Obsługa 1:1, 16:9, 9:16 i innych proporcji.'},
                {
                    icon: '🔊',
                    title: 'Generowanie audio',
                    desc: 'Opcjonalne natywne generowanie audio dla kompletnego doświadczenia wideo.'
                },
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Większość wideo generowana w ciągu 2 minut.'},
                {icon: '🖼️', title: 'Obraz na wideo', desc: 'Animuj statyczne obrazy za pomocą ruchu napędzanego AI.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa Kling 3.0?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Kling 3.0 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Kling 3.0 kosztuje 28 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Jakie rozdzielczości i czasy trwania są obsługiwane?',
                    a: 'Obsługuje rozdzielczości 720p i 1080p, z czasami trwania 5s i 10s.'
                },
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Kling 3.0 może być używana do celów komercyjnych.'
                }
            ]
        },
        sora: {
            title: 'Generator wideo AI Sora 2',
            desc: 'Sora 2 to zaawansowany model wideo AI od OpenAI, zdolny do generowania wysokiej jakości wideo z realistycznym ruchem i jakością filmową.',
            demoPromptExample: '@sama OpenAI\'s CEO, Sam, is introducing this cabinet product, saying it\'s the same as his own and very useful.',
            landscape: 'Krajobraz',
            portrait: 'Portret',
            removeWatermark: 'Usuń znak wodny',
            enabled: 'Włączony',
            disabled: 'Wyłączony',
            noWatermark: 'Bez znaku wodnego',
            cinematic: 'Jakość filmowa',
            restrictedAccess: 'Ograniczony dostęp',
            '60secDuration': 'Czas 4 s / 8 s / 12 s',
            photorealistic: 'Fotorealistyczny',
            physicsSimulation: 'Symulacja fizyki',
            features: [
                {
                    icon: '🎬',
                    title: 'Jakość filmowa',
                    desc: 'Generuj wideo z profesjonalnym filmowym wyglądem i feelingiem.'
                },
                {
                    icon: '🎥',
                    title: 'Realistyczny ruch',
                    desc: 'Naturalny i realistyczny ruch dla postaci i scen.'
                },
                {icon: '⏱️', title: 'Elastyczny czas trwania', desc: 'Obsługa różnych długości wideo dla różnych potrzeb.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Zoptymalizowane pod kątem szybkiej produkcji wideo.'},
                {icon: '🖼️', title: 'Wejście multimodalne', desc: 'Obsługa trybów tekst na wideo i obraz na wideo.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa Sora 2?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Sora 2 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Korzystanie z Sora 2 kosztuje 15 kredytów za generowanie. Możesz uzyskać lepsze stawki kredytowe poprzez plany subskrypcyjne.'
                },
                {
                    q: 'Co czyni Sora 2 wyjątkowym?',
                    a: 'Sora 2 wyróżnia się generowaniem realistycznego ruchu i filmowej jakości wideo, co czyni go idealnym do profesjonalnego tworzenia treści.'
                },
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Sora 2 może być używana do celów komercyjnych.'
                }
            ]
        },
        wan: {
            title: 'Generator wideo AI Wan',
            desc: 'Wan to wszechstronny model wideo AI obsługujący tekst na wideo i obraz na wideo z doskonałą jakością i szybkością.',
            multiFormat: 'Wiele formatów',
            smoothMotion: 'Płynny ruch',
            referenceAudio: 'Audio referencyjne',
            uploadAudio: 'Kliknij, aby przesłać audio referencyjne',
            uploadAudioHint: 'MP3, WAV, M4A (opcjonalnie, napędza ścieżkę dźwiękową wideo)',
            features: [
                {
                    icon: '🎬',
                    title: 'Wysokiej jakości wyniki',
                    desc: 'Generuj profesjonalnej jakości wideo z tekstu lub obrazów.'
                },
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Szybka produkcja wideo dla wydajnego przepływu pracy.'},
                {icon: '📱', title: 'Wiele formatów', desc: 'Obsługa różnych proporcji i rozdzielczości.'},
                {icon: '🖼️', title: 'Animacja obrazów', desc: 'Ożyw statyczne obrazy za pomocą ruchu AI.'},
                {icon: '🎥', title: 'Płynny ruch', desc: 'Naturalny i płynny ruch w generowanych wideo.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa Wan?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Wan wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {
                    q: 'Której wersji Wan powinienem używać?',
                    a: 'Wan 2.5 i 2.6 oferują najnowsze funkcje i najlepszą jakość. Wan 2.2 to opłacalna opcja dla prostszych projektów.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Wan 2.6 kosztuje 70 kredytów, Wan 2.5 kosztuje 60 kredytów, a Wan 2.2 kosztuje 10 kredytów za generowanie.'
                },
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Wan może być używana do celów komercyjnych.'
                }
            ]
        },
        wan25: {
            title: 'Generator wideo AI Wan 2.5',
            desc: 'Wan 2.5 to wszechstronny model wideo AI obsługujący tekst na wideo i obraz na wideo z doskonałą jakością i szybkością.',
            features: [
                {
                    icon: '🎬',
                    title: 'Wysokiej jakości wyniki',
                    desc: 'Generuj profesjonalnej jakości wideo z tekstu lub obrazów.'
                },
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Szybka produkcja wideo dla wydajnego przepływu pracy.'},
                {icon: '📱', title: 'Wiele formatów', desc: 'Obsługa różnych proporcji i rozdzielczości.'},
                {icon: '🖼️', title: 'Animacja obrazów', desc: 'Ożyw statyczne obrazy za pomocą ruchu AI.'},
                {icon: '🎥', title: 'Płynny ruch', desc: 'Naturalny i płynny ruch w generowanych wideo.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jak działa Wan 2.5?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Wan 2.5 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {
                    q: 'Jaka jest różnica między Wan 2.5 a Wan 2.6?',
                    a: 'Wan 2.6 oferuje dalsze ulepszenia w jakości i stabilności; Wan 2.5 jest opłacalny i odpowiedni do większości zastosowań.'
                },
                {q: 'Ile kredytów kosztuje każde generowanie?', a: 'Wan 2.5 kosztuje 60 kredytów za generowanie.'},
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Wan 2.5 może być używana do celów komercyjnych.'
                }
            ]
        },
        wan26: {
            title: 'Generator wideo AI Wan 2.6',
            desc: 'Wan 2.6 to ulepszony model wideo AI z poprawioną jakością i stabilnością, obsługujący tekst na wideo i obraz na wideo.',
            features: [
                {
                    icon: '🎬',
                    title: 'Wysokiej jakości wyniki',
                    desc: 'Generuj profesjonalnej jakości wideo z tekstu lub obrazów z ulepszoną jakością.'
                },
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Szybka produkcja wideo dla wydajnego przepływu pracy.'},
                {icon: '📱', title: 'Wiele formatów', desc: 'Obsługa różnych proporcji i rozdzielczości.'},
                {icon: '🖼️', title: 'Animacja obrazów', desc: 'Ożyw statyczne obrazy za pomocą ruchu AI.'},
                {icon: '🎥', title: 'Płynny ruch', desc: 'Naturalny i płynny ruch w generowanych wideo.'},
                {
                    icon: '💼',
                    title: 'Licencja komercyjna',
                    desc: 'Wszystkie wygenerowane wideo mogą być używane do celów komercyjnych.'
                }
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między Wan 2.6 a Wan 2.5?',
                    a: 'Wan 2.6 oferuje dalsze ulepszenia w jakości i stabilności dla wyższej jakości wyników.'
                },
                {
                    q: 'Jak działa Wan 2.6?',
                    a: 'Wpisz opis tekstowy lub prześlij obraz referencyjny, a Wan 2.6 wygeneruje wysokiej jakości treść wideo na podstawie Twoich instrukcji.'
                },
                {q: 'Ile kredytów kosztuje każde generowanie?', a: 'Wan 2.6 kosztuje 70 kredytów za generowanie.'},
                {
                    q: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    a: 'Tak, cała treść wygenerowana za pomocą Wan 2.6 może być używana do celów komercyjnych.'
                }
            ]
        },
        wan22: {
            title: 'Generator wideo AI Wan 2.2 Klasyczny',
            desc: 'Wan 2.2 to klasyczny model wideo AI do tekstu na wideo i obrazu na wideo, skupiony na stabilnym wyjściu i dużej opłacalności.',
            demoPromptExample: 'A girl with little freckles and messy red hair sitting on a rooftop during sunset, denim jacket slightly worn, holding a Polaroid camera, city skyline glowing in soft hues behind her.',
            resolutionBadge: '720p',
            classicVersion: 'Wersja klasyczna',
            stableReliable: 'Stabilny i niezawodny',
            costEffective: 'Opłacalny',
            features: [
                {
                    icon: '🎬',
                    title: 'Tekst/obraz na wideo',
                    desc: 'Obsługuje zarówno tekst na wideo, jak i obraz na wideo do codziennego tworzenia i testów wsadowych.'
                },
                {icon: '⚡', title: 'Stabilne wyniki', desc: 'Dojrzały klasyczny model z przewidywalną jakością wyjścia.'},
                {icon: '💰', title: 'Przyjazny budżetowi', desc: 'Niższe zużycie kredytów dla przepływów pracy o wysokiej częstotliwości.'},
                {icon: '📐', title: 'Popularne proporcje', desc: 'Obsługuje popularne proporcje takie jak 16:9 i 9:16.'},
                {icon: '🎥', title: 'Czyste wyjście', desc: 'Dostarcza przejrzystą i stabilną jakość wideo.'},
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowana treść może być używana komercyjnie.'}
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między Wan 2.2 a Wan 2.5?',
                    a: 'Wan 2.2 jest lepszy dla scenariuszy wrażliwych na koszty i dużych wolumenów; Wan 2.5/2.6 zapewniają silniejsze możliwości i jakość.'
                },
                {
                    q: 'Jak działa Wan 2.2?',
                    a: 'Wpisz prompt lub prześlij obraz referencyjny, a model wygeneruje wideo na podstawie Twojej instrukcji.'
                },
                {
                    q: 'Czy wygenerowane wideo może być używane komercyjnie?',
                    a: 'Tak, wyniki Wan 2.2 mogą być używane do celów komercyjnych.'
                }
            ]
        },
        kling25: {
            title: 'Generator wideo AI Kling 2.5',
            desc: 'Kling 2.5 to standardowy model wideo AI obsługujący tekst na wideo i obraz na wideo ze stabilną jakością i dobrym stosunkiem jakości do ceny.',
            standard: 'Standardowy',
            reliable: 'Niezawodny',
            costEffective: 'Opłacalny',
            standardQuality: 'Standardowa jakość',
            textToVideo: 'Tekst na wideo',
            imageToVideo: 'Obraz na wideo',
            referenceImage: 'Obraz referencyjny',
            referenceImageHint: 'Kliknij, aby przesłać lub przeciągnij i upuść',
            referenceImageFormats: 'Obsługuje PNG, JPG, JPEG, WEBP (<=10MB)',
            endFrame: 'Klatka końcowa',
            endFrameOptional: 'Opcjonalna',
            endFrameFormats: 'PNG, JPG, JPEG',
            endFrameHint: 'Ogranicz klatkę końcową; najlepiej gdy proporcje odpowiadają obrazowi referencyjnemu',
            videoPrompt: 'Prompt wideo',
            promptPlaceholder: 'Opisz wideo, które chcesz wygenerować...',
            negativePrompt: 'Negatywny prompt',
            negativePromptPlaceholder: 'Opisz, co powinno być wykluczone...',
            duration: 'Czas trwania',
            aspectRatio: 'Proporcje obrazu',
            uploading: 'Przesyłanie...',
            clickToUploadReference: 'Kliknij, aby przesłać obraz referencyjny',
            clickToUploadEndFrame: 'Kliknij, aby przesłać obraz klatki końcowej',
            remove: 'Usuń',
            creditsRequired: 'Wymagane kredyty:',
            remaining: 'Pozostało:',
            generate: 'Generuj',
            generating: 'Generowanie...',
            demoPrompt: 'Prompt demonstracyjny',
            demoPromptExample: 'Use the uploaded sci-fi alley image as the first frame. Keep the same alley, neon signs, reflections and the hooded woman walking away. Slowly move the camera forward down the alley...',
            model: 'Model:',
            durationLabel: 'Czas trwania:',
            introTitle: 'Twórz wysokiej jakości wideo AI z Kling 2.5 Standard',
            featuresBadge: 'Kluczowe funkcje',
            featuresTitle: 'Co potrafi {name}?',
            faqTitle: 'FAQ',
            errorPromptRequired: 'Wpisz prompt',
            errorImageRequired: 'Obraz referencyjny jest wymagany w trybie obraz na wideo',
            errorGenerationFailed: 'Generowanie nie powiodło się',
            errorRequestFailed: 'Żądanie nie powiodło się, spróbuj ponownie',
            errorUploadFailed: 'Przesyłanie nie powiodło się, spróbuj ponownie',
            features: [
                {
                    icon: '🎬',
                    title: 'Tekst/obraz na wideo',
                    desc: 'Obsługuje zarówno tekst na wideo, jak i obraz na wideo z opcjami czasu trwania 5s/10s.'
                },
                {icon: '⚡', title: 'Niezawodne wyniki', desc: 'Dojrzały standardowy model ze stabilną wydajnością.'},
                {icon: '💰', title: 'Świetna wartość', desc: 'Niższe zużycie kredytów niż modele wyższej klasy.'},
                {icon: '📐', title: 'Wiele proporcji', desc: 'Obsługuje 1:1, 16:9 i 9:16.'},
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowana treść może być używana komercyjnie.'}
            ],
            faq: [
                {
                    q: 'Jaka jest różnica między Kling 2.5 a Kling 2.6?',
                    a: 'Kling 2.5 jest zoptymalizowany pod kątem kosztów i przepustowości, podczas gdy Kling 2.6 zapewnia silniejsze ogólne możliwości.'
                },
                {
                    q: 'Jak działa Kling 2.5?',
                    a: 'Wpisz prompt lub prześlij obraz referencyjny, a Kling 2.5 wygeneruje wideo odpowiednio.'
                },
                {q: 'Czy wygenerowane wideo może być używane komercyjnie?', a: 'Tak, wyniki Kling 2.5 mogą być używane komercyjnie.'}
            ]
        },
        viduq3pro: {
            title: 'Wideo AI Vidu Q3 Pro',
            desc: 'Vidu Q3 Pro obsługuje tekst na wideo i obraz na wideo z rozdzielczością, długością 1-16s, proporcjami i opcjonalnym audio.',
            imageUrlHint: 'Akceptowane są tylko URL-e obrazów HTTPS (przesłanie zwraca publiczny URL). Proporcje obrazu muszą być między 1:4 a 4:1.',
            lengthLabel: 'Czas trwania (sekundy)',
            optional: 'Opcjonalne',
            tagHighQuality: 'Wysoka jakość',
            tagLength: '1-16 sekund',
            tagResolution: 'Do 2K',
            demoPromptExample: 'A seaside promenade at sunrise, joggers, gulls over the water, a sailboat in the distance.',
            features: [
                {icon: '🎬', title: 'Tekst i obraz', desc: 'Generuj z promptu lub obrazu referencyjnego.'},
                {icon: '📐', title: 'Proporcje obrazu', desc: 'Tryb tekstowy: 16:9, 9:16, 1:1, 4:3, 3:4.'},
                {icon: '⏱️', title: 'Elastyczna długość', desc: 'Wybierz od 1 do 16 sekund.'},
                {icon: '🎵', title: 'Opcjonalne audio', desc: 'Włącz naturalnie brzmiące audio dla klipu.'},
                {icon: '🎲', title: 'Kontrola ziarna', desc: 'Opcjonalne ziarno dla bardziej powtarzalnych wyników.'}
            ],
            faq: [
                {q: 'Czego wymaga tryb obraz na wideo?', a: 'Publiczny URL obrazu HTTPS (JPG/PNG). Proporcje obrazu muszą być między 1:4 a 4:1.'},
                {q: 'Czym różnią się tryby tekstowy i obrazowy?', a: 'Tryb tekstowy używa proporcji obrazu; tryb obrazowy używa Twojego URL-a obrazu i nie wysyła pól proporcji tylko tekstowych.'},
                {q: 'Jak obliczane są kredyty?', a: 'Zgodnie z kredytami wyświetlonymi na stronie, na podstawie czasu trwania, rozdzielczości i ustawień audio.'}
            ]
        },
        wanAnimate: {
            title: 'Wan Animate',
            desc: 'Steruj animacją postaci za pomocą obrazu referencyjnego i wideo ruchu. Jakość standardowa lub profesjonalna.',
            animateMode: 'Tryb animacji',
            modeAnimate: 'Obraz na akcję',
            modeReplace: 'Zamiana postaci wideo',
            referenceVideo: 'Wideo referencyjne',
            quality: 'Tryb jakości',
            refImageLabel: 'Obraz referencyjny',
            refImageHint: 'Postać lub obiekt do animacji (JPG/PNG/JPEG/BMP/WEBP, maks. 5MB, boki 200-4096px, proporcje 1:3-3:1).',
            refVideoLabel: 'Wideo referencyjne',
            refVideoHint: 'Referencja ruchu (MP4/AVI/MOV, 2-30s, maks. 200MB, boki 200-2048px, proporcje 1:3-3:1).',
            animateModeLabel: 'Tryb animacji',
            btnAnimate: 'Animuj',
            animateModeBadgeAnimate: 'Ruch',
            animateModeBadgeReplace: 'Zamiana',
            btnAnimateDesc: 'Połącz postać z obrazu z ruchem z wideo.',
            btnReplace: 'Zamień',
            btnReplaceDesc: 'Zastąp postać w wideo postacią z obrazu.',
            qualityLabel: 'Tryb jakości',
            qualityStd: 'Standardowy',
            qualityPro: 'Profesjonalny',
            watermarkLabel: 'Znak wodny',
            uploadVideoRequired: 'Prześlij wideo referencyjne.',
            uploadImage: 'Prześlij obraz',
            uploadVideo: 'Prześlij wideo',
            uploading: 'Przesyłanie...',
            imageUploadHint: 'JPG, PNG, JPEG, BMP, WEBP · maks. 5MB',
            videoUploadHint: 'MP4, AVI, MOV · 2-30s · maks. 200MB',
            uploadImageRequired: 'Prześlij obraz referencyjny.',
            errImageFileTooLarge: 'Plik obrazu jest zbyt duży (maks. 5MB).',
            errImageDimensions: 'Szerokość i wysokość obrazu muszą być między 200 a 4096 px.',
            errImageAspect: 'Proporcje obrazu muszą być między 1:3 a 3:1.',
            errImageInvalid: 'Nieprawidłowy lub nieczytelny plik obrazu.',
            errVideoFileTooLarge: 'Plik wideo jest zbyt duży (maks. 200MB).',
            errVideoDuration: 'Czas trwania wideo musi być między 2 a 30 sekundami.',
            errVideoDimensions: 'Szerokość i wysokość wideo muszą być między 200 a 2048 px.',
            errVideoAspect: 'Proporcje wideo muszą być między 1:3 a 3:1.',
            errVideoInvalid: 'Nieprawidłowy lub nieczytelny plik wideo.',
            defaultModelName: 'Wan Animate',
            demoEmptyHint: 'Prześlij obraz postaci i wideo ruchu, a następnie użyj Wan Animate do stworzenia oszałamiających animacji postaci.',
            demoEmptyTitle: 'Animacja postaci',
            demoStepCharacter: 'Postać',
            demoStepMotion: 'Ruch',
            demoStepAnimate: 'Animuj',
            faqCredits: 'Tryb standardowy zużywa mniej kredytów na generowanie niż tryb profesjonalny. Zobacz linię kredytów powyżej.',
            characterAnimation: 'Animacja postaci',
            faceSwap: 'Zamiana twarzy',
            motionTransfer: 'Transfer ruchu',
            identityReplacement: 'Zastąpienie tożsamości',
            motionAccuracy: 'Wysoka wierność ruchu',
            features: [
                {icon: '🎭', title: 'Dwa tryby', desc: 'Animuj transfer ruchu lub pełne zastąpienie postaci.'},
                {icon: '📐', title: 'DashScope oficjalny', desc: 'Napędzany przez Wan 2.2 Animate na Alibaba Cloud.'},
                {icon: '⚡', title: 'Std / Pro', desc: 'Wybierz jakość standardową lub profesjonalną dla każdego zadania.'},
                {icon: '💧', title: 'Opcjonalny znak wodny', desc: 'Przełącz znak wodny na wyjściu.'}
            ],
            faq: [
                {q: 'Jakie dane wejściowe są wymagane?', a: 'Publiczny URL obrazu HTTPS i URL wideo po przesłaniu. Obrazy i wideo muszą spełniać limity rozmiaru i proporcji.'},
                {q: 'Jaka jest różnica między Animuj a Zamień?', a: 'Animuj stosuje ruch z wideo do Twojej postaci z obrazu. Zamień zamienia postać w wideo na postać z Twojego obrazu.'},
                {q: 'Jak obliczane są kredyty?', a: 'Tryb profesjonalny kosztuje więcej niż tryb standardowy za generowanie, jak pokazano na stronie.'}
            ]
        },
        hailuo: {
            title: 'Generator wideo AI Hailuo 2.3',
            desc: 'Hailuo 2.3 to model wideo AI nowej generacji zaprojektowany do kreatywnego, wysokiej jakości generowania wideo.',
            demoPromptExample: 'A cinematic shot of waves crashing on a rocky shore at sunset, golden light reflecting on the water...',
            highQuality: 'Wysoka jakość',
            highQualityOutput: 'Wysokiej jakości wyniki',
            features: [
                {icon: '🎬', title: 'Tekst na wideo', desc: 'Generuj wysokiej jakości wideo bezpośrednio z promptów tekstowych.'},
                {
                    icon: '✨',
                    title: 'Ulepszenie promptu',
                    desc: 'Ulepszenie promptu pomaga poprawić spójność i jakość.'
                },
                {icon: '🌊', title: 'Styl kreatywny', desc: 'Świetny do kreatywnych i artystycznych treści wideo.'},
                {icon: '⚡', title: 'Szybkie generowanie', desc: 'Zoptymalizowany proces dla szybszego realizacji.'},
                {icon: '🎨', title: 'Jakość wizualna', desc: 'Produkuje szczegółowe i stabilne wyniki wizualne.'},
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowana treść może być używana komercyjnie.'}
            ],
            faq: [
                {
                    q: 'Jak działa Hailuo 2.3?',
                    a: 'Wpisz prompt lub prześlij obraz referencyjny, a model wygeneruje odpowiednie wideo.'
                },
                {
                    q: 'Co to jest ulepszenie promptu?',
                    a: 'Ulepszenie promptu przepisuje i wzbogaca prompty dla lepszej jakości generowania.'
                },
                {
                    q: 'Czy wygenerowane wideo może być używane komercyjnie?',
                    a: 'Tak, wyniki Hailuo 2.3 mogą być używane komercyjnie.'
                },
                {
                    q: 'Ile kredytów kosztuje każde generowanie?',
                    a: 'Każde generowanie jest rozliczane według aktualnych zasad kredytowych modelu.'
                }
            ]
        },
        runway: {
            title: 'Generator wideo AI Runway',
            desc: 'Runway to profesjonalny model wideo AI z elastyczną kontrolą proporcji, czasu trwania i ziarna.',
            demoPromptExample: 'At dusk, the silhouettes of cranes at a Singaporean construction site are set against a brilliant sunset. Several construction workers wearing hard hats are packing up their tools, getting ready to leave...',
            professional: 'Profesjonalny',
            multiOption: 'Wiele opcji',
            highQuality: 'Wysoka jakość',
            multiFormat: 'Wiele proporcji',
            reproducibleSeed: 'Powtarzalne ziarno',
            features: [
                {
                    icon: '🎬',
                    title: 'Obraz na wideo',
                    desc: 'Prześlij obraz referencyjny i prompt, aby szybko wygenerować wysokiej jakości wideo.'
                },
                {icon: '📐', title: 'Wiele proporcji', desc: 'Obsługuje 16:9, 9:16, 1:1, 4:3, 3:4 i 21:9.'},
                {icon: '🎲', title: 'Kontrola ziarna', desc: 'Użyj ziarna do odtworzenia podobnych wyników generowania.'},
                {
                    icon: '⚡',
                    title: 'Profesjonalne wyjście',
                    desc: 'Spójne wyniki odpowiednie dla profesjonalnych i komercyjnych przepływów pracy.'
                },
                {icon: '🖼️', title: 'Animacja obrazów', desc: 'Zamień statyczne obrazy w dynamiczne ujęcia wideo.'},
                {icon: '💼', title: 'Licencja komercyjna', desc: 'Wygenerowana treść może być używana komercyjnie.'}
            ],
            faq: [
                {
                    q: 'Jak działa Runway?',
                    a: 'Prześlij obraz referencyjny i wpisz prompt; model wygeneruje odpowiednie wideo.'
                },
                {q: 'Jakie proporcje są obsługiwane?', a: 'Obsługiwane są 16:9, 9:16, 1:1, 4:3, 3:4 i 21:9.'},
                {q: 'Czy wygenerowane wideo może być używane komercyjnie?', a: 'Tak, wyniki Runway mogą być używane komercyjnie.'}
            ]
        }
    },
    privacy: {
        title: 'Polityka prywatności',
        lastUpdated: 'Ostatnia aktualizacja: 15 stycznia 2025',
        navTerms: 'Regulamin →',
        navTrust: 'Zaufanie i bezpieczeństwo →',
        sections: [
            {
                title: '1. Zbieranie informacji',
                paragraphs: ['Zbieramy informacje podane przez Ciebie podczas rejestracji i korzystania z naszych usług, w tym adres e-mail, nazwę użytkownika i informacje o płatnościach.', 'Automatycznie zbieramy również dane o użytkowaniu, takie jak adres IP, typ przeglądarki, czas dostępu i używane funkcje.']
            },
            {
                title: '2. Wykorzystanie informacji',
                paragraphs: ['Wykorzystujemy zebrane informacje do świadczenia, utrzymania i ulepszania naszych usług, przetwarzania transakcji, wysyłania powiadomień związanych z usługami oraz zapobiegania oszustwom i nadużyciom.', 'Nie sprzedajemy Twoich danych osobowych stronom trzecim.']
            },
            {
                title: '3. Treść wygenerowana przez AI',
                paragraphs: ['Przesyłane przez Ciebie obrazy i wprowadzane prompty są wykorzystywane wyłącznie do generowania żądanej treści i nie są używane do trenowania modeli AI.', 'Wygenerowana treść jest tymczasowo przechowywana na naszych serwerach w celu pobrania, a następnie usuwana zgodnie z naszą polityką retencji danych.']
            },
            {
                title: '4. Bezpieczeństwo danych',
                paragraphs: ['Stosujemy branżowe standardy bezpieczeństwa w celu ochrony Twoich danych osobowych, w tym szyfrowanie SSL, kontrole dostępu i regularne audyty bezpieczeństwa.', 'Choć robimy wszystko, aby chronić Twoje dane, żadna metoda transmisji internetowej nie jest w 100% bezpieczna.']
            },
            {
                title: '5. Użycie plików cookie',
                paragraphs: ['Używamy plików cookie i podobnych technologii w celu poprawy doświadczenia użytkownika, analizy wykorzystania i dostarczania spersonalizowanych treści.', 'Możesz zarządzać preferencjami plików cookie w ustawieniach przeglądarki. Wyłączenie plików cookie może wpłynąć na niektóre funkcje.']
            },
            {
                title: '6. Usługi firm trzecich',
                paragraphs: ['Możemy korzystać z usług firm trzecich w celu wsparcia świadczenia naszych usług, takich jak przetwarzanie płatności, analiza danych i obsługa klienta.', 'Ci dostawcy usług trzecich mają dostęp do Twoich danych osobowych tylko w zakresie niezbędnym do świadczenia usług w naszym imieniu.']
            },
            {
                title: '7. Twoje prawa',
                paragraphs: ['Masz prawo dostępu, poprawiania lub usuwania swoich danych osobowych. Masz również prawo żądać ograniczenia przetwarzania Twoich danych lub przeniesienia ich do innej usługi.', 'Aby skorzystać z tych praw, skontaktuj się z nami pod adresem miral_support@miralvis.com. Odpowiemy na Twoją prośbę w ciągu 30 dni.']
            },
            {
                title: '8. Zgodność z RODO',
                paragraphs: ['Dla użytkowników z Europejskiego Obszaru Gospodarczego przestrzegamy wymogów Ogólnego Rozporządzenia o Ochronie Danych (RODO). Nasza podstawa prawna przetwarzania Twoich danych obejmuje wykonanie umowy, uzasadnione interesy i Twoją zgodę.']
            },
            {
                title: '9. Kontakt',
                paragraphs: ['Jeśli masz pytania lub obawy dotyczące naszej polityki prywatności, skontaktuj się z naszym zespołem ochrony danych pod adresem miral_support@miralvis.com.']
            }
        ]
    },
    terms: {
        title: 'Regulamin',
        lastUpdated: 'Ostatnia aktualizacja: 15 stycznia 2025',
        navPrivacy: 'Polityka prywatności →',
        navTrust: 'Zaufanie i bezpieczeństwo →',
        sections: [
            {
                title: '1. Przegląd usług',
                paragraphs: ['Miral (zwana dalej "Platformą") to platforma AI integrująca tworzenie obrazów, wideo i muzyki. Niniejszy Regulamin (zwany dalej "Regulaminem") określa warunki i zasady korzystania z Platformy.', 'Korzystając z Platformy, akceptujesz wiązanie się z niniejszym Regulaminem. Jeśli nie zgadzasz się z Regulaminem, nie korzystaj z Platformy.']
            },
            {
                title: '2. Rejestracja konta',
                paragraphs: ['Musisz mieć ukończone 18 lat, aby zarejestrować konto. Musisz podać dokładne i kompletne informacje rejestracyjne oraz jesteś odpowiedzialny za utrzymanie bezpieczeństwa konta.', 'Jesteś odpowiedzialny za wszystkie działania prowadzone przez Twoje konto. Jeśli wykryjesz nieautoryzowane użycie, natychmiast nas powiadom.']
            },
            {
                title: '3. Korzystanie z usług',
                paragraphs: ['Platforma świadczy usługi generowania treści AI oparte na kredytach. Kredyty można uzyskać poprzez subskrypcję lub jednorazowy zakup. Różne modele AI i funkcje zużywają różne ilości kredytów.', 'Zgadzasz się nie używać Platformy do żadnych nielegalnych, szkodliwych lub naruszających prawa celów. Generowanie nielegalnych, pornograficznych, brutalnych lub naruszających prawa treści jest zabronione.']
            },
            {
                title: '4. Własność intelektualna',
                paragraphs: ['Prawa własności intelektualnej do treści generowanych przez Ciebie za pośrednictwem Platformy należą do Ciebie, z zastrzeżeniem warunków użytkowania każdego dostawcy modelu AI.', 'Znaki towarowe, logotypy, projekty interfejsu i kod oprogramowania Platformy są chronione prawami własności intelektualnej i nie mogą być używane bez autoryzacji.']
            },
            {
                title: '5. Płatności i zwroty',
                paragraphs: ['Wszystkie płatności są w dolarach amerykańskich. Opłaty subskrypcyjne są pobierane miesięcznie lub rocznie, w zależności od wybranego planu.', 'Przy pierwszym zakupie jednorazowych pakietów lub pierwszej subskrypcji zwrot środków można zlecić w ciągu 7 dni kalendarzowych, jeśli zużycie kredytów jest poniżej 3%.']
            },
            {
                title: '6. Wyłączenie odpowiedzialności',
                paragraphs: ['Platforma świadczy usługi "takie jakie są" i nie udziela żadnych wyraźnych ani dorozumianych gwarancji dotyczących dostępności, dokładności lub przydatności usług.', 'Treść wygenerowana przez AI może być niedokładna lub niedoskonała. Użytkownicy powinni samodzielnie oceniać przydatność wygenerowanej treści.']
            },
            {
                title: '7. Ograniczenie odpowiedzialności',
                paragraphs: ['W maksymalnym stopniu dozwolonym przez prawo Platforma nie ponosi odpowiedzialności za jakiekolwiek bezpośrednie, pośrednie, przypadkowe lub wtórne szkody wynikające z korzystania lub niemożności korzystania z usług.', 'Całkowita odpowiedzialność Platformy nie przekracza całkowitych opłat uiszczonych przez Ciebie w ciągu ostatnich 12 miesięcy.']
            },
            {
                title: '8. Modyfikacja regulaminu',
                paragraphs: ['Zastrzegamy sobie prawo do modyfikacji niniejszego Regulaminu w dowolnym momencie. Zmodyfikowany Regulamin wchodzi w życie po opublikowaniu na tej stronie.', 'Kontynuacja korzystania z Platformy oznacza akceptację zmodyfikowanego Regulaminu. Istotne zmiany będą komunikowane przez e-mail lub powiadomienia Platformy.']
            },
            {
                title: '9. Kontakt',
                paragraphs: ['Jeśli masz pytania dotyczące niniejszego Regulaminu, skontaktuj się z nami pod adresem miral_support@miralvis.com.']
            }
        ]
    },
    trustSafety: {
        tag: '🛡️ Zaufanie i bezpieczeństwo',
        title: 'Bezpieczeństwo Twoich danych to nasz priorytet',
        subtitle: 'Dowiedz się, jak chronimy Twoją prywatność i bezpieczeństwo danych.',
        badges: [
            {
                icon: '🛡️',
                title: 'Brak trenowania AI',
                desc: 'Twoje przesłane treści i wygenerowane prace nigdy nie są używane do trenowania modeli AI.'
            },
            {
                icon: '🔒',
                title: 'Szyfrowanie end-to-end',
                desc: 'Wszystkie transfery danych używają szyfrowania TLS 1.3, przechowywane dane używają szyfrowania AES-256.'
            },
            {
                icon: '✓',
                title: 'Zgodność z RODO',
                desc: 'Pełna zgodność z wymogami Ogólnego Rozporządzenia o Ochronie Danych UE.'
            },
            {
                icon: '🗑️',
                title: 'Samodzielna kontrola danych',
                desc: 'Możesz eksportować lub usuwać wszystkie swoje dane w dowolnym momencie, w tym usunąć konto.'
            }
        ],
        sections: [
            {
                title: 'Przejrzystość przetwarzania danych',
                paragraphs: ['Jesteśmy w pełni przejrzysti w kwestii tego, jak przetwarzamy dane. Obrazy i wideo, które przesyłasz, są używane tylko do generowania żądanej treści i są usuwane z serwerów w ciągu 24 godzin po przetworzeniu.', 'Wygenerowana treść jest przechowywana na Twoim koncie i możesz ją pobrać lub usunąć w dowolnym momencie. Nie udostępniamy Twojej treści bez Twojej zgody.']
            },
            {
                title: 'Bezpieczna infrastruktura',
                paragraphs: ['Nasze usługi są wdrożone na wiodącej na świecie infrastrukturze chmurowej z wielowarstwową ochroną bezpieczeństwa. Wszystkie serwery znajdują się w certyfikowanych centrach danych SOC 2 i ISO 27001.', 'Przeprowadzamy regularne audyty bezpieczeństwa i testy penetracyjne w celu zapewnienia bezpieczeństwa systemu. Wszyscy pracownicy przechodzą rygorystyczne szkolenia z bezpieczeństwa.']
            },
            {
                title: 'Bezpieczeństwo treści',
                paragraphs: ['Wdrażamy zaawansowane systemy bezpieczeństwa treści, które automatycznie wykrywają i blokują generowanie szkodliwych treści. Obejmuje to między innymi brutalne, pornograficzne i naruszające prawa treści.', 'Jeśli odkryjesz jakiekolwiek naruszające treści, zgłoś je nam pod adresem abuse@miral.org.']
            },
            {
                title: 'Zgodność i certyfikacja',
                paragraphs: ['Przestrzegamy głównych globalnych przepisów o ochronie danych, w tym RODO (UE), CCPA (Kalifornia) i LGPD (Brazylia).', 'Nasze przetwarzanie płatności jest zgodne ze standardami PCI DSS, zapewniając bezpieczeństwo Twoich informacji płatniczych.']
            }
        ],
        ctaTitle: 'Obawy dotyczące bezpieczeństwa?',
        ctaDesc: 'Nasz zespół ds. bezpieczeństwa jest gotowy odpowiedzieć na Twoje pytania',
        ctaButton: 'Skontaktuj się z zespołem ds. bezpieczeństwa',
        navTerms: 'Regulamin →',
        navPrivacy: 'Polityka prywatności →'
    },
    gallery: {
        tag: 'Historia tworzenia',
        title: 'Moje kreacje',
        subtitle: 'Zobacz całą historię tworzenia AI.',
        loginRequired: 'Zaloguj się, aby zobaczyć historię tworzenia',
        empty: 'Brak kreacji',
        loadMore: 'Załaduj więcej',
        filters: {
            all: 'Wszystkie',
            pending: 'Przetwarzanie',
            finish: 'Zakończone',
            failed: 'Nieudane'
        },
        usePrompt: 'Generuj z tym promptem',
        download: 'Pobierz',
        status: {
            pending: 'Przetwarzanie',
            finish: 'Zakończone',
            failed: 'Nieudane'
        }
    },
    inspiration: {
        title: 'Inspiracja',
        subtitle: 'Zobacz, co twórcy budują z Miral — od hiperrealistycznych obrazów po filmowe wideo, inspiracja w zasięgu ręki.',
        filters: {
            all: 'Wszystkie',
            image: 'Obraz',
            video: 'Wideo',
            portrait: 'Portret',
            landscape: 'Krajobraz',
            fantasy: 'Fantasy',
            anime: 'Anime'
        }
    },
    profile: {
        joinTime: 'Dołączył',
        tabs: {
            account: 'Konto',
            billing: 'Płatności',
            privacy: 'Dane i prywatność'
        },
        balance: {
            title: 'Przegląd salda',
            available: 'Dostępne kredyty'
        },
        subscription: {
            currentPlan: 'Obecny plan',
            status: 'Status',
            activated: 'Aktywny',
            cancelled: 'Anulowany na koniec obecnego okresu',
            pending: 'Przetwarzanie',
            failed: 'Płatność nie powiodła się',
            expiryDate: 'Ważny do',
            permanent: 'Bezterminowo',
            upgradePlan: 'Ulepsz lub zmień plan',
            cancelPlan: 'Anuluj subskrypcję',
            cancelNote: 'Twoja subskrypcja pozostaje aktywna do końca obecnego okresu rozliczeniowego',
            cancelWarning: 'Twoja subskrypcja zostanie anulowana. Możesz nadal korzystać ze wszystkich funkcji do',
            restorePlan: 'Wznów subskrypcję'
        },
        upgrade: {
            title: 'Ulepsz',
            desc: 'Uzyskaj nielimitowany dostęp i ekskluzywne korzyści',
            btn: 'Zobacz plany'
        },
        billing: {
            title: 'Historia płatności',
            subtitle: 'Zobacz swoje rekordy płatności i pobierz faktury',
            empty: 'Brak rekordów płatności',
            creditsPack: 'Pakiet kredytów',
            oneTime: 'Jednorazowo',
            monthly: 'Miesięcznie',
            yearly: 'Rocznie',
            refresh: 'Odśwież',
            plan: 'Plan',
            date: 'Data',
            amount: 'Kwota',
            invoice: 'Faktura',
            download: 'Pobierz',
            invoiceModal: {
                title: 'Szczegóły faktury',
                orderInfo: 'Informacje o zamówieniu',
                invoiceInfo: 'Informacje o fakturze',
                plan: 'Plan',
                date: 'Data płatności',
                amount: 'Kwota',
                paymentId: 'ID zamówienia',
                close: 'Zamknij',
                download: 'Pobierz fakturę',
                fullName: 'Imię i nazwisko',
                fullNamePlaceholder: 'Wpisz swoje imię i nazwisko',
                email: 'E-mail',
                emailPlaceholder: 'Wpisz swój e-mail',
                company: 'Firma',
                companyPlaceholder: 'Pełna nazwa firmy',
                taxId: 'NIP',
                taxIdPlaceholder: 'Wpisz NIP',
                addressLine1: 'Adres linia 1',
                addressLine1Placeholder: 'Ulica i numer',
                addressLine2: 'Adres linia 2',
                addressLine2Placeholder: 'Lokal, apartament itp. (opcjonalnie)',
                city: 'Miasto',
                cityPlaceholder: 'Miasto',
                province: 'Województwo',
                provincePlaceholder: 'Województwo',
                postalCode: 'Kod pocztowy',
                postalCodePlaceholder: 'Kod pocztowy',
                country: 'Kraj',
                countryPlaceholder: 'Kraj',
                invoiceRemarks: 'Uwagi',
                invoiceRemarksPlaceholder: 'Uwagi do faktury',
                optional: 'opcjonalnie',
                required: 'To pole jest wymagane'
            }
        },
        privacy: {
            title: 'Ustawienia prywatności',
            cardTitle: 'Twoje dane są chronione',
            cardSubtitle: 'Nasze zobowiązanie do ochrony Twojej prywatności i bezpieczeństwa danych',
            item1: 'Twoje dane nigdy nie są używane do trenowania modeli AI',
            item2: 'Transmisja i przechowywanie danych są w pełni szyfrowane',
            item3: 'Wygenerowane prace są automatycznie usuwane po okresie przechowywania',
            item4: 'Brak pętli zwrotnych, brak wtórnego wykorzystania danych pochodnych',
            item5: 'Ścisła zgodność z przepisami o ochronie danych'
        },
        support: {
            title: 'Potrzebujesz pomocy?',
            desc: 'Nasz zespół wsparcia jest tu, aby pomóc',
            btn: 'Skontaktuj się ze wsparciem',
            note: 'miral_support@miralvis.com · Odpowiedź w ciągu 24 godzin'
        }
    },
    payment: {
        success: {
            title: 'Płatność zakończona sukcesem',
            message: 'Dziękujemy za zakup! Twoje zamówienie zostało przetworzone, a kredyty dodane do konta.',
            goHome: 'Przejdź do strony głównej',
            viewProfile: 'Zobacz profil'
        },
        cancel: {
            title: 'Płatność anulowana',
            message: 'Twoja płatność została anulowana. Jeśli masz pytania, skontaktuj się z naszym wsparciem.',
            tryAgain: 'Spróbuj ponownie',
            goHome: 'Przejdź do strony głównej'
        }
    },
    seo: {
        default: {
            title: 'Miral - Generator obrazów, wideo i muzyki AI',
            description: 'Miral to wszechstronna platforma tworzenia AI obsługująca najwyższej klasy modele takie jak Seedream 4, Midjourney, GPT Image, Veo 3 i Sora 2. Twórz oszałamiające obrazy, wideo i muzykę bez wysiłku.',
            keywords: 'generator obrazów AI, generator wideo AI, generator muzyki AI, tekst na obraz, tekst na wideo, Seedream, Midjourney, Veo, Sora, Miral'
        },
        home: {
            title: 'Miral: generator obrazów, wideo i muzyki AI',
            description: 'Twórz wysokiej jakości obrazy, wideo i muzykę AI w Miral z modelami Seedream 5, Midjourney, Veo 3.1, Sora 2 i innymi, korzystając z jednej wygodnej platformy.'
        },
        pricing: {
            title: 'Cennik - Platforma tworzenia AI Miral',
            description: 'Miral oferuje elastyczne plany cenowe dla wszystkich Twoich potrzeb kreatywnych. Kupuj kredyty, płać na bieżąco, subskrypcja nie jest wymagana.'
        },
        profile: {
            title: 'Profil - Miral',
            description: 'Zarządzaj swoim kontem Miral, przeglądaj historię zamówień i rekordy tworzenia.'
        },
        models: {
            title: 'Modele AI - Miral',
            description: 'Odkryj najwyższe modele AI na platformie Miral, w tym modele generowania obrazów, wideo i muzyki.',
            wan25: {
                title: 'Wan 2.5 - Potężny model wideo AI',
                description: 'Wan 2.5 zapewnia generowanie wideo AI nowej generacji. Twórz realistyczne, płynne wideo z zaawansowanym ruchem i szczegółami, idealne dla twórców i firm.'
            },
            wan26: {
                title: 'Wan 2.6 - Ulepszony generator wideo AI',
                description: 'Ulepsz swoje tworzenie wideo z Wan 2.6. Ten zaawansowany model AI generuje ultrarealistyczne wideo z poprawionym ruchem, szczegółami i szybkością dla profesjonalnych treści.'
            },
            wan22: {
                title: 'Wan 2.2 - Szybki generator wideo AI',
                description: 'Wan 2.2 to szybki, niezawodny model wideo AI. Generuj wysokiej jakości wideo szybko, idealne dla twórców potrzebujących szybkiej, profesjonalnej produkcji treści.'
            },
            wanAnimate: {
                title: 'Wan Animate - Animacja postaci - Miral',
                description: 'Animuj postacie za pomocą obrazu referencyjnego i wideo ruchu przez Alibaba Wan 2.2 Animate.'
            },
            veo30: {
                title: 'Veo 3.0 - Wiodący model wideo AI',
                description: 'Veo 3.0 to najwyższej klasy generator wideo AI. Twórz żywe, filmowe wideo z zaawansowanym AI, idealne do profesjonalnego tworzenia treści i marketingu.'
            },
            veo31: {
                title: 'Veo 3.1 - Najlepsze generowanie wideo AI',
                description: 'Veo 3.1 to wiodący model wideo AI do oszałamiających, żywych wideo. Twórz filmowe klipy, animacje i treści z niesamowitą jakością i szybkością.'
            },
            kling26: {
                title: 'Kling 2.6 - Premium model wideo AI',
                description: 'Kling 2.6 ożywia profesjonalne generowanie wideo AI. Generuj wysokiej jakości, płynne wideo z zaawansowanym AI dla twórców, marketerów i firm.'
            },
            kling3: {
                title: 'Kling 3 - Generator wideo AI - Miral',
                description: 'Generuj wysokiej jakości wideo AI z modelem Kling 3.'
            },
            kling25: {
                title: 'Kling 2.5 - Niezawodny model wideo AI',
                description: 'Kling 2.5 oferuje potężne generowanie wideo AI dla twórców. Twórz wysokiej jakości wideo z płynnym ruchem i szczegółami, idealne do treści i marketingu.'
            },
            seedance: {
                title: 'Seedance AI - Zaawansowany generator wideo AI',
                description: 'Generuj wysokiej jakości wideo AI z Seedance AI. Twórz oszałamiające klipy, animacje i filmowe treści z najnowocześniejszymi modelami AI dla szybkich, profesjonalnych wyników.'
            },
            sora2: {
                title: 'Generator wideo AI Sora 2 – Tekst i obraz na wideo | Miral',
                description: 'Twórz wideo Sora 2 z tekstu lub obrazów na Miral. Wypróbuj darmowe kredyty i wybierz 4–12 s, 720p/1080p oraz format 16:9/9:16.'
            },
            hailuo23: {
                title: 'Hailuo 2.3 - Inteligentny generator wideo AI',
                description: 'Hailuo 2.3 zapewnia inteligentne generowanie wideo AI. Twórz wysokiej jakości, kreatywne wideo z zaawansowanym AI dla twórców treści i firm.'
            },
            viduq3pro: {
                title: 'Vidu Q3 Pro - Generator wideo AI - Miral',
                description: 'Twórz wideo z tekstu i obrazów z Vidu Q3 Pro, wiele rozdzielczości i długości.'
            },
            runway: {
                title: 'Runway - Platforma tworzenia wideo AI',
                description: 'Runway to wiodąca platforma wideo AI dla twórców. Edytuj, generuj i ulepszaj wideo z potężnymi narzędziami AI, idealna do profesjonalnej produkcji treści.'
            },
            nanobanana: {
                title: 'Nano Banana - Generator obrazów AI - Miral',
                description: 'Szybko generuj kreatywne obrazy z modelem Nano Banana.'
            },
            seedream4: {
                title: 'Seedream 4 - Generator obrazów AI',
                description: 'Twórz oszałamiające, wysokorozdzielcze obrazy AI z Seedream 4. Generuj fotorealistyczną sztukę, ilustracje i projekty z zaawansowanym AI do profesjonalnej pracy kreatywnej.'
            },
            seedream5: {
                title: 'Seedream 5 - Generator obrazów AI ByteDance - Miral',
                description: 'Generuj wysokiej jakości obrazy AI z modelem ByteDance Seedream 5.'
            },
            midjourney: {
                title: 'Midjourney - Generator sztuki AI',
                description: 'Midjourney to wiodący generator sztuki AI. Twórz zapierające dech w piersiach obrazy, sztukę i projekty z promptów tekstowych, idealne dla artystów, projektantów i twórców treści.'
            },
            gptimage1: {
                title: 'GPT-Image-1 - Model obrazów AI OpenAI',
                description: 'GPT-Image-1 od OpenAI generuje wysokiej jakości obrazy AI z tekstu. Twórz realistyczne, kreatywne wizualizacje do projektowania, marketingu i tworzenia treści.'
            },
            gptimage15: {
                title: 'GPT Image 1.5 - Generator obrazów AI OpenAI - Miral',
                description: 'Generuj wysokiej jakości obrazy AI z modelem OpenAI GPT Image 1.5.'
            },
            fluxpro11ultra: {
                title: 'Flux Pro 1.1 Ultra - Premium generator obrazów AI',
                description: 'Flux Pro 1.1 Ultra zapewnia ultrawysokiej jakości generowanie obrazów AI. Twórz fotorealistyczne, szczegółowe obrazy z zaawansowanym AI do profesjonalnego projektowania i sztuki.'
            },
            fluxschnell: {
                title: 'Flux Schnell - Szybki generator obrazów AI',
                description: 'Flux Schnell to błyskawicznie szybki generator obrazów AI. Twórz wysokiej jakości obrazy szybko, idealne dla twórców potrzebujących szybkiej, profesjonalnej treści wizualnej.'
            },
            flux2: {
                title: 'FLUX.2 - Generator obrazów AI - Miral',
                description: 'Generuj profesjonalnej jakości obrazy AI z modelem FLUX.2 — 5 wariantów dla szybkości, jakości i kontroli.'
            },
            zimageturbo: {
                title: 'Z Image Turbo - Generator obrazów AI - Miral',
                description: 'Generuj wysokorozdzielcze obrazy z modelem Z Image Turbo.'
            }
        },
        tools: {
            title: 'Narzędzia obrazów AI - Miral',
            description: 'Miral zapewnia różne narzędzia przetwarzania obrazów AI, w tym usuwanie znaków wodnych, usuwanie tła, ulepszanie obrazów i więcej.',
            watermarkRemover: {
                title: 'Darmowe usuwanie znaków wodnych przez AI | Miral',
                description: 'Usuń online znaki wodne, logo, daty, tekst i oznaczenia ze zdjęć za pomocą AI. Zachowaj szczegóły i eksportuj czyste wyniki jako JPG, PNG lub WebP.'
            },
            backgroundRemover: {
                title: 'Darmowe usuwanie tła AI online | Miral',
                description: 'Usuń tło obrazu za darmo z AI. Wycinaj portrety i produkty, zachowuj włosy i krawędzie oraz twórz przezroczyste PNG z JPG, PNG lub WebP.'
            },
            imageEraser: {
                title: 'AI Usuwanie obiektów - Usuń obiekty ze zdjęć',
                description: 'Usuń niechciane obiekty, osoby, znaki wodne i tekst ze zdjęć za pomocą AI. Zaznacz obszar pędzlem, a sztuczna inteligencja płynnie go usunie, wypełniając lukę naturalną treścią. Idealne do czyszczenia obrazów.'
            },
            objectRemover: {
                title: 'AI Usuwanie obiektów - Usuń obiekty ze zdjęć',
                description: 'Usuń niechciane obiekty ze zdjęć za pomocą AI. Zaznacz obiekt pędzlem, a sztuczna inteligencja płynnie go usunie, wypełniając obszar naturalną treścią. Idealne do czyszczenia zdjęć.'
            },
            aiPersonRemover: {
                title: 'AI Usuwanie osób - Usuń osoby ze zdjęć',
                description: 'Usuń osoby ze zdjęć za pomocą AI. Zaznacz dowolną osobę pędzlem, a sztuczna inteligencja płynnie ją usunie, wypełniając obszar naturalną treścią. Idealne do usuwania przechodniów i obcych z Twoich zdjęć.'
            },
            'whiteBackground': {
                title: 'AI Białe tło - Zastąp tło obrazu na białe',
                description: 'Automatycznie zastępuj tła obrazów na czysto białe za pomocą AI. Idealne do zdjęć produktowych e-commerce, zdjęć dowodowych i obrazów katalogowych.'
            },
            'blueBackground': {
                title: 'AI Niebieskie tło - Zastąp tło obrazu na niebieskie',
                description: 'Automatycznie zastępuj tła obrazów na czysto niebieskie za pomocą AI. Idealne do zdjęć paszportowych, zdjęć dowodowych i dokumentów urzędowych.'
            },
            faceSwap: {
                title: 'AI Zamiana twarzy - Zamień twarze na zdjęciach',
                description: 'Zamieniaj twarze na zdjęciach za pomocą AI. Prześlij zdjęcie docelowe i twarz źródłową, aby płynnie wkomponować twarze z realistycznymi, naturalnymi wynikami.'
            },
            imageEnhancer: {
                title: 'AI Ulepszanie obrazów - Skaluj i ulepszaj zdjęcia',
                description: 'Ulepszaj i skaluj obrazy za pomocą AI. Wyostrzaj szczegóły, naprawiaj rozmycia, zwiększaj rozdzielczość i odnawiaj stare zdjęcia dla wysokiej jakości, profesjonalnych wyników.'
            },
            docCropEnhance: {
                title: 'Kadrowanie i korekta dokumentów online z AI | Miral',
                description: 'Kadruj i poprawiaj dokumenty, testy, zadania i strony książek online. Koryguj przechylenie, perspektywę, krzywizny i cienie, aby uzyskać wyraźne skany.'
            },
            handwrittenErase: {
                title: 'Usuwanie pisma z testów i zadań przez AI | Miral',
                description: 'Usuń odręczne odpowiedzi z testów, zadań i ćwiczeń za pomocą AI, zachowując drukowany tekst. Narzędzie obsługuje obrót, kadrowanie i prostowanie.'
            }
        },
        music: {
            title: 'Generator muzyki AI - Miral',
            description: 'Twórz unikalną muzykę z opisów tekstowych za pomocą generowania muzyki AI Miral.'
        },
        inspiration: {
            title: 'Inspiracja - Miral',
            description: 'Przeglądaj wyróżnione prace ze społeczności Miral i czerp inspirację do tworzenia AI.'
        },
        gallery: {
            title: 'Moja galeria - Miral',
            description: 'Przeglądaj i zarządzaj wszystkimi swoimi kreacjami na platformie Miral.'
        },
        faq: {
            title: 'FAQ - Miral',
            description: 'Często zadawane pytania o platformie Miral, które pomogą Ci zacząć z tworzeniem AI.'
        },
        about: {
            title: 'About Us - Miral',
            description: 'Learn about the Miral AI platform for image, video, and music creation.'
        },
        contact: {
            title: 'Contact Us - Miral',
            description: 'Contact Miral support for help and feedback.'
        },
        terms: {
            title: 'Regulamin - Miral',
            description: 'Regulamin platformy Miral i umowa użytkownika.'
        },
        privacy: {
            title: 'Polityka prywatności - Miral',
            description: 'Polityka prywatności platformy Miral i oświadczenie o ochronie danych.'
        },
        trustSafety: {
            title: 'Zaufanie i bezpieczeństwo - Miral',
            description: 'Polityki zaufania i bezpieczeństwa platformy Miral.'
        },
    imageModels: {
            title: "Modele obrazów AI - Miral",
            description: "Odkryj najlepsze modele obrazów AI w Miral i generuj oszałamiające obrazy z podpowiedzi tekstowych.",
            relatedModelsTitle: "Odkryj więcej modeli obrazów AI",
            demoPrompt: "Monit tekstowy",
            demoOutput: "Wygenerowany obraz",
            demoPlaceholder: "Przykładowy obraz — wkrótce",
            promptLabel: "Utwórz za pomocą",
            usePrompt: "Użyj tej podpowiedzi →",
            imagePlaceholder: "Przykładowy obraz AI",
            replaceImageHint: "Wygenerowano z monitu wyświetlanego obok tego obrazu",
            flux1: {
                title: "FLUX.1 AI Generator obrazów Darmowy online | Miral",
                description: "Twórz wysokiej jakości obrazy AI online za pomocą FLUX.1, korzystając z Flux Pro 1.1 Ultra lub Flux Schnell. Poznaj dziewięć współczynników proporcji, stylów wizualnych i darmowe kredyty.",
                heroHeadline: "Generator obrazów AI FLUX.1",
                heroIntro: "Użyj generatora obrazów FLUX.1 AI firmy Black Forest Labs za darmo w Miral AI. Zarejestruj się, aby otrzymać darmowe kredyty i wybrać między wysokiej jakości wynikami Flux Pro 1.1 Ultra a szybkim, wielostylowym tworzeniem Flux Schnell.",
                eyebrow: "Black Forest Labs · FLUX.1",
                sectionKicker: "FLUX.1",
                ctaTag: "FLUX.1 · Miral",
                badges: ["Tekst do obrazu", "9 Aspektów Proporcje", "Pro i Schnell", "Fotografia / Sztuka cyfrowa / Anime"],
                previewLabel: "Flux Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 proporcji"],
                previewTitle: "Wybierz między dopracowaną jakością a szybką, kreatywną eksploracją",
                previewDesc: "Użyj Pro 1.1 Ultra do szczegółowych wizualizacji lub Schnell do szybkiego zgłębiania zagadnień fotografii, sztuki cyfrowej i anime.",
                keyFeaturesTitle: "Twórz wysokiej jakości wizualizacje za pomocą generatora tekstu na obraz FLUX.1",
                keyFeaturesIntro: "Poznaj funkcje Flux Pro 1.1 Ultra i Flux Schnell, aby szybko zrozumieć obraz, uzyskać wysoką prędkość, styl wizualny i elastyczne proporcje obrazu.",
                exploreTitle: "Odkryj więcej modeli obrazów AI",
                mainFeaturesTitle: "Kluczowe funkcje FLUX.1",
                generatedImageLabel: "Wygenerowany obraz",
                versionLabel: "Wersja",
                featureLabel: "Kluczowe funkcje",
                useCaseLabel: "Najlepsza Dla",
                controlsTitle: "Wybierz odpowiedni model, proporcje i styl wizualny",
                controlsIntro: "Użyj Flux Pro 1.1 Ultra do dopracowania obrazów końcowych lub Flux Schnell do szybszej eksploracji, a następnie dopasuj proporcje obrazu i styl do zamierzonego kanału.",
                galleryTitle: "Więcej przykładów obrazów FLUX.1",
                discussionTitle: "Typowe pytania wyboru FLUX.1",
                communityTitle: "Popularne sposoby tworzenia z FLUX.1",
                tutorialPrompt: "Cicha, szklana księgarnia nad morzem o wschodzie słońca, ciepłe lampy do czytania, jasne dębowe półki, delikatne odbicia na podłodze, realistyczne zdjęcia wnętrz.",
                qualityBenefits: [
                    "Renderuj materiały, oświetlenie i głębię przestrzenną z bardziej dopracowanym wykończeniem.",
                    "Postępuj zgodnie ze szczegółowymi poleceniami, które łączą temat, kompozycję, aparat i styl.",
                    "Poznaj wskazówki dotyczące fotografii, sztuki cyfrowej i anime, korzystając z czytelnych instrukcji tekstowych."
                ],
                features: [
                    { name: "Wysokiej jakości tekst na obraz FLUX.1", short: "Zmień pisemne podpowiedzi w szczegółowe, profesjonalne wizualizacje.", desc: "Flux Pro 1.1 Ultra jest idealny do pracy, w której liczy się szczegółowość obrazu, materiały, oświetlenie i ogólne wykończenie. Dokładne opisanie obiektu, kompozycji, aparatu i stylu pomaga ukierunkować obraz zgodnie z kierunkiem projektu.", demo: { type: 'table', rows: [
                        { prompt: "Zewnętrzna strona butikowego hotelu na pustyni o błękitnej godzinie, ściany z ubitej ziemi, ciepła poświata okien, rodzime trawy, długie cienie, realistyczne zdjęcia architektury.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Fotografia kulinarna z ręcznie robionymi ravioli na matowym czarnym talerzu, olej bazyliowy, lniana serwetka, światło padające z okna, mała głębia ostrości.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Szybkie generowanie z Flux Schnell", short: "Twórz szybkie wersje robocze, testuj podpowiedzi i błyskawicznie eksploruj pomysły.", desc: "Flux Schnell doskonale sprawdza się w przypadku przepływów pracy wymagających szybkiej kompozycji, stylu lub testowania koncepcji. Wygeneruj wersję roboczą, przejrzyj wskazówki, a następnie dopracuj podpowiedź do kolejnej iteracji.", prompt: "Koncepcja modułowego stoiska targowego z tektury dla ekologicznego startupu, proste cokoły produktowe, tekstury papieru z recyklingu, jasne oświetlenie wystawowe, przejrzysty układ.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Dziewięć współczynników proporcji obrazu", short: "Obejmuj formaty ultraszerokokątne, poziome, kwadratowe, pionowe i wysokie.", desc: "Flux Pro 1.1 Ultra i Flux Schnell obsługują formaty 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 i 9:21 dla banerów, zdjęć produktów, treści społecznościowych, plakatów i materiałów wizualnych na urządzenia mobilne.", prompt: "Panoramiczne obserwatorium alpejskie w formacie 21:9 nad morzem chmur, szklany taras widokowy, wczesnoporanne światło, mali wędrowcy dla porównania, kinowe malowanie matowe.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Wiele stylów wizualnych w Schnell", short: "Wybierz Auto, Fotograficzny, Sztuka cyfrowa lub Anime.", desc: "Flux Schnell oferuje instrukcje w stylu automatycznym, fotograficznym, cyfrowym i anime, ułatwiając przełączanie się między wizualizacjami fotorealistycznymi, ilustrowanymi i anime bez konieczności zmiany modeli.", demo: { type: 'table', rows: [
                        { prompt: "Styl fotograficzny: mechanik rowerowy naprawiający zabytkowy rower wyścigowy w nasłonecznionym garażu, poplamione smarem dłonie, realistyczne chromowane odbicia.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Styl anime: przytulna kawiarnia dla kotów w pociągu, pastelowe chmury o zachodzie słońca za oknami, wyraziste postacie, czysta grafika.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Elastyczne, kreatywne zastosowania", short: "Twórz wizualizacje produktów, materiałów marketingowych, portretów, koncepcji i materiałów społecznościowych.", desc: "Rodzina FLUX.1 obsługuje dopracowane zdjęcia produktów i marki, a także szybkie koncepcje kampanii, portrety, projekty otoczenia i proporcje obrazu specyficzne dla platformy.", prompt: "Wizualizacja premiery zrównoważonych butów sportowych z teksturą materiału z recyklingu, unoszącymi się detalami sznurówek, zielonym jak mech gradientem tła i wyrazistą, pustą przestrzenią na reklamę w mediach społecznościowych.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady poleceń FLUX.1 dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych podpowiedzi FLUX.1 jako punktu wyjścia. Jasno opisz temat, kompozycję, oświetlenie, kamerę, materiały, paletę kolorów i styl wizualny.",
                variantsKicker: "Przewodnik po modelach",
                variantsTitle: "Flux Pro 1.1 Ultra vs Flux Schnell",
                variantsIntro: "Wybierz model FLUX.1 w oparciu o jakość, szybkość i kontrolę stylu, których potrzebuje Twój projekt.",
                variants: [
                    { name: "Flux Pro 1.1 Ultra", tag: "Wysoka jakość", desc: "Zaprojektowany do szczegółowej, realistycznej i dopracowanej pracy z tekstem na obrazie z dziewięcioma obsługiwanymi proporcjami obrazu.", bestFor: "Najlepsze do fotografii produktowej, zdjęć promocyjnych kampanii i dopracowanych wizualizacji końcowych." },
                    { name: "Flux Schnell", tag: "Szybka", desc: "Zaprojektowany do szybkiej iteracji z dziewięcioma proporcjami obrazu i stylami: automatycznym, fotograficznym, sztuki cyfrowej i anime.", bestFor: "Najlepszy do wersji roboczych, testowania podpowiedzi, treści społecznościowych i szybkiej eksploracji." }
                ],
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia FLUX.1",
                useCases: [
                    { name: "FLUX.1 dla fotografii produktowej", desc: "Twórz zdjęcia promocyjne produktów, sceny lifestylowe i koncepcje wizualne e-commerce." },
                    { name: "FLUX.1 do marketingu i reklamy", desc: "Generuj reklamy w mediach społecznościowych, banery kampanii i materiały marketingowe marki." },
                    { name: "FLUX.1 do fotorealistycznych portretów", desc: "Twórz portrety niczym ze zdjęć dzięki kontrolowanemu oświetleniu, tłom i kompozycji." },
                    { name: "FLUX.1 dla sztuki cyfrowej", desc: "Użyj Schnella, aby szybko odkrywać ilustrację, fantasy i wskazówki dotyczące sztuki cyfrowej." },
                    { name: "FLUX.1 do obrazów anime", desc: "Użyj stylu Schnell Anime do postaci i scen anime." },
                    { name: "FLUX.1 dla sztuki koncepcyjnej", desc: "Eksploruj kinowe środowiska, sceny z gier, postacie i światy wizualne." },
                    { name: "FLUX.1 do obrazów do mediów społecznościowych", desc: "Użyj dziewięciu współczynników proporcji dla treści platformowych w formacie poziomym, kwadratowym i pionowym." },
                    { name: "FLUX.1 do plakatów i banerów", desc: "Wybierz odpowiedni współczynnik dla wydarzeń, promocji i koncepcji układu strony mobilnej." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów FLUX.1 AI online za darmo",
                howToIntro: "Zarejestruj się, aby otrzymać darmowe kredyty i korzystać z Flux Pro 1.1 Ultra lub Flux Schnell online w Miral.",
                howToSteps: [
                    { title: "Wprowadź szczegółowy monit", desc: "Opisz temat, scenerię, kompozycję, oświetlenie, kamerę, materiały, kolory i styl docelowy." },
                    { title: "Wybierz model i proporcje", desc: "Wybierz Pro 1.1 Ultra dla dopracowanej jakości lub Schnell dla szybkiego przeglądu, a następnie ustaw proporcje i styl Schnell." },
                    { title: "Generuj i udoskonalaj", desc: "Wygeneruj obraz, przejrzyj i pobierz go lub dostosuj motyw, współczynnik proporcji lub styl do innej wersji." }
                ],
                howToCta: "Użyj generatora obrazów AI FLUX.1 za darmo",
                faqTitle: "Często zadawane pytania dotyczące FLUX.1",
                faqs: [
                    { q: "Czym jest generator obrazu FLUX.1 AI?", a: "FLUX.1 to rodzina modeli do generowania obrazów firmy Black Forest Labs. W systemie Miral użyj Flux Pro 1.1 Ultra i Flux Schnell, aby przekształcić podpowiedzi tekstowe w obrazy produktów, materiały marketingowe, portrety, anime i grafiki koncepcyjne." },
                    { q: "Czy mogę korzystać z generatora obrazów FLUX.1 AI za darmo?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów FLUX.1 AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jaka jest różnica między Flux Pro 1.1 Ultra a Flux Schnell?", a: "Flux Pro 1.1 Ultra nadaje się do dopracowanych obrazów finalnych, gdzie liczy się detal i wykończenie. Flux Schnell nadaje się do szybkich szkiców, szybkiego testowania i eksploracji wielostylowej, z trybami: automatycznym, fotograficznym, cyfrowym i anime." },
                    { q: "Jakie proporcje obrazu obsługuje FLUX.1?", a: "Flux Pro 1.1 Ultra i Flux Schnell na platformie Miral obsługują formaty 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 i 9:21, co daje łącznie dziewięć współczynników proporcji." },
                    { q: "Jakie style obsługuje Flux Schnell?", a: "Flux Schnell obsługuje tryby Auto, Photographic, Digital Art i Anime, umożliwiając automatyczne dopasowywanie, tworzenie fotorealistycznych obrazów, ilustracji cyfrowych i wizualizacji anime." },
                    { q: "Jak korzystać z generatora obrazów FLUX.1 AI online?", a: "Wprowadź tekst monitu, wybierz Flux Pro 1.1 Ultra lub Flux Schnell i ustaw proporcje obrazu. W Schnell możesz również wybrać styl wizualny przed kliknięciem przycisku Generuj." },
                    { q: "Jakie są najlepsze przykłady poleceń FLUX.1?", a: "Skuteczne podpowiedzi FLUX.1 jasno opisują temat, scenerię, kompozycję, oświetlenie, kamerę, materiały, paletę kolorów i styl docelowy. Wykorzystaj przykłady na tej stronie jako punkt wyjścia i dostosuj je do swojego projektu." },
                    { q: "FLUX.1 vs FLUX.2: którego powinienem użyć?", a: "Wybierz FLUX.1, aby uzyskać dopracowany wynik w Flux Pro 1.1 Ultra lub szybkie tworzenie wielu stylów w Flux Schnell. Wybierz stronę FLUX.2 w Miral, jeśli potrzebujesz wariantów Klein, Max, Pro i Flex." },
                    { q: "FLUX.1 vs Midjourney: którego powinienem użyć?", a: "FLUX.1 doskonale sprawdza się w przypadku określonych proporcji obrazu, szybkiego procesu roboczego Schnell lub dopracowanego wydruku w Pro 1.1 Ultra. Midjourney może odpowiadać użytkownikom, którzy preferują jego artystyczne style, proces roboczy oparty na obrazach referencyjnych i proces twórczy." }
                ],
                ctaTitle: "Korzystaj z FLUX.1 za darmo na Miral!",
                ctaDesc: "Zarejestruj się, aby otrzymać darmowe punkty. Wybierz Flux Pro 1.1 Ultra lub Flux Schnell i twórz obrazy o proporcjach i stylu odpowiadającym potrzebom Twojego projektu."
            },
            flux2: {
                title: "FLUX.2 AI Generator obrazów online za darmo | Miral",
                description: "Twórz fotorealistyczne obrazy AI online dzięki FLUX.2. Wybierz pięć wariantów modeli dla zdjęć produktów, plakatów, grafik i dopracowanych materiałów marketingowych.",
                heroHeadline: "Generator obrazów AI FLUX.2",
                heroIntro: "Użyj generatora obrazów FLUX.2 AI firmy Black Forest Labs za darmo na platformie Miral AI. Zarejestruj się, aby otrzymać darmowe środki i natychmiast tworzyć wysokiej jakości fotorealistyczne obrazy, fotografie produktów, plakaty i materiały marketingowe.",
                eyebrow: "Black Forest Labs · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · Miral",
                badges: ["Tekst do obrazu", "Fotorealistyczny", "Precyzyjna typografia", "Wiele współczynników proporcji"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "Od precyzyjnego komunikatu do wizualizacji gotowej do produkcji",
                previewDesc: "Twórz szczegółowe zdjęcia produktów, koncepcje kampanii, portrety i projekty bogate w tekst w jednym, usprawnionym procesie roboczym.",
                keyFeaturesTitle: "Twórz profesjonalne wizualizacje za pomocą generatora tekstu na obraz FLUX.2",
                keyFeaturesIntro: "Poznaj kluczowe funkcje generatora obrazów FLUX.2 AI, aby uzyskać precyzyjne podpowiedzi, dopracowane szczegóły, realistyczne wyniki i niezawodną kontrolę wizualną.",
                exploreTitle: "Odkryj więcej modeli obrazów AI",
                mainFeaturesTitle: "Kluczowe funkcje FLUX.2",
                generatedImageLabel: "Wygenerowany obraz",
                versionLabel: "Wersja",
                featureLabel: "Kluczowe funkcje",
                useCaseLabel: "Najlepsza Dla",
                controlsTitle: "Wybierz odpowiednią wersję FLUX.2 i ustawienia wyjściowe",
                controlsIntro: "Użyj Klein do szybkiej iteracji, Max dla najwyższej jakości końcowej, Pro do procesów produkcyjnych lub Flex do typografii i kontroli drobnych szczegółów.",
                galleryTitle: "Więcej przykładów obrazów FLUX.2",
                discussionTitle: "Typowy model FLUX.2 Pytania",
                communityTitle: "Popularne sposoby tworzenia z FLUX.2",
                tutorialPrompt: "Wysokiej jakości zdjęcie kampanii przedstawiające półprzezroczysty, szmaragdowy flakon perfum na bladym wapieniu, łagodne poranne światło, realistyczny refraktogram szkła, wyrafinowana typografia, duża przestrzeń negatywna.",
                qualityBenefits: [
                    "Postępuj zgodnie ze szczegółowymi instrukcjami, mając większą kontrolę nad tematem, kompozycją, oświetleniem i stylem.",
                    "Twórz realistyczne tekstury, głębię i dopracowane detale do profesjonalnych prac wizualnych.",
                    "Obsługuj plakaty z bogatym tekstem, etykiety produktów i grafiki kampanii z wyraźniejszą typografią."
                ],
                features: [
                    { name: "Zaawansowana synteza obrazu", short: "Zapewnia lepszą zgodność i jakość obrazu bez dodatkowych opóźnień.", desc: "FLUX.2 znacznie usprawnia szybkie wyrównywanie i obsługuje nawet długie formaty, takie jak szczegółowe skrypty i opisy scen. Zapewnia większą wierność generowanych obrazów bez utraty szybkości, co zmniejsza potrzebę iteracyjnych korekt i pozwala twórcom szybciej osiągnąć efekt końcowy.", demo: { type: 'table', rows: [
                        { prompt: "Olśniewający krajobraz z żywymi kolorami i misternymi detalami, przedstawiający zachód słońca nad pasmem górskim.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Sztuka abstrakcyjna do tłumaczenia między językami funkcyjnymi a językami niskiego poziomu." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Zdjęcie postaci z anime/kreskówki, szczegółowe i dobrze wykonane, a jednocześnie wyglądające na wykonane przez człowieka." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Wyjątkowa szczegółowość i realizm", short: "Tworzy realistyczne tekstury, oświetlenie i głębię dla wizualizacji studyjnej.", desc: "FLUX.2 rejestruje delikatne tekstury, realistyczne oświetlenie i naturalną głębię, dzięki czemu generowane obrazy wyglądają autentycznie fotograficznie. Dzięki temu doskonale sprawdza się w przypadku zdjęć produktów, portretów i wizualizacji filmowych, gdzie wiarygodność jest najważniejsza.", prompt: "Zdjęcie studyjne srebrnego zegarka mechanicznego na ciemnym łupku, delikatne oświetlenie boczne, realistyczna faktura szczotkowanego metalu, mała głębia ostrości, subtelne odbicia, kompozycja premium." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Silne dopasowanie do treści", short: "Ściśle podąża za złożonymi instrukcjami, uwzględniając konkretne tematy, style i kompozycję.", desc: "FLUX.2 interpretuje warstwowe, wieloczęściowe podpowiedzi z imponującą dokładnością – obsługując konkretne tematy, style graficzne, palety kolorów i instrukcje dotyczące kompozycji w jednym pokoleniu. Daje to twórcom większą kontrolę i mniej ponownych rzutów, gdy opisują dokładnie, czego chcą.", prompt: "Czerwony tramwaj przejeżdżający przez deszczowy europejski plac o zmierzchu, trzech rowerzystów na pierwszym planie, ciepłe okna kawiarni po lewej stronie, błękitne niebo, symetryczna kompozycja, fotografia filmowa.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Zaawansowane zarządzanie typografią", short: "Renderuje tekst na obrazach z lepszą pisownią i spójnym stylem.", desc: "FLUX.2 oferuje ulepszone generowanie tekstu i kontrolę nad obrazami, z dokładniejszą spójnością stylów czcionek. Umożliwia to tworzenie materiałów tekstowych i oznakowań na plakatach, reklamach, komiksach i grafikach marek z dużo mniejszą liczbą artefaktów.", demo: { type: 'table', rows: [
                        { prompt: "Piękne, mistyczne zdjęcie krajobrazu z napisem „FLUX 2”, subtelne piękno, z dodatkiem jagód." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Tort szwarcwaldzki z napisem „FLUX 2 Pro”, smakowita fotografia kulinarna." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Szybkie i skalowalne generowanie", short: "Wybierz od iteracji w czasie poniżej sekundy do wyników o maksymalnej jakości.", desc: "FLUX.2 obejmuje szybkie modele Klein oraz wersje Pro, Max i Flex przeznaczone do produkcji. Ta seria jest praktyczna do szybkich projektów, produkcji wsadowej oraz materiałów marketingowych lub kreatywnych o ostatecznej jakości.", prompt: "Czyste zdjęcie produktu w stylu editorial, przedstawiające półprzezroczysty, zielony flakon perfum na wapieniu, delikatne poranne światło, subtelne cienie, estetyka kampanii premium." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi FLUX.2 dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi FLUX.2 jako punktu wyjścia, dostosuj temat, kompozycję, oświetlenie i styl, a następnie wyślij podpowiedź bezpośrednio do generatora.",
                variantsKicker: "Przewodnik po modelach",
                variantsTitle: "Porównanie modeli FLUX.2: Klein vs Max vs Pro vs Flex",
                variantsIntro: "Porównaj FLUX.2 Klein, Max, Pro i Flex, aby wybrać odpowiedni model obrazu AI do szybkiej iteracji, zasobów o ostatecznej jakości, skali produkcji lub precyzyjnej kontroli typografii.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "Najszybsza", desc: "Wybierz FLUX.2 Klein do szybkiego generowania obrazów o dużej objętości, szkiców i szybkiego prototypowania.", bestFor: "Najlepszy do szkiców, partii i szybkich iteracji" },
                    { name: "FLUX.2 Max", tag: "Najwyższa jakość", desc: "Wybierz FLUX.2 Max, aby uzyskać ostateczne zasoby, najsilniejsze podążanie za wskazówkami i ugruntowane generowanie.", bestFor: "Najlepszy do kampanii premium i obrazów głównych" },
                    { name: "FLUX.2 Pro", tag: "Produkcyjna", desc: "Wybierz FLUX.2 Pro, aby uzyskać równowagę jakości obrazu, czasu realizacji i skalowalności wydruku na poziomie produkcyjnym.", bestFor: "Najlepsze do marketingu i produkcji treści" },
                    { name: "FLUX.2 Flex", tag: "Kontrola", desc: "Wybierz FLUX.2 Flex do regulowanego prowadzenia, typografii, renderowania tekstu i zachowania drobnych szczegółów.", bestFor: "Najlepszy do plakatów, etykiet i materiałów projektowych" }
                ],
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia FLUX.2",
                useCases: [
                    { name: "FLUX.2 do fotografii produktowej", desc: "Twórz dopracowane zdjęcia produktów, sceny lifestylowe i wariacje zdjęć e-commerce." },
                    { name: "FLUX.2 do marketingu i reklamy", desc: "Przekształć koncepcje kampanii w reklamy w mediach społecznościowych, banery i spójne elementy wizualne marki." },
                    { name: "FLUX.2 dla plakatów i typografii", desc: "Użyj renderowania tekstu FLUX.2, aby tworzyć wyraźniejsze nagłówki, etykiety, plakaty i grafiki tekstowe." },
                    { name: "FLUX.2 do fotorealistycznych portretów", desc: "Generuj szczegółowe portrety AI z kontrolowanym oświetleniem, stylizacją i kompozycją." },
                    { name: "FLUX.2 do grafiki koncepcyjnej", desc: "Szybko eksploruj filmowe środowiska, postacie i wskazówki wizualne." },
                    { name: "FLUX.2 do projektowania redakcyjnego", desc: "Twórz charakterystyczne ilustracje i okładki do artykułów i prezentacji." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów FLUX.2 AI online",
                howToIntro: "Użyj generatora obrazów FLUX.2 AI online w Miral, aby przejść od szczegółowego komunikatu tekstowego do wygenerowanego obrazu.",
                howToSteps: [
                    { title: "Wprowadź swój monit", desc: "Opisz obiekt, kompozycję, oświetlenie, kolory, styl i dowolny tekst, który ma się pojawić na zdjęciu." },
                    { title: "Wybierz ustawienia FLUX.2", desc: "Otwórz generator, wybierz Klein, Max, Pro lub Flex, a następnie wybierz rozmiar wyjściowy odpowiedni dla Twojego projektu." },
                    { title: "Wygeneruj obraz", desc: "Rozpocznij generowanie, przejrzyj wyniki i pobierz obraz lub dopracuj wizualizację, aby utworzyć inną wersję." }
                ],
                howToCta: "Wypróbuj generator obrazów FLUX.2 AI",
                faqTitle: "Często zadawane pytania dotyczące FLUX.2",
                faqs: [
                    { q: "Czym jest FLUX.2?", a: "FLUX.2 to model sztucznej inteligencji nowej generacji Black Forest Labs do przetwarzania tekstu na obraz. Zamienia on podpowiedzi tekstowe w wysokiej jakości, szczegółowe obrazy i jest dostępny w Miral do tworzenia grafiki, projektowania, marketingu i wizualizacji produktów bezpośrednio w przeglądarce." },
                    { q: "Jakiego narzędzia mogę użyć do tworzenia fotografii produktów i bogatych w tekst materiałów marketingowych?", a: "FLUX.2 łączy w sobie natychmiastową spójność, szczegółowość, fotorealizm i obsługę typografii dla profesjonalnej fotografii produktów i bogatych w tekst materiałów marketingowych, które wymagają wierności i dokładności." },
                    { q: "Czy mogę bezpłatnie korzystać z generatora obrazów FLUX.2 AI?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów FLUX.2 AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów FLUX.2 AI online?", a: "Wprowadź szczegółowy tekst, wybierz FLUX.2 Klein, Max, Pro lub Flex, wybierz rozmiar obrazu i kliknij „Generuj”. FLUX.2 sprawdza się w materiałach marketingowych, fotografii produktowej, koncepcjach filmowych, materiałach kreatywnych do mediów społecznościowych i projektach plakatów." },
                    { q: "Ile czasu zajmuje wygenerowanie FLUX.2?", a: "Czas generowania zależy od wybranego wariantu FLUX.2, rozmiaru obrazu i bieżącego obciążenia usługi. Klein został zaprojektowany z myślą o bardzo szybkiej iteracji, podczas gdy Max, Pro i Flex priorytetowo traktują różne proporcje jakości i kontroli." },
                    { q: "Jak naprawić obraz FLUX.2, który nie jest zgodny z moimi wskazówkami?", a: "Dokładniej opisz temat, scenerię, kompozycję, oświetlenie, styl aparatu lub grafiki, kolory i wszelkie wymagane teksty. Użyj przykładów podpowiedzi FLUX.2 na tej stronie jako punktu wyjścia i dostosuj je do swojego projektu." },
                    { q: "Który model FLUX.2 powinienem wybrać?", a: "Wybierz FLUX.2 Klein do szybkich wersji roboczych i partii, Max do najwyższej jakości materiałów finalnych, Pro do generowania obrazów na skalę produkcyjną lub Flex, gdy typografia i precyzyjna kontrola mają największe znaczenie." },
                    { q: "FLUX.2 Max vs Pro: jaka jest różnica?", a: "FLUX.2 Max stawia na najwyższą jakość, skuteczne podążanie za wskazówkami i ugruntowane generowanie. FLUX.2 Pro łączy w sobie jakość produkcyjną, szybszy czas realizacji i skalowalność wyników w codziennych procesach kreatywnych." },
                    { q: "FLUX.2 vs Midjourney: którego powinienem użyć?", a: "Wybierz na podstawie przepływu pracy, a nie uniwersalnego zwycięzcy. FLUX.2 doskonale sprawdza się w przypadku precyzyjnego wykonywania poleceń, typografii, wizualizacji produktów i produkcji opartej na API. Midjourney może odpowiadać twórcom, którzy preferują jego charakterystyczny, artystyczny przepływ pracy i narzędzia społecznościowe." }
                ],
                ctaTitle: "Wypróbuj FLUX.2 za darmo na Miral!",
                ctaDesc: "Wprowadź powyżej swój pomysł i użyj generatora obrazów FLUX.2 AI, aby tworzyć szczegółowe obrazy z wariantem modelu dopasowanym do Twojego procesu pracy."
            },
            seedream: {
                title: "Generator obrazów Seedream AI (darmowy online) | Miral",
                description: "Generuj wysokiej jakości obrazy AI online dzięki Seedream. Uzyskaj precyzyjne, szybkie zrozumienie, wyraźne renderowanie tekstu i szczegółowy wynik 2K-4K dla projektów kreatywnych.",
                heroHeadline: "Generator obrazów Seedream AI",
                heroIntro: "Użyj generatora obrazów Seedream AI za darmo. Zarejestruj się, aby otrzymać darmowe kredyty i natychmiast tworzyć wysokiej jakości wizualizacje produktów, plakaty, portrety i obrazy marketingowe.",
                eyebrow: "ByteDance Seed · Seedream AI",
                sectionKicker: "Seedream AI",
                ctaTag: "Seedream · Miral",
                badges: ["Tekst do obrazu", "Zrozumienie intencji", "Wyjście 2K / 3K / 4K", "Renderowanie czystego tekstu"],
                previewLabel: "Seedream AI",
                previewMeta: ["1:1", "2K / 3K / 4K", "Rozmiar niestandardowy"],
                previewTitle: "Od zamysłu kreatywnego do precyzyjnej wizualizacji o wysokiej rozdzielczości",
                previewDesc: "Twórz złożone kompozycje, zdjęcia produktów, portrety i projekty z bogatym tekstem z dopracowanymi szczegółami i niezawodną kontrolą podpowiedzi.",
                keyFeaturesTitle: "Twórz precyzyjne wizualizacje za pomocą generatora tekstu na obraz Seedream AI",
                keyFeaturesIntro: "Poznaj funkcje Seedream AI, aby uzyskać głębsze zrozumienie intencji, złożoną kompozycję, wydruki w wysokiej rozdzielczości, realistyczne szczegóły i precyzyjne renderowanie tekstu poprzez generowanie tekstu na obraz.",
                exploreTitle: "Poznaj modele Seedream AI",
                mainFeaturesTitle: "Kluczowe funkcje Seedream AI do przetwarzania tekstu na obraz",
                seedream5Desc: "Użyj najnowszego modelu Seedream, aby uzyskać precyzyjne podpowiedzi, wyrafinowany realizm, renderowanie tekstu i wysoką rozdzielczość wydruku.",
                seedream4Desc: "Użyj sprawdzonego procesu roboczego Seedream 4, aby zapewnić niezawodne tworzenie tekstu na obraz i elastyczne ustawienia wyjściowe.",
                features: [
                    { name: "Głębsze zrozumienie podpowiedzi", short: "Interpretuje zamysł twórczy, relacje przestrzenne i szczegółowe instrukcje.", desc: "Seedream AI wykracza poza dopasowywanie pojedynczych terminów. Analizuje relacje między obiektami, układem, atrybutami i kontekstem wizualnym, aby uzyskać bardziej spójne rezultaty na podstawie złożonych instrukcji tekstowych.", demo: { type: 'table', rows: [
                        { prompt: "Półka ekspozycyjna 3x3, widok z przodu, z dziewięcioma różnymi obiektami ułożonymi według materiału i koloru, jednolitym oświetleniem studyjnym i precyzyjnym wyrównaniem przestrzennym.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Zdjęcie produktu do publikacji prasowej przedstawiające zegarek obok złożonego płótna i ceramicznego kubka, zrównoważoną trójkątną kompozycję, delikatne poranne światło.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Scena filmowa na targu z klientami na pierwszym planie, wyraźnym tematem centralnym, wielowarstwową głębią i ciepłym światłem odbijającym się od mokrego chodnika.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Kompleksowa kontrola kompozycji", short: "Obsługuje wiele obiektów, atrybutów i ustrukturyzowanych układów z większą spójnością.", desc: "Generator obrazów Seedream AI wykonuje wieloczęściowe instrukcje w złożonych scenach, pomagając zachować żądane atrybuty obiektów, pozycje, kolory i relacje w jednej kompozycji.", prompt: "Scena redakcyjna z przodu z trzema ceramicznymi wazonami o różnych kształtach na schodkowych kamiennych platformach, czerwoną kulą za najwyższym wazonem, delikatnym oświetleniem bocznym, zrównoważonymi odstępami i neutralnym tłem studyjnym.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "Wyjście 2K, 3K i 4K", short: "Wybierz rozdzielczość wyjściową w oparciu o poziom szczegółowości i wymiary wymagane w projekcie.", desc: "Seedream AI obsługuje wybór rozdzielczości 2K, 3K i 4K w Miral, a także niestandardowe rozmiary obrazu. Wybierz w oparciu o wymiary i poziom szczegółowości wymagany do ostatecznego zastosowania.", prompt: "Szeroki, kinowy krajobraz futurystycznego nadmorskiego miasta o wschodzie słońca, wielowarstwowa architektura, odbijająca woda, głębia atmosferyczna, misterne detale budynków, panoramiczna kompozycja.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Ulepszone renderowanie tekstu", short: "Tworzy wyraźniejszy tekst na plakatach, layoutach, etykietach i grafikach prezentacyjnych.", desc: "Seedream AI łączy w sobie wnioskowanie wizualne z ulepszonym tworzeniem tekstu, co czyni go przydatnym w przypadku plakatów, grafik prezentacyjnych, reklam, koncepcji opakowań i innych układów, w których czytelny tekst jest częścią obrazu.", demo: { type: 'table', rows: [
                        { prompt: "Minimalistyczny plakat wydarzenia z nagłówkiem „PROJEKT NA JUTRO”, pogrubiona czcionka geometryczna, białe tło, zielona siatka akcentowa.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Opakowanie kawy premium z etykietą „MIRAL ROAST”, zwięzłe notatki degustacyjne, ciepła faktura papieru, studyjna fotografia produktowa.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Dopracowany detal i realizm", short: "Tworzy przekonujące oświetlenie, materiały, głębię i prezentację produktu.", desc: "Seedream AI renderuje wyrafinowane tekstury i spójne oświetlenie w fotografii produktowej, portretach, materiałach redakcyjnych i koncepcjach filmowych, gdzie liczy się przejrzystość i wiarygodna struktura.", prompt: "Czyste zdjęcie produktu w stylu editorial, przedstawiające półprzezroczysty, zielony flakon perfum na wapieniu, delikatne poranne światło, subtelne cienie, estetyka kampanii premium.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi Seedream AI dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi Seedream AI jako punktu wyjścia. Opisz jasno tematy, relacje przestrzenne, tekst, oświetlenie i układ, a następnie wyślij podpowiedź bezpośrednio do generatora.",
                variantsKicker: "Przewodnik po rozdzielczościach",
                variantsTitle: "Przewodnik po rozdzielczościach Seedream AI: 2K vs 3K vs 4K",
                variantsIntro: "Wybierz rozdzielczość wyjściową Seedream AI w zależności od tego, jak szybko chcesz iterować i ile szczegółów wymaga ostateczny zasób.",
                variants: [
                    { name: "2K", tag: "Standardowy format wyjściowy", desc: "Praktyczne rozwiązanie dla treści społecznościowych, codziennej pracy kreatywnej i standardowych layoutów cyfrowych.", bestFor: "Najlepsze do standardowych treści cyfrowych" },
                    { name: "3K", tag: "Więcej szczegółowość", desc: "Dodaje więcej szczegółów obrazu i obsługuje większe układy do celów marketingowych i prezentacji.", bestFor: "Najlepsze do materiałów marketingowych i prezentacyjnych" },
                    { name: "4K", tag: "Maksymalna szczegółowość", desc: "Użyj najwyższego ustawienia, gdy liczą się delikatne tekstury, układy z dużą ilością tekstu lub wysoka jakość dostawy.", bestFor: "Najlepsze do ostatecznych kampanii i wydruków w wysokiej rozdzielczości" }
                ],
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia Seedream AI",
                useCases: [
                    { name: "Seedream AI do fotografii produktowej", desc: "Twórz dopracowane zdjęcia produktów, sceny lifestylowe i koncepcje zdjęć e-commerce." },
                    { name: "Seedream AI dla marketingu", desc: "Przekształć ustrukturyzowane pomysły na kampanie w reklamy w mediach społecznościowych, banery i elementy wizualne marki." },
                    { name: "Seedream AI do plakatów i tekstów", desc: "Twórz koncepcje plakatów, grafiki prezentacyjne, etykiety i układy tekstowe." },
                    { name: "Seedream AI do złożonych kompozycji", desc: "Uporządkuj wiele obiektów i żądanych atrybutów w spójną strukturę wizualną." },
                    { name: "Seedream AI do grafiki koncepcyjnej", desc: "Eksploruj filmowe środowiska, postacie i szczegółowe instrukcje wizualne." },
                    { name: "Seedream AI do materiałów wizualnych", desc: "Twórz okładki, ilustracje, infografiki i grafiki gotowe do prezentacji." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów Seedream AI online za darmo",
                howToIntro: "Zarejestruj się, aby otrzymać darmowe kredyty i korzystać z generatora obrazów Seedream AI online z przejrzystym komunikatem i rozdzielczością wymaganą przez Twój projekt.",
                howToSteps: [
                    { title: "Wprowadź swój zamysł twórczy", desc: "Opisz tematy, relacje przestrzenne, kompozycję, oświetlenie, styl i wymagany tekst tak jasno, jak to możliwe." },
                    { title: "Wybierz rozdzielczość i rozmiar", desc: "Otwórz generator i wybierz 2K, 3K, 4K lub obsługiwany rozmiar niestandardowy, w zależności od docelowego zastosowania." },
                    { title: "Generuj i przeglądaj", desc: "Rozpocznij generowanie, sprawdź kompozycję i szczegóły, a następnie pobierz wynik lub dostosuj swój podpowiedź." }
                ],
                howToCta: "Użyj generatora obrazów Seedream AI za darmo",
                faqTitle: "Często zadawane pytania dotyczące Seedream AI",
                faqs: [
                    { q: "Czym jest generator obrazów Seedream AI?", a: "Seedream AI to inteligentny model tworzenia obrazów opracowany przez zespół Seed firmy ByteDance. W systemie Miral przekształca on szczegółowe podpowiedzi tekstowe w obrazy o wysokiej rozdzielczości do celów projektowych, marketingowych, koncepcyjnych, plakatów i materiałów redakcyjnych." },
                    { q: "Jakiego narzędzia mogę użyć do tworzenia plakatów o wysokiej rozdzielczości z czytelnym tekstem?", a: "Seedream AI łączy głębsze zrozumienie intencji, precyzyjną kompozycję, ulepszone tworzenie tekstu oraz możliwość wyboru wydruku w wysokiej rozdzielczości dla plakatów i innych układów z dużą ilością tekstu." },
                    { q: "Czy mogę korzystać z generatora obrazów Seedream AI za darmo?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów Seedream AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów Seedream AI online?", a: "Wprowadź szczegółowy tekst monitu, wybierz rozdzielczość 2K, 3K lub 4K, opcjonalnie wybierz rozmiar niestandardowy i kliknij „Generuj”. Aby uzyskać lepsze rezultaty, jasno opisz tematy, relacje przestrzenne, atrybuty, oświetlenie, tekst i układ." },
                    { q: "Czy Seedream AI obsługuje obrazy 2K, 3K i 4K?", a: "Tak. Miral udostępnia predefiniowane rozdzielczości 2K, 3K i 4K dla Seedream AI, a także obsługuje niestandardowe wymiary dla różnych proporcji obrazu i potrzeb związanych z dostawą." },
                    { q: "Jak naprawić obrazy Seedream z nieprawidłowym tekstem lub kompozycją?", a: "Opisz temat, relacje między obiektami, kompozycję, oświetlenie, kolory, styl i wymagany tekst bardziej szczegółowo. Wykorzystaj przykłady Seedream na tej stronie jako punkt wyjścia i jasno określ każde wymaganie wizualne." },
                    { q: "Którą rozdzielczość Seedream AI powinienem wybrać?", a: "Wybierz rozdzielczość 2K dla standardowych treści cyfrowych, 3K, gdy materiały marketingowe lub układy prezentacji wymagają większej szczegółowości, oraz 4K, gdy maksymalna szczegółowość jest ważna w przypadku dużych kampanii finalnych, plakatów lub materiałów projektowych premium." },
                    { q: "Seedream AI vs Midjourney: którego powinienem użyć?", a: "Seedream AI doskonale sprawdza się w przypadku ustrukturyzowanych podpowiedzi, złożonych kompozycji, układów z dużą ilością tekstu oraz w przypadku plików wyjściowych o wysokiej rozdzielczości z możliwością wyboru w programie Miral. Midjourney może odpowiadać twórcom, którzy preferują jego charakterystyczny, artystyczny przepływ pracy i narzędzia społecznościowe." }
                ],
                ctaTitle: "Korzystaj z Seedream AI za darmo na Miral!",
                ctaDesc: "Zarejestruj się, aby otrzymać darmowe punkty. Opisz swój pomysł, wybierz odpowiednią rozdzielczość i użyj generatora obrazów Seedream AI, aby tworzyć precyzyjne wizualizacje o wysokiej rozdzielczości."
            },
            gptImage: {
                title: "Generator obrazów GPT Image AI – darmowy online | Miral",
                description: "Generuj wysokiej jakości obrazy AI online za pomocą GPT Image i GPT-Image-1.5 w Miral AI. Wybierz praktyczne rozmiary i poziomy jakości plakatów, produktów i portretów.",
                heroHeadline: "Generator obrazów GPT Image AI",
                heroIntro: "Skorzystaj z generatora obrazów GPT Image AI za darmo w Miral AI. Zarejestruj się, aby otrzymać darmowe kredyty i natychmiast tworzyć wysokiej jakości zdjęcia produktów, plakaty, portrety i materiały marketingowe dzięki GPT-Image-1.5.",
                eyebrow: "OpenAI · GPT-Image-1.5",
                sectionKicker: "Obraz GPT",
                ctaTag: "Obraz GPT · Miral",
                badges: ["Tekst do obrazu", "Wybór jakości", "Poziomy/Pionowy/Kwadratowy", "Precyzyjne zrozumienie treści"],
                previewLabel: "Obraz GPT-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "Od pisemnego pomysłu do dopracowanego, praktycznego obrazu AI",
                previewDesc: "Użyj przejrzystych wskazówek i możliwości wyboru jakości, aby tworzyć wizualizacje produktów, plakaty, portrety i treści marki.",
                keyFeaturesTitle: "Twórz wysokiej jakości wizualizacje za pomocą generatora obrazów GPT Image AI",
                keyFeaturesIntro: "Poznaj funkcje GPT-Image-1.5, aby zapewnić szybkie zrozumienie, kontrolę jakości, praktyczne rozmiary obrazów i profesjonalne tworzenie wizualizacji.",
                features: [
                    { name: "Podpowiedzi w języku naturalnym i wielotematyczne", short: "Opisuj tematy, kompozycję, oświetlenie, styl i relacje wizualne w języku naturalnym.", desc: "Generator obrazów GPT Image AI obsługuje komunikaty w języku naturalnym z wieloma tematami, atrybutami i wymaganiami dotyczącymi kompozycji. Zacznij od prostego komunikatu lub określ położenie, kolor i relację każdego tematu, aby stworzyć bardziej spójne obrazy wielotematyczne.", demo: { type: 'table', rows: [
                        { prompt: "Fotografia produktu redakcyjnego przedstawiająca przezroczysty flakon perfum na jasnym kamiennym cokole, delikatne poranne światło z lewej strony, czyste tło, mała głębia ostrości, estetyka marki premium.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Deszczowa ulica miasta nocą, trzech pieszych na pierwszym planie trzymających parasole w różnych kolorach, przejeżdżający w oddali tramwaj, neon odbijający się na mokrym chodniku, kinowa, szeroka kompozycja.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "Kontrola jakości GPT-Image-1.5", short: "Wybierz opcję Auto, Niska, Średnia lub Wysoka w zależności od potrzeb dotyczących szybkości i szczegółowości.", desc: "GPT-Image-1.5 oferuje ustawienia automatyczne, niskiej, średniej i wysokiej jakości. Użyj niższej jakości do szybkiej eksploracji, a wyższej jakości dla finalnych obrazów produktów, plakatów lub materiałów marketingowych.", prompt: "Wysokiej jakości reklama kulinarna z tortem truskawkowym na czarnym tle, o wyrazistej konsystencji kremu, delikatnym świetle krawędziowym, szczegółowa fotografia kulinarna, kompozycja komercyjna.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Trzy praktyczne rozmiary obrazów", short: "Twórz wydruki kwadratowe, poziome i pionowe.", desc: "Wybierz rozdzielczość 1024×1024, 1536×1024 lub 1024×1536 dla postów w mediach społecznościowych, banerów i materiałów wizualnych do prezentacji, a także plakatów portretowych i treści mobilnych.", prompt: "Portretowy plakat podróżniczy o wymiarach 1024×1536 z nadmorskim klifem i latarnią morską w porannej mgle, z miejscem na nagłówek u góry, nowoczesny układ redakcyjny.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Wyraźny tekst i tworzenie układu", short: "Twórz koncepcje plakatów, etykiet i marek zawierające tekst.", desc: "Dzięki jasnemu określeniu wymaganego tekstu, umiejscowienia, nastroju typograficznego i relacji między układem, GPT Image może pomóc w eksploracji plakatów, opakowań, grafik eventowych i obrazów marketingowych za pomocą nagłówków.", demo: { type: 'table', rows: [
                        { prompt: "Minimalistyczny plakat na wydarzenie technologiczne z nagłówkiem „STWÓRZ PRZYSZŁOŚĆ”, pogrubioną czcionką bezszeryfową, ciemnoniebieskim tłem, zieloną siatką geometryczną i wyraźnym, wyśrodkowanym nagłówkiem.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Koncepcja opakowania kawy premium z napisem „MIRAL ROAST” z przodu, ciepła, brązowa faktura papieru, czysta etykieta, studyjne zdjęcia produktów.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Szczegółowość i realizm", short: "Renderuj wiarygodne materiały, oświetlenie, osoby i szczegóły produktów.", desc: "GPT Image sprawdza się w fotografii produktowej, portretach, wnętrzach i materiałach redakcyjnych, gdy polecenie jasno opisuje materiały, wybór aparatu, oświetlenie i głębię ostrości.", prompt: "Zbliżony portret redakcyjny artysty ceramika w naturalnym świetle okna, realistyczna faktura skóry, gliniany pył na dłoniach, tło warsztatowe, mała głębia ostrości, ciepła fotografia redakcyjna.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi dla obrazu GPT dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych podpowiedzi graficznych GPT jako punktu wyjścia. Jasno opisz temat, kompozycję, oświetlenie, styl, materiały i ewentualny wymagany tekst.",
                variantsKicker: "Przewodnik po wersjach",
                variantsTitle: "GPT-Image-1.5 vs GPT-Image-1",
                variantsIntro: "Wybierz wersję obrazu GPT w zależności od tego, czy potrzebujesz kontroli jakości. Obie wersje obsługują praktyczne formaty kwadratowe, poziome i pionowe.",
                variants: [
                    { name: "Obraz GPT-1.5", tag: "Zalecana", desc: "Obsługuje rozdzielczości 1024×1024, 1536×1024 i 1024×1536 z opcjami automatycznej, niskiej, średniej i wysokiej jakości.", bestFor: "Najlepszy do codziennej i profesjonalnej pracy wymagającej kontroli jakości" },
                    { name: "Obraz GPT-1", tag: "Klasyczna", desc: "Obsługuje te same trzy praktyczne rozmiary obrazu z prostszym zestawem elementów sterujących.", bestFor: "Najlepszy do prostego, uniwersalnego tworzenia tekstu na obraz" }
                ],
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia obrazów GPT",
                useCases: [
                    { name: "Obraz GPT do fotografii produktów i makiet", desc: "Twórz obrazy produktów, sceny lifestylowe, makiety produktów i koncepcje wizualne e-commerce." },
                    { name: "Obraz GPT do obrazów ofert e-commerce", desc: "Przeglądaj zdjęcia produktów, grafiki wyróżnione, ekspozycje opakowań i koncepcje reklamowe." },
                    { name: "Obraz GPT do reklam marketingowych i w mediach społecznościowych", desc: "Twórz reklamy do mediów społecznościowych, banery kampanii, banery e-mailowe i materiały wizualne do marketingu marki." },
                    { name: "Obraz GPT dla interfejsu użytkownika/doświadczenia użytkownika i układów stron internetowych", desc: "Generuj koncepcje wizualne dla interfejsów aplikacji, układów stron internetowych, landing page'y i stron prezentujących produkty." },
                    { name: "Obraz GPT do infografik i raportów wizualnych", desc: "Poznaj koncepcje układu infografik, raportów wizualnych i grafik prezentacyjnych; zweryfikuj cały tekst i dane przed ostatecznym użyciem." },
                    { name: "Obraz GPT do plakatów i opakowań produktów", desc: "Eksploruj plakaty, etykiety produktów i projekty opakowań z uwzględnieniem wymagań dotyczących nagłówków i układu." },
                    { name: "Obraz GPT do książek Okładki i obrazy blogowe", desc: "Twórz okładki książek, ilustracje redakcyjne, nagłówki blogów i wizualne koncepcje wydawnicze." },
                    { name: "Obraz GPT do portretów", desc: "Twórz portrety redakcyjne z kontrolowanym oświetleniem, tłami i stylizacją." },
                    { name: "Obraz GPT do konceptów postaci w grach", desc: "Szybko poznaj postacie z gier, kostiumy, rekwizyty i różne kierunki artystyczne." },
                    { name: "Obraz GPT do środowisk gier", desc: "Generuj środowiska gier, sceny filmowe i koncepcje budowania świata na potrzeby wczesnych etapów kreatywnej eksploracji." },
                    { name: "Obraz GPT do treści społecznościowych", desc: "Generuj obrazy kwadratowe, poziome i pionowe dla różnych platform." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak bezpłatnie korzystać z generatora obrazów GPT Image AI online?",
                howToIntro: "Zarejestruj się, aby otrzymać darmowe kredyty i korzystać z generatora obrazów GPT Image AI online na Miral.",
                howToSteps: [
                    { title: "Wprowadź szczegółowy monit", desc: "Opisz temat, scenerię, kompozycję, oświetlenie, styl, materiały i wszelkie wymagane teksty." },
                    { title: "Wybierz rozmiar i jakość", desc: "Wybierz format kwadratowy, poziomy lub pionowy i ustaw jakość GPT-Image-1.5 w zależności od potrzeb." },
                    { title: "Generuj i przeglądaj", desc: "Rozpocznij generowanie, sprawdź i pobierz obraz lub dostosuj podpowiedź i utwórz kolejną wersję." }
                ],
                howToCta: "Użyj darmowego generatora obrazów GPT Image AI",
                faqTitle: "Często zadawane pytania dotyczące obrazu GPT",
                faqs: [
                    { q: "Czym jest generator obrazów GPT Image AI?", a: "GPT Image to rodzina uniwersalnych modeli przekształcających tekst na obraz firmy OpenAI. W systemie Miral, generator obrazów GPT Image AI przekształca polecenia tekstowe w wysokiej jakości obrazy do zastosowań w projektowaniu, marketingu, koncepcjach produktów, plakatach i mediach społecznościowych." },
                    { q: "Czy mogę bezpłatnie korzystać z generatora obrazów GPT Image AI?", a: "Tak. Zarejestruj się, aby otrzymać darmowe kredyty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów GPT Image AI. Generowanie obrazów wykorzystuje odpowiednie kredyty." },
                    { q: "Jak korzystać z generatora obrazów GPT Image AI online?", a: "Wprowadź szczegółowy podpowiedź i wybierz rozdzielczość 1024×1024, 1536×1024 lub 1024×1536. W GPT-Image-1.5 możesz również wybrać jakość automatyczną, niską, średnią lub wysoką przed kliknięciem przycisku Generuj." },
                    { q: "Jaka jest różnica między GPT-Image-1.5 a GPT-Image-1?", a: "Obie wersje obsługują te same trzy praktyczne rozmiary obrazów. GPT-Image-1.5 w systemie Miral oferuje również automatyczną, niską, średnią i wysoką kontrolę jakości, podczas gdy GPT-Image-1 ma prostszy zestaw parametrów." },
                    { q: "Jakie rozmiary obrazów obsługuje GPT Image?", a: "W systemie Miral, GPT-Image-1 i GPT-Image-1.5 obsługują obrazy kwadratowe o rozdzielczości 1024×1024, poziome 1536×1024 i portretowe 1024×1536." },
                    { q: "Jaką jakość obrazu GPT powinienem wybrać?", a: "Wybierz niską lub średnią wartość, gdy szybko testujesz monity, wysoką wartość dla gotowych zdjęć produktów, plakatów lub materiałów marketingowych, a automatyczną, gdy nie masz pewności. Opcje jakości dotyczą GPT-Image-1.5." },
                    { q: "Jak naprawić wyniki wyszukiwania obrazów GPT, które nie pasują do mojego monitu?", a: "Opisz temat, scenerię, kompozycję, oświetlenie, kamerę, materiały, styl i wymagany tekst bardziej szczegółowo. Wykorzystaj przykłady obrazów GPT na tej stronie jako punkt wyjścia i dostosuj je do swojego projektu." },
                    { q: "Czy potrzebuję natychmiastowego doświadczenia inżynierskiego, aby korzystać z GPT Image?", a: "Nie. Zacznij od prostego, naturalnego komunikatu, a następnie dodaj pozycje obiektów, kompozycję, oświetlenie, kolory, materiały i wymagania tekstowe w razie potrzeby. Jaśniejsze opisy zazwyczaj pomagają uzyskać efekt bardziej zgodny z zamysłem twórczym." },
                    { q: "Jakiego narzędzia mogę użyć do tworzenia obrazów produktów e-commerce, plakatów i koncepcji interfejsu użytkownika?", a: "GPT Image może tworzyć obrazy ofert e-commerce, makiety produktów, plakaty, koncepcje UI/UX, układy stron internetowych, układy infografik, okładki książek, obrazy blogowe, banery e-mail i koncepcje gier. Przed ostatecznym użyciem należy zweryfikować tekst, dane, elementy marki i szczegóły strukturalne." },
                    { q: "Obraz GPT kontra Midjourney: którego powinienem użyć?", a: "GPT Image doskonale sprawdza się w przypadku przejrzystego sterowania monitami, praktycznych rozmiarów obrazów i bezpośredniego generowania w przeglądarce. Midjourney może odpowiadać użytkownikom, którzy preferują jego artystyczne style, przepływ pracy z obrazami referencyjnymi i proces twórczy." }
                ],
                ctaTitle: "Użyj GPT Image za darmo w Miral!",
                ctaDesc: "Zarejestruj się, aby otrzymać darmowe kredyty. Opisz swój pomysł, wybierz rozmiar i jakość, a następnie użyj generatora obrazów GPT Image AI, aby tworzyć wysokiej jakości wizualizacje."
            },
            qwenImage2Pro: {
                title: "Generator obrazów Qwen Image 2.0 Pro AI – darmowy online | Miral",
                description: "Twórz obrazy AI online za pomocą Qwen Image 2.0 Pro. Korzystaj z negatywów, udoskonalania podpowiedzi, elastycznych proporcji i generuj do czterech obrazów na raz.",
                heroHeadline: "Generator obrazów AI Qwen Image 2.0 Pro",
                heroIntro: "Korzystaj z generatora obrazów Qwen Image 2.0 Pro AI za darmo w Miral AI. Zarejestruj się, aby otrzymać darmowe punkty i szybko tworzyć wysokiej jakości obrazy z negatywami, poprawkami i elastycznymi proporcjami obrazu.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Image 2.0 Pro",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["Tekst do obrazu", "Negatywny komunikat", "Ulepszenie komunikatu", "1-4 obrazy / seria", "Elastyczne proporcje obrazu"],
                previewLabel: "Qwen Image 2.0 Pro",
                previewMeta: ["1:1", "2048 × 2048", "Do 1-4 obrazów"],
                previewTitle: "Od precyzyjnego komunikatu z wykluczeniami po dopracowane wizualizacje",
                previewDesc: "Połącz pozytywne podpowiedzi z negatywnymi podpowiedziami i udoskonaleniem podpowiedzi, aby wygenerować wiele docelowych obrazów w jednym przebiegu.",
                keyFeaturesTitle: "Twórz precyzyjne wizualizacje za pomocą generatora tekstu na obraz Qwen Image 2.0 Pro",
                keyFeaturesIntro: "Poznaj kluczowe funkcje generatora obrazów Qwen Image 2.0 Pro AI, które zapewniają precyzyjną kontrolę, negatywy, natychmiastową poprawę jakości, generowanie partii zdjęć i elastyczne proporcje obrazu.",
                mainFeaturesTitle: "Kluczowe możliwości Qwen Image 2.0 Pro",
                promptLabel: "Pozytywny komunikat",
                negativePromptLabel: "Negatywny komunikat",
                shortPromptLabel: "Krótki komunikat",
                negativePromptFallback: "Niska przejrzystość, zniekształcone szczegóły, chaotyczna kompozycja",
                features: [
                    { name: "Sterowanie negatywną podpowiedzią", short: "Opisz, co należy wykluczyć, aby uzyskać czystsze, zgodne z oczekiwaniami rezultaty.", desc: "Generator obrazów AI Qwen Image 2.0 Pro obsługuje dedykowane podpowiedzi negatywowe, dzięki czemu możesz wskazać modelowi, czego ma unikać — na przykład niskiej przejrzystości, zdeformowanych dłoni lub nieuporządkowanej kompozycji. Daje to większą kontrolę nad ostatecznym obrazem i zmniejsza konieczność wielokrotnego przewijania.", demo: { type: 'table', rows: [
                        { prompt: "Wysokiej jakości zdjęcie produktu przedstawiające szklaną butelkę z kosmetykami na mokrym kamieniu, delikatne poranne światło, czyste tło. (Negatyw: chaotyczne tło, niska rozdzielczość, zdeformowane odbicia).", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Portret młodej kobiety w jesiennym świetle, naturalna tekstura skóry, mała głębia ostrości. (Negatyw: nadmiernie wygładzona skóra, woskowy wygląd, przesycone kolory).", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Ulepszenie komunikatu", short: "Opcjonalnie rozszerz krótki komunikat, dodając więcej szczegółów.", desc: "Włącz funkcję ulepszania podpowiedzi, a Qwen Image 2.0 Pro automatycznie wzbogaci krótką podpowiedź o dodatkowe szczegóły przed jej wygenerowaniem. Dzięki temu podpowiedzi mniej wymagające od specjalistów tworzą pełniejsze, żywe obrazy bez konieczności ręcznego przepisywania.", demo: { type: 'table', rows: [
                        { prompt: "Przytulny kącik do czytania przy deszczowym oknie.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Drewniane biurko do czytania przy deszczowym oknie w nocy, ciepła lampa oświetlająca otwartą książkę i parującą herbatę, ciche i przytulne wnętrze.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Generuj 1-4 obrazy naraz", short: "Tworzenie wielu wariantów w jednym cyklu.", desc: "Qwen Image 2.0 Pro może wygenerować do czterech obrazów na żądanie, dzięki czemu możesz porównywać warianty koncepcji, kąta widzenia lub stylu obok siebie i wybrać najlepszy. Przyspiesza to kreatywną eksplorację w wizualizacjach marketingowych i produktowych.", prompt: "Minimalistyczna ceramiczna lampa stołowa na orzechowym stoliku bocznym, ciepłe wieczorne wnętrze, kremowa ściana, miękkie cienie, skandynawska fotografia produktów.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Elastyczne proporcje obrazu", short: "Wybierz rozmiar poziomy, pionowy, kwadratowy lub niestandardowy.", desc: "Wybierz spośród gotowych proporcji obrazu, takich jak 2688×1536 (poziomo), 1536×2688 (pionowo), 2048×2048 (kwadrat) i 2368×1728/1728×2368, lub wprowadź niestandardowy rozmiar od 512×512 do 2048×2048. Dzięki temu generator tekstu na obraz Qwen Image 2.0 Pro nadaje się zarówno do banerów, plakatów, postów w mediach społecznościowych, jak i kwadratowych miniatur.", prompt: "Kinowe, szerokie ujęcie krajobrazowe nadmorskiego klifu o złotej godzinie, dramatyczne chmury, drobne detale skalne, 2688 × 1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Dopracowany detal i realizm", short: "Renderuj realistyczne tekstury, oświetlenie i głębię.", desc: "Qwen Image 2.0 Pro zapewnia doskonałe tekstury, realistyczne oświetlenie i naturalną głębię, dzięki czemu doskonale sprawdza się w fotografii produktowej, portretach i materiałach redakcyjnych, gdzie liczy się wiarygodność.", prompt: "Portret starszego artysty ceramika w zbliżeniu w słonecznym warsztacie, naturalna faktura skóry, gliniany pył na dłoniach, ciepłe światło z okna, niewielka głębia ostrości.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi Qwen Image 2.0 Pro dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi Qwen Image 2.0 Pro jako punktu wyjścia. Połącz każdą pozytywną podpowiedź z negatywną, aby usunąć niepożądane elementy, a następnie wyślij ją bezpośrednio do generatora.",
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro do fotografii produktowej", desc: "Twórz czyste zdjęcia produktów z kontrolowanym tłem, używając negatywów podpowiedzi, aby usunąć bałagan." },
                    { name: "Qwen Image 2.0 Pro dla marketingu", desc: "Twórz koncepcje kampanii, reklamy społecznościowe i banery w różnych proporcjach obrazu." },
                    { name: "Qwen Image 2.0 Pro dla plakatów i typografii", desc: "Twórz projekty plakatów i bogate w tekst projekty z czytelnymi nagłówkami i etykietami." },
                    { name: "Qwen Image 2.0 Pro do portretów", desc: "Twórz szczegółowe portrety z naturalną teksturą skóry, korzystając z negatywów, aby uniknąć artefaktów." },
                    { name: "Qwen Image 2.0 Pro do grafiki koncepcyjnej", desc: "Eksploruj postacie, otoczenie i wskazówki wizualne, korzystając z 1–4 wariantów na przebieg." },
                    { name: "Qwen Image 2.0 Pro dla e-commerce", desc: "Tworzenie wielu wariantów obrazów dla ofert i reklam w jednym pokoleniu." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów AI Qwen Image 2.0 Pro online",
                howToIntro: "Użyj generatora obrazów Qwen Image 2.0 Pro AI online w Miral z pozytywnymi i negatywnymi podpowiedziami oraz elastycznymi opcjami wyjściowymi.",
                howToSteps: [
                    { title: "Wprowadź swoją główną podpowiedź", desc: "Opisz pożądany obiekt, scenę, kompozycję, oświetlenie, styl i szczegóły wizualne." },
                    { title: "Konfiguruj sterowanie generacją", desc: "Dodaj negatyw monitu, włącz funkcję ulepszania monitu, wybierz rozmiar i wybierz od jednego do czterech obrazów." },
                    { title: "Generuj i porównuj", desc: "Rozpocznij generowanie, porównaj zwrócone warianty i pobierz obraz, który najlepiej odpowiada Twoim zamierzeniom." }
                ],
                howToCta: "Wypróbuj generator obrazów AI Qwen Image 2.0 Pro",
                faqTitle: "Często zadawane pytania dotyczące Qwen Image 2.0 Pro",
                faqs: [
                    { q: "Czym jest generator obrazów Qwen Image 2.0 Pro AI?", a: "Qwen Image 2.0 Pro to model przekształcający tekst na obraz firmy Alibaba, Tongyi Qwen. Generator obrazów Qwen Image 2.0 Pro AI przekształca polecenia tekstowe w wysokiej jakości, szczegółowe obrazy i jest dostępny w systemie Miral do tworzenia grafiki, projektowania, marketingu i wizualizacji produktów bezpośrednio w przeglądarce." },
                    { q: "Jakiego narzędzia mogę użyć do utworzenia wielu wariantów obrazu produktu z negatywami?", a: "Qwen Image 2.0 Pro oferuje dedykowany negatyw, opcjonalną korektę, od 1 do 4 zdjęć na serię oraz elastyczne proporcje obrazu do fotografii produktowej, marketingu i wariacji wizualnych dla e-commerce." },
                    { q: "Czy mogę bezpłatnie korzystać z generatora obrazów Qwen Image 2.0 Pro AI?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów Qwen Image 2.0 Pro AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów Qwen Image 2.0 Pro AI online?", a: "Wprowadź szczegółowy tekst polecenia, opcjonalnie dodaj polecenie negatywne opisujące, czego należy unikać, w razie potrzeby włącz funkcję ulepszania poleceń, wybierz proporcje obrazu lub niestandardowy rozmiar, ustaw liczbę generowanych obrazów (1-4) i kliknij „Generuj”. Qwen Image 2.0 Pro sprawdza się w przypadku materiałów marketingowych, fotografii produktów, portretów i projektów plakatów." },
                    { q: "Jak naprawić niechciane elementy w wynikach wyszukiwania Qwen Image 2.0 Pro?", a: "Dodaj komunikat negatywny opisujący elementy, których nie chcesz, takie jak słaba przejrzystość, zdeformowane dłonie lub zagracone tło. Qwen Image 2.0 Pro używa go, aby odciągnąć generację od takich rezultatów." },
                    { q: "Ile obrazów może wygenerować Qwen Image 2.0 Pro jednocześnie?", a: "Qwen Image 2.0 Pro może wygenerować do 4 obrazów w jednym żądaniu (n = 1 do 4), dzięki czemu możesz porównać warianty koncepcji, kąta widzenia lub stylu i wybrać najlepszy." },
                    { q: "Jakie rozmiary i proporcje obrazu obsługuje Qwen Image 2.0 Pro?", a: "W systemie Miral aplikacja Qwen Image 2.0 Pro oferuje gotowe proporcje, takie jak 2688×1536, 1536×2688, 2048×2048, 2368×1728 i 1728×2368, a także rozmiar niestandardowy od 512×512 do 2048×2048. Obejmuje to orientację poziomą, pionową i kwadratową dla banerów, plakatów, postów w mediach społecznościowych i miniatur." },
                    { q: "Jakie są najlepsze przykłady podpowiedzi Qwen Image 2.0 Pro?", a: "Skuteczne polecenia Qwen Image 2.0 Pro jasno opisują temat, scenerię, kompozycję, oświetlenie i styl, a następnie łączą polecenie pozytywne z poleceniem negatywnym, aby usunąć niepożądane szczegóły. Wykorzystaj przykłady poleceń Qwen Image 2.0 Pro na tej stronie jako punkt wyjścia i dostosuj je do swojego projektu." },
                    { q: "Generator obrazów Qwen Image 2.0 Pro kontra Midjourney: którego powinienem użyć?", a: "Wybieraj w oparciu o przepływ pracy, a nie o uniwersalnego zwycięzcę. Qwen Image 2.0 Pro to idealne rozwiązanie, gdy potrzebujesz wyraźnych, negatywnych podpowiedzi, ulepszeń podpowiedzi, 1-4 obrazów na wydruk i elastycznych proporcji obrazu w generatorze przeglądarkowym Miral. Midjourney może odpowiadać twórcom, którzy preferują jego charakterystyczny, artystyczny przepływ pracy i narzędzia społecznościowe." }
                ],
                ctaTitle: "Wypróbuj Qwen Image 2.0 Pro za darmo w Miral!",
                ctaDesc: "Wprowadź powyżej swój pomysł i użyj generatora obrazów Qwen Image 2.0 Pro AI z opcjonalnymi elementami sterującymi, aby tworzyć precyzyjne wariacje obrazów."
            },
            stableDiffusion: {
                title: "Generator obrazów Stable Diffusion 3.5 AI – darmowy online | Miral",
                description: "Generuj obrazy AI online za pomocą Stable Diffusion 3.5. Korzystaj z negatywów, predefiniowanych współczynników proporcji i niestandardowych rozmiarów od 512 do 2048 pikseli w Miral.",
                heroHeadline: "Generator obrazów AI Stable Diffusion 3.5",
                heroIntro: "Korzystaj z generatora obrazów Stable Diffusion 3.5 AI za darmo w Miral AI. Zarejestruj się, aby otrzymać darmowe punkty i szybko tworzyć wysokiej jakości obrazy ze szczegółowymi negatywami, negatywami i elastycznymi rozmiarami.",
                eyebrow: "Stabilność AI · Stabilna dyfuzja 3.5",
                sectionKicker: "Stabilna dyfuzja 3.5",
                ctaTag: "Stabilna dyfuzja 3.5 · Miral",
                badges: ["Tekst do obrazu", "Negatywny komunikat", "Elastyczne proporcje obrazu", "Rozmiar niestandardowy"],
                previewLabel: "Stabilna dyfuzja 3.5",
                previewMeta: ["1:1", "512 – 2048", "Wielokrotności 64"],
                previewTitle: "Od szczegółowego monitu do kontrolowanego, dopracowanego obrazu",
                previewDesc: "Połącz pozytywne podpowiedzi z negatywnymi i wybierz odpowiedni format obrazu, aby Stable Diffusion 3.5 tworzył czyste, trafne wizualizacje.",
                keyFeaturesTitle: "Twórz kontrolowane wizualizacje za pomocą generatora tekstu na obraz Stable Diffusion 3.5",
                keyFeaturesIntro: "Poznaj kluczowe funkcje generatora obrazów Stable Diffusion 3.5 AI, które umożliwiają tworzenie negatywów podpowiedzi, elastyczne proporcje obrazu, niestandardowe rozmiary i szczegółowe zrozumienie podpowiedzi.",
                exploreTitle: "Odkryj więcej modeli obrazów AI",
                mainFeaturesTitle: "Kluczowe funkcje Stable Diffusion 3.5",
                generatedImageLabel: "Wygenerowany obraz",
                versionLabel: "Kontrola",
                featureLabel: "Co zmienia",
                useCaseLabel: "Najlepsza Dla",
                variantsTitle: "Sterowanie wyjściem Stable Diffusion 3.5",
                variantsIntro: "Połącz model Stable Diffusion 3.5 z predefiniowanymi proporcjami obrazu lub dokładnymi, niestandardowymi wymiarami w zależności od potrzebnego układu.",
                variants: [
                    { name: "Stabilna dyfuzja 3.5", desc: "Szczegółowe generowanie tekstu na obraz z kontrolą zachęty dodatniej i ujemnej.", bestFor: "Wizualizacje produktów, portrety, grafiki koncepcyjne i obrazy marketingowe." },
                    { name: "Wstępnie ustawiony aspekt Proporcje obrazu", desc: "Gotowe wymiary wyjściowe: poziomy, pionowy i kwadratowy.", bestFor: "Posty w mediach społecznościowych, banery, plakaty i miniatury." },
                    { name: "Niestandardowy rozmiar obrazu", desc: "Dokładna szerokość i wysokość od 512 do 2048, wielokrotności 64.", bestFor: "Układaj sloty i projekty wymagające precyzyjnych wymiarów pikseli." }
                ],
                controlsTitle: "Wybierz odpowiednie elementy sterujące i rozmiar obrazu",
                controlsIntro: "Użyj negatywnej podpowiedzi, aby zredukować niepożądane szczegóły, a następnie wybierz predefiniowany współczynnik lub wprowadź niestandardowe wymiary dla wybranego kanału.",
                galleryTitle: "Przykłady bardziej stabilnych obrazów z dyfuzją 3.5",
                discussionTitle: "Typowe pytania dotyczące Stable Diffusion 3.5",
                communityTitle: "Popularne sposoby tworzenia z użyciem Stable Diffusion 3.5",
                tutorialPrompt: "Zdjęcie redakcyjne produktu przedstawiające rzeźbiarski głośnik ceramiczny na jasnym kamieniu, łagodne poranne światło padające z okna, realistyczna faktura, zrównoważona kompozycja, subtelne cienie, czyste tło.",
                qualityBenefits: [
                    "Użyj negatywów, aby zmniejszyć bałagan, zniekształcone szczegóły i niepożądane style wizualne.",
                    "Postępuj zgodnie z warstwowymi opisami obiektu, kompozycji, oświetlenia, materiałów i nastroju.",
                    "Twórz obrazy poziome, pionowe i kwadratowe z ustawieniami domyślnymi lub precyzyjnymi wymiarami niestandardowymi."
                ],
                features: [
                    { name: "Sterowanie negatywną podpowiedzią", short: "Opisz, co należy wykluczyć, aby uzyskać czystsze, zgodne z oczekiwaniami rezultaty.", desc: "Generator obrazów Stable Diffusion 3.5 AI obsługuje dedykowany negatywowy komunikat, dzięki czemu możesz wskazać modelowi, czego unikać — na przykład niskiej przejrzystości, zdeformowanych dłoni lub zagraconego tła. Daje to większą kontrolę nad ostatecznym obrazem i zmniejsza konieczność wielokrotnego przewijania.", demo: { type: 'table', rows: [
                        { prompt: "Wysokiej jakości zdjęcie produktu przedstawiające matowy, czarny ceramiczny wazon na marmurowym cokole, miękkie światło studyjne, czyste tło. (Negatyw: chaotyczne tło, niska rozdzielczość, zdeformowane odbicia.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Portret młodego mężczyzny w miękkim świetle padającym przez okno, naturalna faktura skóry, mała głębia ostrości. (Negatyw: nadmiernie wygładzona skóra, woskowy wygląd, przesycone kolory).", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Elastyczne proporcje obrazu", short: "Wybierz format poziomy, pionowy, kwadratowy lub niestandardowy.", desc: "Wybierz spośród gotowych proporcji obrazu, takich jak 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 i 1536×1536, lub wprowadź niestandardowy rozmiar od 512×512 do 2048×2048. Dzięki temu generator tekstu na obraz Stable Diffusion 3.5 nadaje się zarówno do banerów, plakatów, postów w mediach społecznościowych, jak i kwadratowych miniatur.", prompt: "Kinowe, szerokie ujęcie krajobrazowe nadmorskiego klifu o złotej godzinie, dramatyczne chmury, drobne detale skalne, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Niestandardowe rozmiary obrazu", short: "Ustaw dokładne wymiary pikseli, aby uzyskać precyzyjny wynik.", desc: "Jeśli predefiniowany rozmiar nie pasuje, przełącz się na niestandardowy i wprowadź dowolną szerokość i wysokość od 512 do 2048, wielokrotność 64. Pozwala to dopasować konkretny układ, miejsce na baner lub aspekt wydruku bez ręcznego przycinania.", prompt: "Minimalistyczne tło plakatu z wyśrodkowaną kompozycją geometryczną, głębokim niebieskim gradientem, delikatnym usłojeniem, 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Szczegółowe zrozumienie podpowiedzi", short: "Podąża za warstwowymi opisami tematu, światła i stylu.", desc: "Stable Diffusion 3.5 odczytuje warstwowe instrukcje tekstowe i renderuje opisany przez Ciebie temat, scenerię, oświetlenie i nastrój. Połącz jasną, pozytywną zachętę z negatywną, aby uzyskać efekt bliższy zamierzonemu efektowi w mniejszej liczbie prób.", demo: { type: 'table', rows: [
                        { prompt: "Zdjęcie redakcyjne przedstawiające zegarek naręczny obok złożonej pościeli i ceramicznego kubka, zrównoważona trójkątna kompozycja, delikatne poranne światło.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Przytulny kącik do czytania przy deszczowym oknie, ciepłe światło lampy, stosy książek, teksturowany koc, kinowy nastrój.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Dopracowany detal i realizm", short: "Tworzenie wiarygodnego oświetlenia, materiałów i głębi.", desc: "Stable Diffusion 3.5 generuje precyzyjne tekstury, realistyczne oświetlenie i naturalną głębię, dzięki czemu generator obrazów Stable Diffusion 3.5 AI doskonale sprawdza się w fotografii produktowej, portretach, grafikach koncepcyjnych i materiałach redakcyjnych, gdzie liczy się wiarygodność.", prompt: "Portret starszego artysty ceramika w zbliżeniu w słonecznym warsztacie, naturalna faktura skóry, gliniany pył na dłoniach, ciepłe światło z okna, niewielka głębia ostrości.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi do stabilnej dyfuzji 3.5 dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi do programu Stable Diffusion 3.5 jako punktu wyjścia. Jasno opisz temat, kompozycję, oświetlenie i styl, połącz każdą podpowiedź z podpowiedzią negatywną, a następnie wyślij ją bezpośrednio do generatora.",
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia Stable Diffusion 3.5",
                useCases: [
                    { name: "Stabilna dyfuzja 3.5 do fotografii produktowej", desc: "Twórz czyste zdjęcia produktów z kontrolowanym tłem, używając negatywów podpowiedzi, aby usunąć bałagan." },
                    { name: "Stable Diffusion 3.5 dla marketingu", desc: "Twórz koncepcje kampanii, reklamy społecznościowe i banery w różnych proporcjach obrazu." },
                    { name: "Stable Diffusion 3.5 dla plakatów i makiet", desc: "Tworzenie tła plakatów i gotowych wizualizacji w niestandardowych wymiarach pikseli." },
                    { name: "Stabilna dyfuzja 3.5 do portretów", desc: "Generuj szczegółowe portrety z naturalną teksturą skóry, używając negatywów, aby uniknąć artefaktów." },
                    { name: "Stabilna dyfuzja 3.5 do grafiki koncepcyjnej", desc: "Eksploruj postacie, otoczenie i wskazówki wizualne za pomocą warstwowych podpowiedzi." },
                    { name: "Stabilna dyfuzja 3.5 do treści społecznościowych", desc: "Twórz obrazy kwadratowe, pionowe i poziome dostosowane do różnych platform społecznościowych." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów AI Stable Diffusion 3.5 online",
                howToIntro: "Użyj generatora obrazów Stable Diffusion 3.5 AI online w Miral z przejrzystym komunikatem, negatywem i proporcjami obrazu wymaganymi przez Twój projekt.",
                howToSteps: [
                    { title: "Wprowadź swoją główną podpowiedź", desc: "Opisz pożądany obiekt, scenę, kompozycję, oświetlenie, styl i szczegóły wizualne." },
                    { title: "Konfiguruj sterowanie generacją", desc: "W razie potrzeby dodaj negatywną podpowiedź, a następnie wybierz gotowy współczynnik proporcji lub wprowadź niestandardowy rozmiar." },
                    { title: "Generuj i przeglądaj", desc: "Rozpocznij generowanie, przejrzyj wynik i pobierz obraz lub dostosuj podpowiedź do kolejnego etapu." }
                ],
                howToCta: "Wypróbuj generator obrazów AI Stable Diffusion 3.5",
                faqTitle: "Często zadawane pytania dotyczące Stable Diffusion 3.5",
                faqs: [
                    { q: "Czym jest generator obrazów Stable Diffusion 3.5 AI?", a: "Stable Diffusion 3.5 to model przekształcający tekst w obraz od Stability AI. Generator obrazów Stable Diffusion 3.5 AI przekształca polecenia tekstowe w szczegółowe obrazy i jest dostępny w Miral do tworzenia grafiki, projektów, materiałów marketingowych i wizualizacji produktów bezpośrednio w przeglądarce." },
                    { q: "Jakiego narzędzia mogę użyć do utworzenia obrazów o niestandardowym rozmiarze z negatywami?", a: "Stable Diffusion 3.5 oferuje dedykowany negatyw, gotowe proporcje obrazu i niestandardowe rozmiary od 512 do 2048 dla fotografii produktowej, wizualizacji marketingowych, portretów i grafik koncepcyjnych." },
                    { q: "Czy mogę bezpłatnie korzystać z generatora obrazów Stable Diffusion 3.5 AI?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów Stable Diffusion 3.5 AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów Stable Diffusion 3.5 AI online?", a: "Wprowadź szczegółowy tekst monitu, opcjonalnie dodaj negatywny monit opisujący, czego unikać, wybierz gotowy współczynnik proporcji lub wprowadź niestandardowy rozmiar i kliknij „Generuj”. Stable Diffusion 3.5 dobrze sprawdza się w materiałach marketingowych, fotografii produktów, portretach i układach plakatów." },
                    { q: "Jak naprawić niechciane lub zdeformowane szczegóły na obrazach Stable Diffusion 3.5?", a: "Dodaj negatyw opisujący elementy, których nie chcesz, takie jak niska przejrzystość, zdeformowane dłonie lub chaotyczne tło. Stable Diffusion 3.5 wykorzystuje go, aby odciągnąć generację od tych rezultatów." },
                    { q: "Jakie rozmiary i proporcje obrazu obsługuje Stable Diffusion 3.5?", a: "W systemie Miral, Stable Diffusion 3.5 oferuje gotowe proporcje, takie jak 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 i 1536×1536, a także niestandardowy rozmiar od 512×512 do 2048×2048 (wielokrotność 64). Obejmuje to orientację poziomą, pionową i kwadratową dla banerów, plakatów, postów w mediach społecznościowych i miniatur." },
                    { q: "Jakie są najlepsze przykłady podpowiedzi do stabilnej dyfuzji 3.5?", a: "Polecenia „Efektywnej, stabilnej dyfuzji” 3.5 jasno opisują temat, scenerię, kompozycję, oświetlenie i styl, a następnie łączą pozytywne z negatywnym, aby usunąć niepożądane szczegóły. Wykorzystaj przykłady poleceń „Stabilnej dyfuzji” 3.5 na tej stronie jako punkt wyjścia i dostosuj je do swojego projektu." },
                    { q: "Stable Diffusion 3.5 vs Midjourney: którego powinienem użyć?", a: "Wybierz na podstawie przepływu pracy, a nie uniwersalnego zwycięzcy. Stable Diffusion 3.5 to idealne rozwiązanie, gdy potrzebujesz wyraźnych negatywów, gotowych proporcji obrazu i niestandardowych rozmiarów pikseli w generatorze opartym na przeglądarce w systemie Miral. Midjourney może odpowiadać twórcom, którzy preferują jego charakterystyczny, artystyczny przepływ pracy i narzędzia społecznościowe." }
                ],
                ctaTitle: "Wypróbuj Stable Diffusion 3.5 za darmo na Miral!",
                ctaDesc: "Wpisz powyżej swój pomysł i użyj generatora obrazów Stable Diffusion 3.5 AI z negatywnymi podpowiedziami i elastycznymi rozmiarami, aby tworzyć kontrolowane wizualizacje."
            },
            zImageTurbo: {
                title: "Z Image Turbo AI Generator obrazów za darmo online | Miral",
                description: "Twórz wysokiej jakości obrazy AI online dzięki Z Image Turbo. Rozszerzaj podpowiedzi, wybieraj elastyczne proporcje obrazu, ustawiaj niestandardowe wymiary i kontroluj zarodki w Miral.",
                heroHeadline: "Generator obrazów AI Z Image Turbo",
                heroIntro: "Użyj generatora obrazów Z Image Turbo AI za darmo w Miral AI. Zarejestruj się, aby otrzymać darmowe punkty i szybko tworzyć wysokiej jakości obrazy z rozszerzeniem zachęty, elastycznymi proporcjami obrazu i kontrolą zarodków.",
                eyebrow: "Z Image Turbo",
                sectionKicker: "Z Image Turbo",
                ctaTag: "Z Image Turbo · Miral",
                badges: ["Tekst do obrazu", "Rozszerzenie komunikatu", "Elastyczne proporcje obrazu", "Rozmiar niestandardowy", "Kontrola nasion"],
                previewLabel: "Z Image Turbo",
                previewMeta: ["1:1", "512 – 2048", "Kontrola nasion"],
                previewTitle: "Od krótkiego komunikatu do dopracowanego obrazu o wysokiej rozdzielczości",
                previewDesc: "Pozwól, aby szybkie rozszerzenie wzbogaciło krótki pomysł, wybierz odpowiedni format obrazu i ponownie wykorzystaj ziarno, aby zachować spójny styl wszystkich zdjęć.",
                keyFeaturesTitle: "Twórz dopracowane wizualizacje dzięki generatorowi tekstu na obraz w Z Image Turbo",
                keyFeaturesIntro: "Poznaj kluczowe funkcje generatora obrazów Z Image Turbo AI, które umożliwiają tworzenie podpowiedzi w sposób rozszerzony, elastyczne proporcje obrazu, niestandardowe rozmiary i spójność opartą na ziarnach.",
                exploreTitle: "Odkryj więcej modeli obrazów AI",
                mainFeaturesTitle: "Kluczowe funkcje Z Image Turbo",
                generatedImageLabel: "Wygenerowany obraz",
                versionLabel: "Kontrola",
                featureLabel: "Co zmienia",
                useCaseLabel: "Najlepsza Dla",
                variantsTitle: "Elementy sterujące Z Image Turbo Creation",
                variantsIntro: "Połącz szybkie rozszerzanie, elastyczne wymiary i kontrolę nad materiałem źródłowym, w zależności od poziomu szczegółowości i spójności wizualnej, jakich potrzebuje Twój projekt.",
                variants: [
                    { name: "Z Image Turbo", desc: "Szybkie generowanie tekstu na obraz z dokładnym wydrukiem o wysokiej rozdzielczości.", bestFor: "Wizualizacje produktów, portrety, grafiki koncepcyjne i obrazy marketingowe." },
                    { name: "Rozszerzenie komunikatu", desc: "Automatycznie wzbogaca krótkie komunikaty o dodatkowe szczegóły wizualne.", bestFor: "Przekształcanie szybkich pomysłów w bardziej kompletne instrukcje generowania." },
                    { name: "Kontrola nasion", desc: "Ponownie wykorzystuje ten sam początkowy element podczas udoskonalania innych ustawień.", bestFor: "Zachowanie spójnego stylu we wszystkich wariantach obrazów lub kampaniach." }
                ],
                controlsTitle: "Wybierz odpowiednie ustawienia monitu, rozmiaru i zarodka",
                controlsIntro: "Włącz rozszerzenie podpowiedzi, gdy pomysł wymaga więcej szczegółów, wybierz docelowe wymiary wyjściowe i ponownie wykorzystaj źródło, gdy liczy się spójność wizualna.",
                galleryTitle: "Więcej przykładów obrazów Z Image Turbo",
                discussionTitle: "Często zadawane pytania dotyczące Z Image Turbo",
                communityTitle: "Popularne sposoby tworzenia z Z Image Turbo",
                tutorialPrompt: "Kompaktowy skuter elektryczny zaprezentowany w jasnym studiu architektonicznym, jasna betonowa podłoga, delikatne świetliki, wyrafinowane zdjęcia produktu, zrównoważona kompozycja, realistyczne materiały.",
                qualityBenefits: [
                    "Rozwijaj krótkie pomysły w bogatsze podpowiedzi bez ręcznego przepisywania każdego szczegółu wizualnego.",
                    "Wybierz orientację poziomą, pionową, kwadratową lub precyzyjne wymiary niestandardowe dla ostatniego kanału.",
                    "Ponownie wykorzystaj ziarno, aby zachować spójność oświetlenia, palety barw i kompozycji w kolejnych iteracjach."
                ],
                features: [
                    { name: "Rozszerzenie komunikatu", short: "Opcjonalnie rozszerz krótki komunikat, dodając więcej szczegółów.", desc: "Włącz rozszerzenie podpowiedzi, a Z Image Turbo automatycznie wzbogaci krótką podpowiedź o dodatkowe szczegóły przed jej wygenerowaniem. Dzięki temu krótkie lub proste podpowiedzi tworzą pełniejsze, bardziej żywe obrazy bez konieczności ręcznego przepisywania.", demo: { type: 'table', rows: [
                        { prompt: "Szklana szklarnia wypełniona tropikalnymi roślinami na powierzchni Marsa.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Mała piekarnia rzemieślnicza zbudowana w zabytkowym wagonie kolejowym.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Elastyczne proporcje obrazu", short: "Wybierz format poziomy, pionowy, kwadratowy lub niestandardowy.", desc: "Wybierz spośród gotowych proporcji obrazu, takich jak 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 i 1536×1536, lub wprowadź niestandardowy rozmiar od 512×512 do 2048×2048. Dzięki temu generator tekstu na obraz Z Image Turbo nadaje się zarówno do banerów, plakatów, postów w mediach społecznościowych, jak i kwadratowych miniatur.", prompt: "Ultraszeroki widok z lotu ptaka na nocny targ w Tokio w deszczu, świecące papierowe lampiony, zatłoczone stragany z jedzeniem, odblaskowe ulice, kinowa atmosfera, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Niestandardowe rozmiary obrazu", short: "Ustaw dokładne wymiary pikseli, aby uzyskać precyzyjny wynik.", desc: "Jeśli predefiniowane ustawienie nie pasuje, zmień rozmiar na niestandardowy i wprowadź dowolną szerokość i wysokość od 512 do 2048. Pozwoli to dopasować konkretny układ, miejsce na baner lub aspekt wydruku bez ręcznego kadrowania.", prompt: "Pionowy plakat wystawy botanicznej, powiększona pomarańczowa typografia, rzadkie tropikalne liście, ciepła, kremowa faktura papieru, precyzyjna siatka redakcyjna, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Kontrola nasion dla spójności", short: "Ponowne użycie ziarna, aby zachować stabilny styl we wszystkich obrazach.", desc: "Ustaw stałą wartość początkową (od 0 do 2147483647), a generator obrazów Z Image Turbo AI będzie bazował na tym samym punkcie początkowym w kolejnych edycjach, co ułatwi zachowanie spójnego wyglądu podczas dopracowywania komunikatu. Pozostaw wartość początkową na 0, aby za każdym razem uzyskać nowy, losowy wynik.", prompt: "Skoordynowana kampania pielęgnacyjna z trzema matowymi szklanymi butelkami na jasnozielonym kamieniu, miękkim, rozproszonym światłem, akcentami eukaliptusa – wykorzystaj to samo ziarno, aby zachować oświetlenie, paletę barw i kompozycję w całej serii produktów.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Dopracowany detal i realizm", short: "Tworzenie wiarygodnego oświetlenia, materiałów i głębi.", desc: "Z Image Turbo generuje drobne tekstury, realistyczne oświetlenie i naturalną głębię, dzięki czemu doskonale nadaje się do fotografii produktowej, portretów, grafik koncepcyjnych i materiałów redakcyjnych, gdzie liczy się wiarygodność.", prompt: "Dokumentalne zbliżenie lutnika rzeźbiącego mostek z klonu w cichym warsztacie, drobne wióry drewniane, zużyte narzędzia ręczne, naturalna faktura skóry, miękkie światło padające od północnego okna, mała głębia ostrości.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady komunikatów Z Image Turbo dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi Z Image Turbo jako punktu wyjścia. Jasno opisz temat, kompozycję, oświetlenie i styl, opcjonalnie włącz rozszerzenie podpowiedzi, a następnie wyślij je bezpośrednio do generatora.",
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo do fotografii produktowej", desc: "Twórz czyste zdjęcia produktów z kontrolowanym tłem i stałym elementem referencyjnym, aby uzyskać spójny wygląd." },
                    { name: "Z Image Turbo dla marketingu", desc: "Twórz koncepcje kampanii, reklamy społecznościowe i banery w różnych proporcjach obrazu." },
                    { name: "Z Image Turbo dla plakatów i makiet", desc: "Tworzenie tła plakatów i gotowych wizualizacji w niestandardowych wymiarach pikseli." },
                    { name: "Z Image Turbo do portretów", desc: "Twórz szczegółowe portrety z naturalną fakturą skóry i wiarygodnym oświetleniem." },
                    { name: "Z Image Turbo do grafiki koncepcyjnej", desc: "Eksploruj postacie, otoczenie i wskazówki wizualne za pomocą warstwowych podpowiedzi." },
                    { name: "Z Image Turbo dla treści społecznościowych", desc: "Twórz obrazy kwadratowe, pionowe i poziome dostosowane do różnych platform społecznościowych." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów Z Image Turbo AI online",
                howToIntro: "Użyj generatora obrazów Z Image Turbo AI online w Miral z przejrzystym komunikatem, opcjonalnym rozszerzeniem komunikatu i proporcjami obrazu wymaganymi przez Twój projekt.",
                howToSteps: [
                    { title: "Wprowadź swoją główną podpowiedź", desc: "Opisz pożądany obiekt, scenę, kompozycję, oświetlenie, styl i szczegóły wizualne." },
                    { title: "Konfiguruj sterowanie generacją", desc: "Opcjonalnie włącz rozszerzenie promptu, wybierz gotowy format obrazu lub wprowadź niestandardowy rozmiar i ustaw wartość zerową, jeśli chcesz zachować spójność." },
                    { title: "Generuj i przeglądaj", desc: "Rozpocznij generowanie, przejrzyj wynik i pobierz obraz lub dostosuj podpowiedź do kolejnego etapu." }
                ],
                howToCta: "Wypróbuj generator obrazów AI Z Image Turbo",
                faqTitle: "Często zadawane pytania dotyczące Z Image Turbo",
                faqs: [
                    { q: "Czym jest generator obrazów Z Image Turbo AI?", a: "Z Image Turbo to model przekształcający tekst w obraz do generowania obrazów o wysokiej rozdzielczości. Generator obrazów Z Image Turbo AI przekształca tekstowe komunikaty w szczegółowe obrazy i jest dostępny w serwisie Miral do tworzenia grafiki, projektowania, marketingu i wizualizacji produktów bezpośrednio w przeglądarce." },
                    { q: "Jakiego narzędzia mogę użyć do stworzenia spójnej serii zdjęć produktów?", a: "Z Image Turbo łączy szybkie rozszerzanie, elastyczne rozmiary obrazów i kontrolę nad materiałem źródłowym, pomagając w tworzeniu spójnej serii fotografii produktów lub materiałów marketingowych." },
                    { q: "Czy mogę korzystać z generatora obrazów Z Image Turbo AI za darmo?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów Z Image Turbo AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów Z Image Turbo AI online?", a: "Wprowadź szczegółowy podpowiedź tekstową, opcjonalnie włącz rozszerzenie podpowiedzi, wybierz gotowy współczynnik proporcji lub wprowadź niestandardowy rozmiar, ustaw wartość początkową, jeśli chcesz uzyskać spójny wygląd, i kliknij Generuj. Z Image Turbo sprawdza się w przypadku materiałów marketingowych, fotografii produktów, portretów i układów plakatów." },
                    { q: "Czym jest rozszerzenie promptu w Z Image Turbo?", a: "Rozszerzenie podpowiedzi to opcjonalny przełącznik, który pozwala Z Image Turbo automatycznie wzbogacić krótkie lub proste podpowiedzi o dodatkowe szczegóły przed wygenerowaniem. Dzięki temu podpowiedzi dla osób niebędących ekspertami tworzą pełniejsze, bardziej żywe obrazy bez ręcznego przepisywania." },
                    { q: "Jak naprawić niespójne wyniki w Z Image Turbo?", a: "Używaj tego samego ziarna, dopracowując inne parametry, aby zachować spójny styl wszystkich obrazów. Pozostaw ziarno na 0 tylko wtedy, gdy chcesz uzyskać świeży, losowy wynik za każdym razem." },
                    { q: "Jakie rozmiary i proporcje obrazu obsługuje Z Image Turbo?", a: "W systemie Miral, Z Image Turbo oferuje gotowe formaty, takie jak 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 i 1536×1536, a także rozmiar niestandardowy od 512×512 do 2048×2048. Obejmuje to formaty poziome, pionowe i kwadratowe dla banerów, plakatów, postów w mediach społecznościowych i miniatur." },
                    { q: "Jakie są najlepsze przykłady komunikatów Z Image Turbo?", a: "Efektywne podpowiedzi Z Image Turbo jasno opisują temat, scenerię, kompozycję, oświetlenie i styl. W przypadku krótkich pomysłów włącz rozszerzenie podpowiedzi, aby model mógł automatycznie wzbogacić podpowiedź. Użyj przykładów podpowiedzi Z Image Turbo na tej stronie jako punktu wyjścia i dostosuj je do swojego projektu." }
                ],
                ctaTitle: "Wypróbuj Z Image Turbo za darmo na Miral!",
                ctaDesc: "Wprowadź powyżej swój pomysł i użyj generatora obrazów Z Image Turbo AI z rozszerzeniem podpowiedzi, elastycznymi rozmiarami i kontrolą ziarna, aby tworzyć dopracowane wizualizacje."
            },
            midjourney: {
                title: "Darmowy generator obrazów AI Midjourney online | Miral",
                description: "Twórz grafikę AI online z Midjourney na Miral AI. Wybierz styl realistyczny lub anime, pomóż w wynikach za pomocą obrazów referencyjnych i zmień podpowiedzi tekstowe w żywe wizualizacje.",
                heroHeadline: "Generator obrazów AI Midjourney",
                heroIntro: "Skorzystaj z darmowego generatora obrazów Midjourney AI w Miral AI. Zarejestruj się, aby otrzymać darmowe kredyty i natychmiast tworzyć wysokiej jakości obrazy w stylach Realistycznym lub Anime oraz z opcjonalnymi wskazówkami dotyczącymi obrazów referencyjnych.",
                eyebrow: "Środek podróży",
                sectionKicker: "Środek podróży",
                ctaTag: "Midjourney · Miral",
                badges: ["Tekst do obrazu", "Style realistyczne i anime", "Wskazówki dotyczące obrazu referencyjnego", "Kierownictwo artystyczne"],
                previewLabel: "Środek podróży",
                previewMeta: ["Realistyczny", "Anime", "Do 5 odniesień"],
                previewTitle: "Od żywego polecenia do kinowego, artystycznego obrazu",
                previewDesc: "Wybierz styl, opisz nastrój i oświetlenie, a Midjourney ukształtuje artystyczny wygląd Twojej koncepcji, plakatu lub postaci.",
                keyFeaturesTitle: "Twórz wizualizacje z aranżacją artystyczną dzięki generatorowi tekstu na obraz Midjourney",
                keyFeaturesIntro: "Poznaj kluczowe funkcje generatora obrazów Midjourney AI, takie jak przełączanie stylów, wskazówki dotyczące obrazów referencyjnych i bogate opracowanie artystyczne.",
                features: [
                    { name: "Style realistyczne i anime", short: "Przełączaj styl wizualny jednym dotknięciem.", desc: "Generator obrazów AI Midjourney w Miral udostępnia dwa gotowe style — Realistyczny i Anime. Wybierz Realistyczny, aby uzyskać fotograficzną szczegółowość, naturalne światło i realistyczne tekstury, lub Anime, aby uzyskać stylizowane linie, wyraziste kolory i wrażenie rysowania odręcznego. Styl wybiera się na panelu, dzięki czemu podpowiedź może skupić się na samej scenie.", demo: { type: 'table', rows: [
                        { prompt: "Samotny wędrowiec stojący na skraju mglistego grzbietu górskiego o wschodzie słońca, światło wolumetryczne, kinowe ujęcie szerokokątne, subtelne detale tkaniny i skał.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Zdeterminowana młoda szermierka na dachu o zmierzchu, rozwiane włosy, świecące latarnie, ekspresyjne, anime'owe kreski, żywe cienie cel-shading.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Wskazówki dotyczące obrazu referencyjnego", short: "Prześlij maksymalnie pięć obrazów, aby sterować wyglądem.", desc: "Wykorzystaj generator obrazów Midjourney AI z maksymalnie pięcioma obrazami referencyjnymi (PNG, JPG, JPEG lub WebP). Użyj ich, aby przenieść paletę kolorów, wygląd postaci, kształt produktu lub ogólną estetykę, dzięki czemu rezultat będzie bliższy wskazówkom referencyjnym, a nie tylko tekstowi.", prompt: "Zdjęcie produktu premium przedstawiające matowy, czarny ceramiczny wazon na marmurowym cokole, miękkie światło studyjne, czyste tło, pasujące do nastroju i palety barw przesłanych materiałów referencyjnych.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Oświetlenie kinowe i nastrój", short: "Utwórz dramatyczne światło, atmosferę i głębię.", desc: "Midjourney jest znane z oświetlenia i atmosfery sterowanej artystycznie. Opisz złotą godzinę, blask neonu, mgłę, światło kontrowe lub światło świec, a model nabierze kinowego charakteru, który pasuje do plakatów, grafiki kluczowej i wizualizacji koncepcyjnych.", demo: { type: 'table', rows: [
                        { prompt: "Nocna, deszczowa alejka neonowa, odbijające światło kałuże, miękki bokeh odległych znaków, nastrojowa, kinowa atmosfera, pojedyncza postać z parasolem.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Portret muzyka na dachu o złotej godzinie, ciepłe podświetlenie, flara obiektywu, mała głębia ostrości, ziarnistość filmu.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Postać i grafika koncepcyjna", short: "Twórz wyraziste postacie i światy.", desc: "Generator tekstu na obraz Midjourney doskonale sprawdza się w projektowaniu postaci, scenach fantasy i grafikach koncepcyjnych. Opisz pozę, strój, wyraz twarzy i scenerię postaci, wybierz styl i iteruj, aż uzyskasz pożądany efekt.", prompt: "Wędrowny alchemik w wielowarstwowym płaszczu podróżnym, niosący mosiężną latarnię i świecące fiolki, ścieżka w starożytnym lesie, rozproszone światło, misterne detale kostiumu.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Plakaty i grafika redakcyjna", short: "Twórz przyciągające wzrok układy i kluczowe materiały wizualne.", desc: "Od kluczowych materiałów graficznych kampanii po ilustracje redakcyjne, Midjourney tworzy śmiałe kompozycje i dopracowaną estetykę. Połącz wyraźny temat główny z określonym nastrojem i pozwól modelowi/modelce tworzyć wizualizacje do celów marketingowych i redakcyjnych, dostosowane do potrzeb artystycznych.", prompt: "Odważny, kluczowy element wizualny kampanii przedstawiający kolibra unoszącego się nad świecącym tropikalnym kwiatem, nasycone barwy klejnotów, czysta przestrzeń negatywna, kontrastowe oświetlenie studyjne.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Przykładowe instrukcje",
                showcaseTitle: "Przykłady podpowiedzi do Midjourney dla lepszych obrazów AI",
                showcaseIntro: "Użyj tych przykładów podpowiedzi Midjourney jako punktu wyjścia. Opisz temat, nastrój, oświetlenie i styl sceny, a następnie wybierz opcję Realistyczny lub Anime na panelu i prześlij obraz do generatora.",
                useCasesKicker: "Stworzone do rzeczywistej pracy",
                useCasesTitle: "Popularne przypadki użycia w Midjourney",
                useCases: [
                    { name: "Środek do grafiki koncepcyjnej", desc: "Twórz postacie, światy fantasy i wizualizacje z aranżacją artystyczną oświetlenia i nastroju." },
                    { name: "Połowa drogi do kluczowych grafik i plakatów", desc: "Twórz wyraziste, kluczowe wizualizacje kampanii, plakaty i ilustracje redakcyjne o dopracowanym wyglądzie." },
                    { name: "Połowa drogi do wizualizacji produktów i marek", desc: "Kształtuj koncepcje produktów premium i wizerunek marki, korzystając ze zdjęć referencyjnych, aby zapewnić spójność." },
                    { name: "Środek do portretów", desc: "Generuj kinowe portrety z naturalnym oświetleniem, ziarnistością filmu lub stylizowanym cieniowaniem anime." },
                    { name: "Środek podróży po anime i ilustrację", desc: "Przełącz się na styl Anime, aby uzyskać wyrazistą kreskę, wyraziste kolory i ręcznie rysowane postacie." },
                    { name: "Środek do treści społecznościowych", desc: "Twórz efektowne, łatwe do udostępniania materiały wizualne do kanałów, miniatur i kreatywnych postów w mediach społecznościowych." }
                ],
                howToKicker: "Trzy proste Kroki",
                howToTitle: "Jak korzystać z generatora obrazów AI Midjourney online",
                howToIntro: "Użyj generatora obrazów Midjourney AI online w Miral z żywym podpowiedzią, wybranym stylem i opcjonalnymi obrazami referencyjnymi.",
                howToSteps: [
                    { title: "Opisz swoją scenę", desc: "Napisz wyrazisty motyw, obejmujący temat, scenerię, nastrój, oświetlenie i pożądany efekt artystyczny." },
                    { title: "Wybierz styl i odniesienia", desc: "Wybierz opcję Realistyczny lub Anime na panelu i opcjonalnie prześlij do pięciu obrazów referencyjnych, aby pomóc w wyborze wyglądu." },
                    { title: "Generuj i udoskonalaj", desc: "Rozpocznij generowanie, przejrzyj wynik i pobierz obraz lub dostosuj motyw i odniesienia do kolejnego podejścia." }
                ],
                howToCta: "Wypróbuj generator obrazów AI Midjourney",
                faqTitle: "Często zadawane pytania dotyczące Midjourney",
                faqs: [
                    { q: "Czym jest generator obrazów Midjourney AI?", a: "Midjourney to powszechnie używany model przetwarzania tekstu na obraz, znany z dopracowanych artystycznie, kinowych wizualizacji. W systemie Miral, generator obrazów Midjourney AI przekształca pisemne podpowiedzi w efektowne obrazy do grafik koncepcyjnych, kluczowych wizualizacji, plakatów i prac redakcyjnych bezpośrednio w przeglądarce." },
                    { q: "Jakiego narzędzia mogę użyć do tworzenia kinowych grafik koncepcyjnych z obrazami referencyjnymi?", a: "Midjourney łączy bogatą reżyserię artystyczną, dramatyczne oświetlenie, style realistyczne i anime oraz referencyjne wskazówki dotyczące obrazów koncepcyjnych, kluczowych elementów wizualnych i wizerunku marki." },
                    { q: "Czy mogę korzystać z generatora obrazów Midjourney AI za darmo?", a: "Tak. Zarejestruj się, aby otrzymać darmowe punkty i natychmiast rozpocząć tworzenie wysokiej jakości obrazów za pomocą generatora obrazów Midjourney AI. Generowanie obrazów wykorzystuje odpowiednie punkty." },
                    { q: "Jak korzystać z generatora obrazów Midjourney AI online?", a: "Wprowadź żywy tekst opisujący temat, nastrój, oświetlenie i styl, wybierz opcję Realistyczny lub Anime w panelu, opcjonalnie prześlij do pięciu obrazów referencyjnych i kliknij Generuj. Midjourney sprawdza się w przypadku grafik koncepcyjnych, kluczowych wizualizacji, plakatów, portretów i ilustracji redakcyjnych." },
                    { q: "Jaka jest różnica między stylem realistycznym a anime?", a: "Styl realistyczny skłania się ku fotograficznemu detalowi, naturalnemu oświetleniu i realistycznym fakturom, podczas gdy styl anime preferuje stylizowane linie, wyraziste kolory i ręcznie rysowany wygląd. Styl wybierasz na panelu, dzięki czemu podpowiedź może skupić się na samej scenie." },
                    { q: "Jak naprawić obrazy Midjourney, które nie pasują do mojego pliku referencyjnego?", a: "Prześlij maksymalnie pięć czytelnych obrazów referencyjnych (PNG, JPG, JPEG lub WebP) i opisz, jakiej palecie kolorów, wyglądowi postaci, kształtowi produktu lub ogólnej estetyce ma odpowiadać wynik." },
                    { q: "Jakie są najlepsze przykłady podpowiedzi do Midjourney?", a: "Polecenia „Efektywnej, środkowej drogi” szczegółowo opisują temat, scenerię, nastrój, oświetlenie i efekt artystyczny, a następnie dopasuj te polecenia do odpowiedniego stylu na panelu. Wykorzystaj przykłady poleceń „Środkowej drogi” na tej stronie jako punkt wyjścia i dostosuj je do swojego projektu." },
                    { q: "Midjourney kontra Stable Diffusion 3.5: którego powinienem użyć?", a: "Wybierz na podstawie przepływu pracy, a nie uniwersalnego zwycięzcy. Midjourney doskonale nadaje się do koncepcji artystycznych, kinowego oświetlenia i wizualizacji opartych na referencjach, z gotowymi stylami Realistycznym i Anime w Miral. Stable Diffusion 3.5 może być odpowiedni dla twórców, którzy potrzebują wyraźnych negatywów i elastycznych proporcji obrazu z niestandardowymi rozmiarami." }
                ],
                ctaTitle: "Wypróbuj Midjourney za darmo na Miral!",
                ctaDesc: "Wprowadź powyżej swój pomysł i użyj generatora obrazów Midjourney AI ze stylami realistycznymi lub anime oraz wskazówkami dotyczącymi obrazów referencyjnych, aby tworzyć wizualizacje z elementami artystycznymi."
            }
        }
    }
}
